import Vue from "vue";
import { MLCreate, MLInstaller, MLanguage } from "vue-multilanguage";

Vue.use(MLInstaller);

// Atenção - utilizar craze (`) para delimitar as strings e sempre colocar uma virgula no final da linha!
//         - não utilizar variáveis em multiplas linhas!

export default new MLCreate({
    initial: "portuguese", 
    save: true, 
    languages: [ 

        new MLanguage("portuguese").create({ 
            ln: "br",
            //translation_script_start_pt
            agreementText: `Você concorda com os termos do contrato de confidencialidade?`, 
            agree: `Concordo`, 
            doNotAgree: `Não Concordo`, 
            programWithNda: `Este programa possui um NDA vinculado!`, 
            ndaAccepted: `NDA aceito!`, 
            programWithoutNda: `Este programa ainda não possui um NDA vinculado!`, 
            menuProgram: `Programas`, 
            menuReport: `Relatórios`, 
            menuAccount: `Minha conta`, 
            navInvitations: `Convites`, 
            navPayments: `Pagamentos`, 
            navCreateNda: `Criar um Modelo NDA`, 
            navEditNda: `Editar NDA`, 
            navPrograms: `Programas`, 
            navPublished: `Publicados`, 
            navClosed: `Inativos`, 
            navNda: `NDAs`, 
            navAll: `Todos`, 
            navPending: `Pendente`, 
            navRetest: `Reteste`, 
            dashTitle: `Bem vindo {0}!`, 
            dashSubTitle: `Uma visão geral e acesso rápido da sua conta só para você`, 
            dashReportResolv: `Relatórios aprovados`, 
            navAverage: `Média de Recompensas`, 
            dashMsgYouHave: `Você possui`, 
            dashMsgYouDHave: `Você não possui`, 
            msgProgramPu: `programas publicos!`, 
            msgProgramPr: `programas privados!`, 
            dashMsgGP: `Gerenciar seus programas.`, 
            dashMsgCP: `Cadastrar um programa agora?`, 
            dashInvTitle: `Convide Especialistas!`, 
            dashInvSubTitle: `Faça o convite à especialistas para participar dos seus programas.`, 
            dashPayTitle: `Pagamentos!`, 
            dashPaySubTitle: `Resumo financeiro e solicitações de pagamentos.`, 
            dashNdaTitle: `Contratos de Confidencialidade!`, 
            dashNdaSubTitle: `Gerencie os contratos de confidencialidade dos seus programas.`, 
            dashCreatNdaTitle: `Modelo Padrão de NDA!`, 
            dashCreatNdaSubTitle: `Crie um modelo padrão para gerenciar os contratos de confidencialidade dos seus programas.`, 
            dashCreatNdaAbriefsummary: `Um breve sumário pra o especialista entender do que se trata ...`, 
            dashCreatNdaDesc: `NDA é uma sigla em inglês para Non-Disclosure-Agreements, ou simplesmente acordo de sigilo de informações. Ele tem a intenção de proteger segredos industriais, comerciais, ou ainda qualquer informação que não pode ser divulgada e deve manter-se em sigilo entre aqueles que têm acesso a ela.`, 
            dashCreatNdaWriteTerms: `Redija os termos do seu contrato de confidencialidade e suas peculiaridades.`, 
            dashCreatNdawritePaste: `Vamos começar, redija ou cole os seus termos!`, 
            dashCreatNdaWantAttach: `Quer anexar um documento à ser assinado?`, 
            progTitle: `Visão Geral!`, 
            progSubTitle: `Acompanhe e gerencie seus programas na BugHunt.`, 
            progPubTitle: `Programas Publicados!`, 
            progPubSubTitle: `Gerencie seus programas publicados! Acompanhe todos os detalhes.`, 
            progCampTitle: `Campanhas`, 
            progClosTitle: `Programas Inativos!`, 
            progClosSubTitle: `Bateu saudade? Veja os dados dos programas inativos.`, 
            progCreateTitle: `Criar um Programa`, 
            progCreateSubTitle: `Momento emocionante, hora de começar a criar o seu programa!`, 
            progRankTitle: `Ranking de Contribuições!`, 
            progRankSubTitle: `Veja quem mais contribui com seus programas.`, 
            progRankSendThank: `Envie um Agradecimento!`, 
            progRankBtnSendThank: `Enviar Agradecimento`, 
            progTimelineTitle: `Programas Timeline!`, 
            progTimelineSubTitle: `Acompanhe a timeline dos seus programas`, 
            repTitle: `Relatórios!`, 
            repSubTitle: `Gerencie os relatórios enviados por especialistas aos seus programas.`, 
            repSubTitleHacker: `Gerencie os relatórios enviados aos programas.`, 
            repDetMsgAlter: `Alterações feitas no relatório não podem ser desfeitas!`, 
            ccpTitle: `Vamos criar um programa ?`, 
            ccpProgPubli: `Programa Público`, 
            ccpProgPubliDesc: `Criar um programa onde todos os especialistas cadastrados podem ver e enviar relatórios!`, 
            ccpProgVDPDesc: `Criar um programa onde todos os especialistas podem ver e enviar relatórios!`, 
            ccpProgPriv: `Programa Privado`, 
            ccpProgPrivDesc: `Criar um programa onde somente os especialistas selecionados podem ver e enviar relatórios!`, 
            managedProgram: `Programa Gerenciado`, 
            protectedByNDA: `Protegido por um NDA`, 
            helpTitle: `Precisando de ajuda ?`, 
            helpProgram: `Como funciona um programa ?`, 
            helpDifference: `Qual a diferença entre privado e público ?`, 
            helpaverage: `Qual a média aplicada em um bounty ?`, 
            rankTitle: `Ranking de Contribuições`, 
            retest_confirmed: `Corrigido`, 
            retest_denied: `Falha persiste`, 
            accountSubTitle: `Uma visão geral e acesso rápido da sua conta só para você.`, 
            accountAcSubTitle: `Quem, quando e como acessaram sua conta`, 
            accountTerSubTitle: `Acesse nossos termos e política de privacidade`, 
            accountUserSubTitle: `Gerencie quem tem acesso a organização.`, 
            accountSettSubTitle: `Como deseja receber seus e-mails, política de privacidade e outros.`, 
            aboutUs: `Sobre nós`, 
            aboutYou: `Sobre você`, 
            aboutYourAccount: `Sobre sua conta`, 
            aboutTheProgramPolicy: `Sobre a política do programa!`, 
            add: `Adicionar`, 
            addUser: `Adicionar Usuário`, 
            addAcomment: `Adicione um comentário`, 
            addExpertToBlacklist: `Adicionar especialista à Blacklist`, 
            addTheScopesHere: `Adicione os escopos aqui!`, 
            addOutOfScopesHere: `Adicione aqui as aplicações que devem ser evitadas durante os testes de segurança!`, 
            addYourPayPalAccount: `Adicione sua conta do PayPal`, 
            adjustedTheImpactTo: `ajustou o impacto para`, 
            adjustedTheImpactFrom: `ajustou o impacto de`, 
            adjustMetrics: `Ajustar Métricas`, 
            allowedFiles: `Arquivos permitidos: vídeos, imagens e arquivos de texto .jpg .jpeg .png .txt .rar .zip .7z`, 
            alreadyHaveAccount: `Já possui uma conta?`, 
            accepted: `Aceito`, 
            acceptThisInvitation: `Aceitar este Convite!`, 
            access: `Acessos`, 
            accessControl: `Controle de Acesso`, 
            accessMyAccount: `Acessar minha conta!`, 
            accessProfile: `Perfil de Acesso`, 
            accessInformation: `Informações de Acesso`, 
            accountCreatedSuccessfully: `Conta criada com sucesso!`, 
            accountDeleted: `Conta deletada`, 
            accountRecovery: `Recuperação de conta`, 
            accurate: `Apurado`, 
            activate: `Ativar`, 
            activated: `Ativado`, 
            additionalServices: `Serviços Adicionais`, 
            addOtherRewardsHere: `Adicione outras recompensas aqui!`, 
            addToBlacklist: `Adicionar a Blacklist`, 
            agreementSpecialists: `Especialistas em acordo`, 
            ago: `há {0}`, 
            aGoodPolicAvoids: `Uma boa política evita problemas, caso tenha algum problema nos consulte.`, 
            all: `Todos`, 
            gatTagOptDescription: `Apenas relatórios quem contenham a tag GAT`, 
            gatTagDescription: `Quais relatórios serão enviados para a plataforma GAT?`, 
            allowMobileAccess: `Permitir acessos de celular`, 
            allowedToPayReward: `Tem permissão para pagar recompensas.`, 
            allThePrograms: `Todos os programas`, 
            allStatus: `Todos os Status`, 
            aLowercaseLetter: `Uma letra minúscula. `, 
            anEmailContainingPasswordReset: `Um email contendo instruções para o reset de senha foi enviado.`, 
            aNewValidationEmailHasBeenSenToYou: `Um novo e-mail de validação foi enviado para você, verique sua caixa postal`, 
            aNewSuperStrongPassword: `Uma nova senha super forte!`, 
            annotation: `Anotação`, 
            aNumber: `Um número. `, 
            anUppercaseLetter: `Uma letra maiúscula. `, 
            anyQuestionsAboutIntegration: `Dúvidas sobre essa integração?`, 
            application: `Aplicativo`, 
            applicableReport: `Relatório aplicável`, 
            approvedReports: `Relatórios aprovados`, 
            approveWithoutRetest: `Você deseja mesmo encerrar o relatório como aprovado antes de solicitar um reteste?`, 
            approveRetest: `Aprovar reteste`, 
            approvedRetest: `aprovou o reteste`, 
            areYouSureYouWantToDeleteThisUser: `Tem certeza de que deseja excluir este usuário ?`, 
            as: `como`, 
            aSuperStrongPasswordNow: `Uma senha super forte agora!`, 
            atBugHuntYouWillFindPrograms: `Na BugHunt você vai encontrar programas para testar diferentes tipos de tecnologias, coloque em prática seus conhecimentos, testando aplicações reais de forma ética e legalizada.`, 
            attention: `Atenção!`, 
            atLeastCharacters: `No mínimo 6 caracteres. `, 
            authentication: `Autenticação`, 
            averageTicket: `Ticket Médio`, 
            average_time_to_bounty: `Tempo médio para pagar recompensa`, 
            average_time_to_first_response: `Tempo médio para a primeira resposta`, 
            average_time_to_resolution: `Tempo médio para encerramento do relatório`, 
            averageTimeToBounty: `Tempo médio para pagamento`, 
            avgTimeToBounty: `O tempo médio decorrido desde a primeira interação da empresa com um relatório até a solicitação de pagamento de uma recompensa.`, 
            avgTimeToFirstResponse: `O tempo médio decorrido desde o envio do relatório até a primeira interação da empresa com um relatório.`, 
            avgTimeToResolution: `O tempo médio decorrido desde a abertura de um relatório até o seu encerramento.`, 
            awaitingAcceptance: `aguardando aceitação`, 
            awaitingPayment: `aguardando pagamento`, 
            paymentReceived: `recebeu o pagamento`, 
            awaitingResponse: `Aguardando Resposta`, 
            award: `Premiação`, 
            backupCodesLeft: `códigos de backup restantes`, 
            balance: `Saldo`, 
            basedLast90Day: `Baseado nos últimos 90 dias`, 
            beforeActivatingTwoFactorAuthentication: `Antes de ativar o Two-factor authentication é preciso validar o seu telefone.`, 
            beforeContinuingYouNeed: `Antes de continuar é preciso validar seu e-mail!`, 
            billingCreditCard: `Cartão de Crédito de faturamento`, 
            billingForms: `Formas de Faturamento`, 
            billingInformation: `Informações de Faturamento`, 
            byActivatingTheProgramSpecialistsWill: `Ao ativar o programa os especialistas poderão enviar novos relatórios!`, 
            byPausingTheProgramExpertsWill: `Ao pausar o programa os especialistas não poderão mais enviar novos relatórios!`, 
            bounty: `Financeira`, 
            bountyAwarded: `Recompensa concedida`, 
            bugBountyAndTheSecurityParadox: `Bug Bounty e o paradoxo da Segurança`, 
            bugHuntIsTheFirstBrazilianBugBounty: `<b>BugHunt</b> é a primeira plataforma brasileira de Bug Bounty, e agora está em parceria com a <b>AME Digital</b> com propósito de democratizar o acesso a segurança da informação e com isso tornar a Internet um lugar mais seguro.`, 
            ongoingProfileVerification: `Seu perfil está sendo verificado!`, 
            cancel: `Cancelar`, 
            cannotEnterEqualScopes: `Não é possível inserir escopos iguais`, 
            cannotEnterSpecialCharacters: `Não é possível inserir caracteres especiais`, 
            cautionNDA1: `Ao redigir o NDA da sua empresa certifique-se de que ele contemple os seguintes itens:`, 
            cautionNDA2: `conter ao menos uma cláusula com a penalidade, em caso de descumprimento;`, 
            cautionNDA3: `informar as partes que assumem aquele compromisso;`, 
            cautionNDA4: `conter prazo de validade;`, 
            cautionNDA5: `detalhar especificamente sobre o que se refere aquele NDA, pois informações genéricas e ambíguas descaracterizam o documento legal;`, 
            cautionNDA6: `utilizar a tag `, 
            cautionNDA7: `para se referir ao nome do especialista;`, 
            cautionNDA8: `O modelo de NDA abaixo é ilustrativo. Certifique-se de informar corretamente os dados da sua empresa ao redigir o contrato de confidencialidade `, 
            changeAccessPassword: `Alterar senha de acesso`, 
            changePassword: `Alterar Senha`, 
            changePermission: `Alterar permissão`, 
            changedReportSeverity: `Severidade do relatório alterada`, 
            changedReportStatus: `Situação do relatório alterada`, 
            changedTheStatusFrom: `alterou a situação de {f} para {l}`, 
            changedTheSituationTo: `alterou a situação para {0}`, 
            changedTheTitleOf: `alterou o título do relatório de {f} para {l}`, 
            changedTheTitleTo: `alterou o título do relatório para {0}`, 
            changedTheVisibilityOf: `alterou a visibilidade de {f} para {l}`, 
            changedTheVisibilityTo: `alterou a visibilidade para {0}`, 
            checkOutAllFieldsHighlightedInRed: `Confira todos os campos destacados em vermelho!`, 
            chooseANicknameYoursAlone: `Escolha um apelido para ser só seu!`, 
            city: `Cidade`, 
            clickHereToLearn: `Saiba mais.`, 
            clearData: `Limpar dados`, 
            clearlyDefine: `Defina claramente sua política do programa.`, 
            close: `Encerrar`, 
            closed: `Encerrado`, 
            closedAgo: `Encerrado {0} dias`, 
            closedIn: `Encerrado em`, 
            closedReport: `Relatório fechado`, 
            closedReports: `Relatórios encerrados`, 
            closedTheReportAs: `fechou o relatório como`, 
            reopenedTheReport: `reabriu o relatório`, 
            code: `Código`, 
            conclude: `Concluir`, 
            connectionDenied: `Conexão negada`, 
            connectionTime: `Tempo aproximado de conexão`, 
            connectionRefusedUserDisabled: `Conexão recusada, usuário desativado!`, 
            connectionsPerUser: `Conexões por usuário`, 
            contacts: `Contatos`, 
            company: `Empresa`, 
            completed: `Concluídos`, 
            confirm: `Confirmar!`, 
            confirmAccountRemoval: `Confirmar Remoção de Conta`, 
            confirmYourPassword: `Confirme sua senha!`, 
            token2fa: `Informe o token da autenticação de 2 fatores`, 
            confirmProgramChanges: `Descreva as alterações feitas no programa`, 
            congratulationsYourUsernameIsNowVerified: `Parabéns, agora seu usuário é verificado.`, 
            invalidEmail: `Email inválido, verifique e tente novamente.`, 
            continueReport: `Continuar Relatório`, 
            copiedId: `Id copiado`, 
            copyLink: `Copiar link`, 
            continue: `Continuar`, 
            creatAccountInvit: `Criou a conta pelo convite`, 
            createA: `Criar um`, 
            created: `Criado!`, 
            createMyAccount: `Criar minha conta!`, 
            critical: `Crítico`, 
            request_response: `Resposta`, 
            request_closure: `Encerramento`, 
            responseRequestReport: `solicitou uma resposta para este relatório.`, 
            reportClosureRequest: `solicitou encerramento deste relatório.`, 
            day: `dia`, 
            days: `dias`, 
            dateTime: `Data/Hora`, 
            declined: `Recusado`, 
            dataChanged: `Dados alterados!`, 
            dataWillBeRemovedWithPhoneValidation: `Os dados do 2fa serão removidos com a validação do telefone!`, 
            date: `Data`, 
            declineThisInvitation: `Recusar este Convite!`, 
            delimitDomains: `Delimite domínios, subdomínios, aplicativos e muito mais`, 
            delimitItems: `Delimite itens`, 
            deleteUser: `Excluir usuário`, 
            depositedAmount: `Total de Aportes`, 
            delimitationOfDomainsSubdomains: `Delimitação de domínios, subdomínios, aplicativos e outros`, 
            describeALittleMoreAboutTheImpact: `Descreva um pouco mais sobre o impacto!`, 
            describeChangesMadeInProgram: `Este resumo ficará disponível para todos os especialistas que participam deste programa!`, 
            describeClearlyHowTheVulnerabilityWorks: `Descreva claramente como funciona a vulnerabilidade.`, 
            describeInDetailTheImpactOfThisRepor: `Descreva em detalhes o impacto deste relatório.`, 
            describeThePerformedTests: `Descreva os testes realizados`, 
            describeTheTitleOfTheReport: `Descreva o título do relatório`, 
            describeTheScope: `Qual é a url da aplicação vulnerável?`, 
            description: `Descrição`, 
            descriptionSubmitReport: `##### 1. Resumo \n(adicionar resumo da vulnerabilidade)\n\n##### 2. Descrição\n(adicione mais detalhes sobre esta vulnerabilidade)\n 1. [adicionar etapa]\n\n##### 3. Passos para reproduzir\n(Adicione detalhes de como podemos reproduzir o problema)\n 1. [adicionar etapa]\n 2. [adicionar etapa]\n 3. [adicionar etapa]\n\n##### 4. Material de apoio / referências\n(por exemplo, capturas de tela, registros, etc.)\n 1. Liste qualquer material adicional\n `, 
            descriptionCannotContainSpecialCharacters: `A descrição não pode conter caracteres especiais`, 
            descriptionMustBeFromToCharacters: `A descrição deve ter de {f} a {l} caracteres.`, 
            describeEditsMade: `Descreva as edições feitas.`, 
            details: `Detalhes`, 
            directoryName: `Nome do Diretório`, 
            disable: `Desativar`, 
            domain: `Domínio`, 
            done: `Pago`, 
            doNotUseSpecialCharactersAndMalicious: `Não use caracteres especiais e payloads maliciosos no título, impacto e resumo, esses itens devem ser anexados como .zip, .rar ou .7z no final do relatório.`, 
            doNotUseSpecialCharacters: `Não envie payloads com possíveis códigos maliciosos, esses itens devem ser anexados como .zip, .rar ou .7z!`, 
            dontForgetToSaveYourChanges: `Não esqueça de salvar as alterações!`, 
            downloadTheReportPDF: `Download do Relatório em PDF`, 
            doYouHaveOrganizationAndDidYou: `Gostaria de proteger sua empresa?`, 
            doYouWantToRemoveThePhone: `Deseja remover o telefone ?`, 
            doyoureallyWanttoDeleteVacancy: `Deseja mesmo excluir esta vaga ?`, 
            doYouReallyWantToRemoveTwoFactor: `Deseja mesmo remover o Two-factor authentication ?`, 
            doYouReallyWantToRemoveThisAccount: `Deseja mesmo remover esta conta ?`, 
            doYouReallyWantToRemoveThis: `Deseja mesmo remover esta {0} ?`, 
            doYouWantToActivateTheProgram: `Deseja ativar o programa ?`, 
            doYouWantToContinue: `Deseja continuar com os campos já preenchidos ?`, 
            doYouWantDisableProgram: `Deseja desativar o programa ?`, 
            doYouWantToPauseTheProgram: `Deseja pausar o programa ?`, 
            doYouWantToAddVPNToYourNewProgram: `Você deseja adicionar VPN ao seu novo programa?`, 
            editProgram: `Editar Programa`, 
            editNda: `Editar NDA`, 
            eligible: `Elegível`, 
            efficiencyMetrics: `Métricas de eficiência`, 
            emailAlreadyRegistered: `E-mail já esta cadastrado`, 
            emailAlreadyValidatedNonExistent: `E-mail já validado ou expirado!`, 
            emailConfirmation: `Confirmação de e-mail`, 
            emailDoesNotAppearToBeValid: `O e-mail não parece ser válido`, 
            emailSuccessfullyValidated: `Email validado com sucesso!`, 
            enableTwoFactorAuthentication: `Habilitar autenticação de dois fatores`, 
            end: `Final`, 
            enterNewTags: `Digite novas tags separando as por virgula`, 
            enterPasswordConfirmation: `Digite a confirmação da senha`, 
            enterTheCode: `Digite o código`, 
            enterTheCodeReceivedBySms: `Informe o código recebido por sms`, 
            enterTheCompletePhone: `Informe o Telefone completo`, 
            enterTheDescriptionOfTheOrganization: `Informe a descrição da organização`, 
            enterTheEmail: `Informe o e-mail`, 
            enterTheNameOfTheOrganization: `Informe o nome da organização`, 
            enterThePassword: `Digite a senha`, 
            enterTheUsername: `Informe o username`, 
            enterTheScope: `Informe o escopo do programa!`, 
            enterUserName: `Informe o nome do usuário`, 
            enterYourEmail: `Informe seu e-mail`, 
            enterYourFullName: `Escreva seu nome completo`, 
            enterYourPayPalAccountEmail: `Informe o email da conta PayPal`, 
            enterYourPrimaryEmailAddress: `Informe seu e-mail primário!`, 
            enterYourUserPassword: `Informe sua senha de usuário`, 
            enterYourRewardDetails: `Digite os detalhes da recompensa!`, 
            evaluate_retest: `Avaliar reteste`, 
            evaluatedRetest: `Reteste avaliado`, 
            executiveSummary: `Sumário executivo da organização`, 
            exit: `Sair`, 
            expertSuccessfullCreated: `Especialista {0} criado com sucesso`, 
            export: `Exportar`, 
            exportLogs: `Exportar logs`, 
            exportInCsv: `Exportar em .csv`, 
            exportReports: `Exportar relatórios`, 
            externalLinkNotice: `Aviso de link externo`, 
            extract: `Extrato`, 
            extractedBy: `Extraido por`, 
            fillInTheDetailsBelowTo: `Preencha os detalhes abaixo para alterar sua senha.`, 
            fillInAllFieldHighlightedInRed: `Preencha todos os campos destacados em vermelho!`, 
            filterByTags: `Filtro por tags`, 
            findSecurityJobsOnOurDashboard: `BugHunt conectando a comunidade com as melhores empresas.`, 
            forgotYourPassword: `Esqueceu sua senha ?`, 
            forSecurityWeRequestYourPassword: `Por segurança solicitamos sua senha para esta operação.`, 
            forYourSecurityToPDF: `Para sua segurança é necessario adicionar uma senha ao PDF.`, 
            fullName: `Nome completo`, 
            generateNewCodes: `Gerar novos códigos`, 
            getAccessToExclusiveRewards: `Tenha acesso à recompensas exclusivas deste programa!`, 
            gift: `Brinde`, 
            giftsAndAcknowledgments: `Brindes e Agradecimentos`, 
            guests: `Convidados`, 
            hackerControl: `Controle de Hackers`, 
            haveYouRevised: `Revisou seu modelo? Então pronto!`, 
            haveYouReviewedYourReportNow: `Revisou seu relatório? Então pronto, vamos enviá-lo para análise!`, 
            here: `aqui`, 
            hereYouCanSetUpYourAccount: `Aqui você pode configurar a sua conta para receber suas recompensas.`, 
            high: `Alto`, 
            historic: `Histórico`, 
            features: `Funcionalidades`, 
            iAlreadyHaveAnSccount: `Eu já tenho conta!`, 
            iAlreadyRemembered: `Eu já lembrei!`, 
            iAgreeWithThe: `Eu concordo com os `, 
            ifYouDontReceiveIt: `Caso não receba, poderá tentar de novo em`, 
            ifYouNeedToSubmitMoreComment: `Se precisar enviar mais, é só escrever outro comentário`, 
            impact: `Impacto`, 
            impactDescriptionCannotContainSpecialCharacters: `A descrição do impacto não pode conter caracteres especiais!`, 
            inactivated: `inativado`, 
            inactiveUsers: `Usuários Inativos`, 
            initProgramMessage: `Programa iniciado dia `, 
            informBugHuntPassword: `Informe a senha da plataforma BugHunt para confirmar esta operação.`, 
            informThePhoneWithAreaCode: `Informe o telefone com DDD`, 
            informTheRecommendations: `Informe as recomensas que o especialista vai obter caso tenha sucesso!`, 
            informTheScope: `Informe o escopo`, 
            informTheScopeWhereTheThreatsAre: `Informe o escopo onde estão as ameaças`, 
            selectTheScopeType: `Selecione o tipo do escopo inspecionado`, 
            informTheImpact: `Informe o impacto`, 
            informTheUser: `Informe o usuário`, 
            informTheWebsite: `Informe o website`, 
            interationIdealTime: `O tempo médio ideal para {interationType} é de `, 
            interviewWithExpertIgorRincon: `Entrevista com especialista Igor Rincon`, 
            invalidBackupCodeOrToken: `Código ou token de backup inválidos`, 
            invalidCode: `Código inválido`, 
            invalidCodeOrToken: `Código ou token inválido`, 
            invalidDate: `Data inválida`, 
            invalidData: `Dados inválidos`, 
            invalidRegistrationData: `Dados para cadastro {0} inválidos!`, 
            invalidEmailOrPassword: `E-mail ou senha inválida!`, 
            invalidPassword: `Senha inválida`, 
            invite: `Convidar`, 
            invitationAccepted: `Convite aceito`, 
            invitationDeclined: `Convite recusado`, 
            invitationLimitManagersReached: `O limite de convites para gestores foi atingido.`, 
            invitationProgramLimitReached: `O limite de convites do programa {program} foi atingido.`, 
            invitationNotFoundOrExpired: `Convite não encontrado ou expirado!`, 
            invitationsAccepted: `Convite aceito`, 
            invitationsReceived: `Convites Recebidos!`, 
            invitationRevoked: `Convite revogado`, 
            invitationSent: `Convite enviado`, 
            invoiceValue: `Total da nota fiscal`, 
            NdaCreated: `NDA criado`, 
            inProgress: `Em andamento`, 
            inRelationToTheReport: `Referente ao relatório`, 
            inSomeCasesTheEmailMayFallAsSpam: `Em alguns casos, o e-mail pode ser considerado spam.`, 
            integration: `Integração`, 
            integrations: `Integrações`, 
            integrationsNotAvailable: `Integrações não disponíveis!`, 
            inTheProgram: `no programa`, 
            internal: `Interno`, 
            invoices: `Faturamentos`, 
            iPAdress: `Endereço IP`, 
            issued: `Emitido`, 
            itHappensInTheBestFamilies: `Acontece nas melhores famílias! Não se preocupe, basta colocar seu e-mail e enviaremos uma nova senha.`, 
            itHappensInTheBestFamiliesDonotworry: `Acontece nas melhores famílias! Não se preocupe.`, 
            itIsNotPossibleToEnterEqualRewards: `Não é possível inserir recompensas iguais!`, 
            itIsNotPossibleToEnterMore: `Não é possível inserir mais que 30 tags!`, 
            itIsNotPossibleToSubmitAnotherRetest: `Não foi possível submeter a avaliação do reteste!<br /> Aguarde o reteste do especialista.`, 
            iWantToCreateAnAccount: `Quero criar uma conta!`, 
            jobBoard: `Painel de Vagas`, 
            jobDescription: `##### Sobre a Empresa \n Descreva aqui os detalhes sobre sua **empresa**\n \n ##### Sobre a Vaga\n Estamos procurando por um Profissional que terá como principais responsabilidades:\n - Responsabilidade 1.\n - Responsabilidade 2.\n - Responsabilidade 3.\n \n ##### Requisitos\n - **Requisito 1:** Acima de x anos de experiência.\n - **Requisito 2:** Acima de x anos de experiência.\n - **Requisito 3:** Acima de x anos de experiência.`, 
            jobTitle: `Título da Vaga`, 
            joinedThePlatform: `Entrou na plataforma`, 
            lastReviewSubmittedAgo: `Última revisão enviada há {0}`, 
            lastInvitations: `Últimos Convites Enviados`, 
            last7daysOfAccess: `Últimos 7 dias de acesso`, 
            latestReports: `Últimos relatórios`, 
            letStartYourRegistrationAnd: `Vamos iniciar seu cadastro e em breve iremos entrar em contato com você para esclarecer qualquer dúvida e finalizar seu cadastro!`, 
            letsCompleteYourRegistration: `Vamos concluir seu cadastro!`, 
            letsCreateYourAccount: `Vamos criar sua conta!`, 
            letsCreateYourPreRegistration: `Vamos criar seu pré-cadastro!`, 
            lessThanMonthAgo: `há menos de um mês`, 
            like: `do tipo`, 
            limitScope: `Delimite o escopo e somente os acessos que serão recopensados!`, 
            limitOutOfScope: `Quais aplicações não devem ser testadas?`, 
            limitOfScopesPerProgramReached: `Limite de {0} escopos por programa atingido!`, 
            linkToJob: `Link para vaga`, 
            location: `Localidade`, 
            longPeriodsImpactSpecialists: `Longos períodos de espera podem impactar o engajamento dos especialistas neste programa.`, 
            low: `Baixo`, 
            makePayment: `Realize um Pagamento`, 
            makeAPayment: `Realizar um Pagamento`, 
            makeSureYouHaveACompatibleAppLike: `Certifique-se de ter um aplicativo compatível como `, 
            makeYourAccessEvenMoreSecure: `Torne seu acesso ainda mais seguro`, 
            manageAccess: `Gerencie quem tem acesso ao programa.`, 
            managementInvitations: `Gerenciamento de convites recebidos.`, 
            manageVPNforUsers: `Gerencie a VPN dos usuários de cada programa`, 
            manageYourPlanInformation: `Gerencie as informações do seu plano.`, 
            manageYourProgressPlatform: `Gerencie seu progresso na plataforma BugHunt`, 
            maximumLengthIsCharacters: `Tamanho máximo é de {0} caracteres`, 
            maximumFilesPerComment: `O máximo é de 10 arquivos por comentário`, 
            medianTimeToResolution: `Tempo médio para resolução`, 
            medianTimeToFirstResponse: `Tempo médio até a primeira resposta`, 
            medium: `Médio`, 
            metricDoesNotHaveEnoughDataYet: `Não existem dados suficientes para cálculo desta métrica`, 
            metricsDoesNotHaveEnoughDataYet: `Ainda não existem dados suficientes para cálculo das métricas`, 
            message: `Mensagem`, 
            messagePostedAgo: `mensagem publicada há {time}`, 
            messagePublishedDay: `mensagem publicada dia {day}`, 
            missedResponseTargetsReportsSent: `Respostas enviadas acima do tempo esperado`, 
            missedResponseTargetsResolved: `Resolução de relatórios acima do tempo esperado`, 
            missedResponseTargetsBounty: `Pagamentos efetuados acima do tempo esperado`, 
            monthlyFee: `Valor da mensalidade`, 
            monthlyPayment: `Mensalidade`, 
            moreOptions: `Mais opções`, 
            money: `Dinheiro`, 
            myPlan: `Meu Plano`, 
            myBusiness: `Minha empresa`, 
            nameChanged: `Nome alterado!`, 
            nameOfAccountHolder: `Nome do responsável pela conta!`, 
            nameIsNotValid: `O nome não é válido`, 
            navigation: `Navegação`, 
            needChangeDescription: `Utilize o molde para fazer uma descrição detalhada.`, 
            ndaVerificationRequired: `Seu perfil está apto a participar do processo de verificação!`, 
            ndaChange: `Mudança de NDA`, 
            next: `Próxima`, 
            new: `Novo`, 
            newComment: `Novo comentário`, 
            newUsers: `Novos Usuários`, 
            newPassword: `Nova Senha`, 
            newPasswordAndConfirmation: `Nova senha e confirmação não são iguais!`, 
            newReport: `Novo relatório`, 
            none: `Nenhum`, 
            noActivePrograms: `Nenhum programa ativo`, 
            noInvitationAvailable: `Nenhum convite disponível`, 
            noNotificationsAvailable: `Nenhuma notificação disponível`, 
            noPaymentsFound: `Nenhum pagamento encontrado`, 
            noProgramAvailable: `Nenhum programa disponível`, 
            noReportsFound: `Nenhum relatório encontrado`, 
            noScopeAvailable: `Nenhum escopo disponível!`, 
            noSuggestionsAvailable: `Nenhuma sugestão disponível`, 
            noteValue: `Valor da Nota`, 
            notAvailableForThisPlan: `Não disponível para este Plano!`, 
            notAuthorized: `Não autorizado!`, 
            shutdownRequested: `O encerramento deste relatório já foi solicitado!`, 
            replyNotificationTitle: `Solicitação de resposta`, 
            closingRequestTitle: `Solicitação de encerramento`, 
            replyRequestMessage: `Já foi solicitada uma resposta para este relatório!`, 
            notificationResponseReport: `Atenção! Uma resposta foi solicitada para este relatório.`, 
            shutdownNotificationMessage: `Atenção! Foi solicitado o fechamento deste relatório.`, 
            notificationSeeRequest: `Ver solicitação`, 
            requestSent: `Solicitação enviada com sucesso!`, 
            reportResponseNotification: `Atenção! Foi solicitado uma resposta deste relatório.`, 
            notEligible: `Não elegível`, 
            noExpertsFound: `Nenhum especialista encontrado`, 
            notificationUpdatedNDA: `O contrato de confidencialidade do programa {programName} foi atualizado! Para continuar participando deste programa é necesário você revise e aceite o NDA.`, 
            noUserAvailable: `Nenhum usuário disponível`, 
            noVpnAccessLogFound: `Nenhum log de acesso a vpn encontrado!`, 
            nowTellUsLittle: `Agora nos fale um pouco da política do programa!`, 
            nowTellUsALittleBitAboutTheThreat: `Agora conte-nos um pouco sobre a ameaça!`, 
            ofReward: `de recompensa`, 
            oneDayAgo: `há um dia`, 
            oldPassword: `Senha Antiga`, 
            outstandingPayments: `Pagamentos pendentes`, 
            open: `Aberto`, 
            opssMatiDidntApproveYourData: `Opss, a Mati não aprovou seus dados.`, 
            other: `Outros`, 
            others: `Outros`, 
            otherTypes: `Outros tipos`, 
            outOfScope: `fora de escopo`, 
            outOfScopeTitle: `Fora de Escopo`, 
            participating: `Participando`, 
            password: `Senha`, 
            passwordChanged: `Senha alterada!`, 
            passwordConfirmation: `Confirmação da Nova Senha`, 
            passwordsMustMatch: `As senhas devem ser iguais`, 
            passwordUpdateRequired: `Atenção! Altere sua senha para evitar o bloqueio desta conta!`,
            remainingDaysToUpdateYourPassword: `dias restantes para atualizar sua senha.`,
            passwordExpiredNotificationTitle: `Atenção! Sua senha expirou!`,
            passwordExpiredInstructions: `Sua conta será bloqueada temporariamente. Mantenha sua senha atualizada e siga as instruções enviadas ao e-mail associado a esta conta.`,
            enablePasswordExpiration: `Habilitar expiração de senha`,
            configSuccess: `Configuração atualizada com sucesso!`,
            expirePasswordConfig: `As senhas dos usuários serão válidas por`,
            pasteTheLinkIntoTheBodyOfTheDescription: `Cole o link no corpo da descrição.`, 
            pause: `Pausar`, 
            paused: `Pausado`, 
            pauseProgram: `Pausar programa ?`, 
            paymentFor: `Pagamento para`, 
            paymentHistory: `Histórico de Pagamentos`, 
            paymentSummary: `Resumo de pagamentos`, 
            paymentRequested: `Pagamento solicitado`, 
            pending: `Pendente`, 
            pendingSubscription: `Pendente de Assinatura`, 
            permission: `Permissão`, 
            permissions: `Permissões`, 
            pleaseMakeSureThatThisEmail: `Por favor, certifique-se que este email esteja correto e que pertença a você.`, 
            phoneNumber: `Número de telefone`, 
            phoneSuccessfullyRemoved: `Telefone removido com sucesso!`, 
            phoneValidation: `Validação de telefone`, 
            platform: `Plataforma`, 
            points: `Pontos`, 
            pointsIn: `pontos em`, 
            possibleDup: `Relatório possivelmente duplicado - O escopo {scope} já recebeu relatórios referentes a {CWE}`, 
            possibleSpam: `Possível SPAM - Verificamos que o especialista {expert} enviou vários relatórios referentes a {CWE} no escopo {scope}.`, 
            postedComment: `postou um comentário `, 
            postedImage: `Postou uma imagem`, 
            previous: `Anterior`, 
            primaryEmail: `e-mail principal`, 
            primaryEmailReceiving: `E-Mail primário para recebimento de informações`, 
            privacy: `Privacidade`, 
            privacyPolicy: `Política de Privacidade`, 
            private: `Privado`, 
            privateProgram: `programa privado`, 
            profileInformation: `Informações do Perfil`, 
            profileVerifiedReleased: `Verificação de perfil solicitada`, 
            program: `Programa`, 
            programs: `Programas`, 
            programDetails: `Detalhes do programa`, 
            program_management: `Gerenciamento de programas`, 
            programLifeCycle: `Ciclo de vida do programa`, 
            programsLimitReached: `Limite de programas {0} atingido!`, 
            programsIhaveAlreadyContributed: `Programas que já contribuí`, 
            programPolicy: `Política do Programa`, 
            programPolicyMustBeInformed: `A política do programa deve ser informada`, 
            programPolicyMustBeBetweenAndCharacters: `A política do programa deve ter entre {f} e {l} caracteres`, 
            programRanking: `Ranking do programa`, 
            programNdaMustBeBetweenAndCharacters: `O conteúdo do NDA deve ter entre {f} e {l} caracteres`, 
            programsPublishedOnTheWeb: `Programas publicados na web podem ser acessados por especialistas não cadastrados na plataforma.`, 
            programSuccessfullyChanged: `Programa alterado com sucesso`, 
            programType: `Tipo de Programa`, 
            programWith: `Programa com {0}`, 
            proofOfConceptLinks: `Links para prova de conceito são geralmente benignos, mas muitas vezes podem ser acompanhados por consequências não intencionais.`, 
            setProgramNda: `Você deseja adicionar o contrato de confidencialidade ao seu novo programa?`, 
            public: `Público`, 
            publicInformation: `Dados Públicos`, 
            publicOrPrivateProgram: `Programa público ou privado`, 
            publicProgram: `programa público`, 
            publish: `Publicar`, 
            published: `Publicado`, 
            publishedDaysAgo: `Publicado há {0}`, 
            publishProgramOnTheWeb: `Publicar programa na Web ?`, 
            publishToTheWeb: `Publicar na Web `, 
            questionsAboutUrl: `Dúvidas sobre {0}`, 
            rankingDoesNotHaveEnoughDataYet: `O Ranking ainda não tem dados suficientes`, 
            rankingPosition: `{0}° no Ranking`, 
            received: `Recebido`, 
            receiveAdvertising: `Receive advertising emails`, 
            receiveEmails: `Recebimento de E-Mails`, 
            receiveAdvertisingEmails: `Receber e-mails de propaganda`, 
            receiveNotificationsAboutNewReports: `Receba notificações sobre novos relatórios diretamente em suas plataformas de gestão`, 
            referenceDate: `Data de referência`, 
            refuseRetest: `Recusar reteste`, 
            refusedRetest: `recusou o reteste`, 
            registerBelowTheTags: `Cadastre abaixo as tags que serão utilizadas para classificar os relatórios.`, 
            registeredUsers: `Usuários Registrados`, 
            registeredVacancies: `Vagas`, 
            registration: `Cadastro`, 
            removeAccount: `Remover Conta`, 
            remove: `Remover`, 
            removeFromWhitelist: `Remover da Whitelist`, 
            removeFromBlacklist: `Remover da Blacklist`, 
            removed: `Removido`, 
            reportAllPossibleThreatData: `Informe todos os dados possíveis das ameaças`, 
            report: `Relatório`, 
            reportID: `ID do relatório`, 
            reportCreatedSuccessfully: `Relatório criado com sucesso`, 
            reportEvaluation: `Avaliação do relatório`, 
            reportPayments: `Pagamentos de relatórios`, 
            reports: `Relatórios`, 
            reportSent: `Relatório enviado`, 
            reportsSent: `Relatórios enviados`, 
            reportTitle: `Título do relatório`, 
            reportedThatTheVulnerabilityIsFixed: `informou que a vulnerabilidade está corrigida`, 
            reportedThatTheVulnerabilityIsNotPatched: `informou que a vulnerabilidade não está corrigida`, 
            reportedVulnerabilities: `Vulnerabilidades reportadas`, 
            vulnerabilities: `Vulnerabilidades`, 
            overviewSubTitle: `Uma visão gerencial da sua conta só para você`, 
            summaryCard: `Resumo dos relatórios`, 
            requestedPayment: `solicitou um pagamento`, 
            requestedPaymentOf: `solicitou o pagamento de`, 
            requestedANewTestOfTheReport: `solicitou um novo teste do relatório`, 
            reset: `Limpar`, 
            rewardValue: `Valor da recompensa`, 
            whatIsAnNda: `O que é um NDA?`, 
            whatIsAnNda2: `NDA é uma sigla em inglês para Non-Disclosure-Agreements, ou simplesmente acordo de sigilo de informações.`, 
            whatIsAnNda3: `Ele tem a intenção de proteger segredos industriais, comerciais, ou ainda qualquer informação que não pode ser divulgada e deve manter-se em sigilo entre aqueles que têm acesso a ela.`, 
            whatIsaVPNAndHow: `O que é uma VPN e como ele pode ajudar em seus programas ?`, 
            reportTags: `Tags para o relatório`, 
            requestNewPassword: `Solicitar nova senha!`, 
            requestRetest: `Solicitar Reteste`, 
            requestSubscription: `Solicitar Assinatura`, 
            requiredField: `Campo obrigatório`, 
            retestRequested: `Reteste Solicitado`, 
            requestedRetestPayment: `solicitou o pagamento do reteste`, 
            retestId: `Reteste id`, 
            retestSent: `Reteste enviado`, 
            return: `Voltar`, 
            resolved: `Resolvidos`, 
            revoke: `Revogar`, 
            revokeWebAccessToTheProgram: `Revogar acesso Web ao programa ?`, 
            revoked: `Revogado`, 
            revokeAccess: `Revogar Acesso`, 
            rewardAmount: `Valor da Recompensa`, 
            reward: `Recompensa`, 
            rewardDetails: `Detalhes da recompensa`, 
            rewards: `Recompensas`, 
            rewardsReceived: `Recompensas Recebidas`, 
            rewardsWithFinancialValues: `Recompensas com valores financeiros`, 
            save: `Salvar`, 
            saveEditions: `Salvar alterações`, 
            saveNda: `Salvar contrato de confidencialidade`, 
            saveInformation: `Salvar`, 
            scopePerProgram: `Escopo por programa`, 
            scopesPerProgram: `Escopos por programa`, 
            search: `Pesquisar`, 
            seconds: `segundos`, 
            select: `Selecione`, 
            selectAddAccount: `Selecione "Adicionar conta" ou "+" e digitalize o código QR abaixo`, 
            selectAScoreForTheReport: `Selecione uma pontuação para o relatório`, 
            selectFile: `Selecione o arquivo!`, 
            selectProgram: `Selecione um programa`, 
            selectLanguage: `Selecione um idioma`, 
            selectScopeType: `Selecione o tipo de escopo`, 
            selectTheThreat: `Selecione a ameaça!`, 
            selectTheProgramScope: `Selecione o escopo do programa!`, 
            selectTheProgramImpact: `Selecione o impacto do programa!`, 
            selectTheReport: `Selecione o relatório`, 
            selectTheScope: `Selecione o escopo`, 
            selectTheCWE: `Selecione o CWE`, 
            selectTheVulnerability: `Selecione a vulnerabilidade`, 
            securityAnalyst: `Ex. Analista de segurança`, 
            send: `Enviar`, 
            sentTheRetest: `Enviou o reteste`, 
            sendMessage: `Enviar Mensagem`, 
            sent: `Enviou`, 
            sentTo: `Enviado`, 
            sentTheReport: `enviou o relatório`, 
            settings: `Configurações`, 
            severityReports: `Relatórios por severidade`, 
            severity: `Severidade`, 
            currentValue: `Valor atual`, 
            finalValue: `Valor final`, 
            showingResultsOfTotal: `Mostrando {results} de {totalResults} resultados.`, 
            since: `Desde {0}`, 
            sinceLastMonth: `desde mês passado`, 
            situation: `Situação`, 
            scope: `Escopo`, 
            scopeLimitExceeded: `O limite de escopos do programa foi excedido.`, 
            scopeListOfTheProgram: `Lista de escopo do programa!`, 
            score: `Pontuação`, 
            scoreHistory: `Histórico de pontuação`, 
            scopeType: `Tipo do Escopo`, 
            share: `Compartilhar`, 
            smsCode: `Código SMS`, 
            smsCodeSent: `Código SMS enviado`, 
            specialist: `Especialista`, 
            specialistNotFound: `Especialista não encontrado!`, 
            standard: `Padrão`, 
            standoutCreate: `Destaque-se! Crie um título motivador.`, 
            start: `Início`, 
            pauseMessage: `Não foi possível executar a ação, uma vez que a campanha ainda não teve início.`, 
            startAnAccountForOrganization: `Criar uma conta para organização`, 
            startWithRewards: `Começe pelas recomensas que possuem valor financeiro`, 
            statistics: `Estatísticas`, 
            stateCity: `Estado`, 
            status: `Estado`, 
            statusChanged: `Status alterado!`, 
            storeYourBackupCodes: `Armazene seus códigos de backup`, 
            subdomain: `Subdomínio`, 
            submittedDays: `Enviado tem {0} dias`, 
            submitComment: `Enviar Comentário`, 
            submitForReview: `Enviar para Análise`, 
            rewardNotice: `Lembrete: Esse programa oferece recompensa em dobro`, 
            submitReport: `Submeter Relatório`, 
            submit_retest: `Submeter reteste`, 
            successfullyGeneratedKeys: `Keys geradas com sucesso!`, 
            suggestions: `Sugestões`, 
            suggestedReward: `Recompensa sugerida`, 
            summary: `Resumo`, 
            superSimpleItDoesntEvenTake: `É simples, não leva nem 1 minuto. Basta informar os dados abaixo e pronto! Sua conta está criada.`, 
            superSimpleItDoesntEvenTakeCompany: `É simples, não leva nem 1 minuto. Basta informar os dados comuns da organização e pronto! Sua conta será enviada para análise.`, 
            support: `Suporte`, 
            sureAddExpertBlacklist: `Tem certeza de que deseja adicionar este especialista a blacklist ?`, 
            sureAddExpertWhiteList: `Tem certeza de que deseja adicionar este especialista a Whitelist ?`, 
            sureRemoveExpertBlacklist: `Tem certeza de que deseja retirar este especialista da Blacklist ?`, 
            sureRemoveExpertWhitelist: `Tem certeza de que deseja remover este especialista da Whitelist ?`, 
            successfullyCreatedProgram: `Programa criado com sucesso`, 
            successfullyCreated: `criada com sucesso`, 
            acceptedNda: `NDA aceito com sucesso!`, 
            openReports: `Relatórios abertos`, 
            openYourApp: `Abra seu aplicativo.`, 
            or: `ou`, 
            organizationName: `Nome da organização`, 
            overallRanking: `Ranking Geral`, 
            paidRetest: `Se o&nbsp;<b>reteste for aprovado</b>, você receberá mais&nbsp;<b>{0}</b>&nbsp;do valor do bounty.`, 
            tagsAreUsedToHelpIdentifyReports: `As Tags são utilizadas para auxiliar na identificação dos relatórios.`, 
            tagsForReports: `Tags para relatórios`, 
            takeAction: `Realizar Ação`, 
            takeTheOpportunityToAcquireMoreComplete: `Aproveite a oportunidade para adquirir planos mais completos para sua empresa`, 
            talkDirectlyToOurOperators: `Fale diretamente com nossos operadores.`, 
            target: `Tempo esperado: {0}`, 
            telephone: `Telefone`, 
            testDescriptionsMustBetweenCharacters: `A descrição dos testes deve ter entre {f} e {l} caracteres`, 
            tests: `Testes`, 
            terms: `Termos`, 
            termsAPolicy: `Termos e Política`, 
            termsOfUse: `Termos de Uso`, 
            thanksForRegistering: `Obrigado por se cadastrar!`, 
            thankByEmail: `Agradecimento por e-mail`, 
            theActionsTakenOnTheReportCannotBe: `As ações feitas no relatório não poderão ser removidas`, 
            theCommentNeedsToBeInformed: `O comentário precisa ser informado!`, 
            theDescriptionTestsMustBeInformed: `A descrição dos testes precisa ser informada`, 
            theDescriptionOfTheProgramMustBeInformed: `A descrição do programa deve ser informado`, 
            theImpactDescriptionMustBeInformed: `A descrição do impacto precisa ser informada`, 
            theImpactDescriptionMustBetweenCharacters: `A descrição do impacto deve ter entre {f} e {l} caracteres`, 
            theIsNotValid: `O {0} não válido`, 
            theFileIsNotValid: `O arquivo não é válido!`, 
            theNameMustBeFromToCharacters: `O nome deve ter de {f} a {l} caracteres`, 
            theNameOfThePersonResponsibleIsMandatory: `O nome do responsável é obrigatório.`, 
            theNameOfTheProgramMustBInformed: `O nome do programa deve ser informado`, 
            theNameWillBeAssignedToYourProgramsURL: `O nome será atribuido a URL do seu programa.`, 
            thenUseYourEmail: `Então utilize seu e-mail, sua senha e acesse nossa plataforma. Caso tenha esquecido da senha ou seu usuário, utilize a opção de recuperação abaixo!`, 
            thePhoneIsNotValid: `O telefone não é valido.`, 
            theProgramDescriptionMustBeBetweenAndCharacters: `A descrição do programa deve ter entre {f} e {l} caracteres!`, 
            theProgramNameMustBeBetweenAndCharacters: `O nome do programa deve ter entre {f} e {l} caracteres`, 
            thereIsAlreadyAprogram: `Já existe um programa cadastrado com esse nome!`, 
            thereIsAlreadyProgramSlug: `Já existe um programa cadastrado com essa slug!`, 
            theReportNeedsToBeInformed: `O relatório precisa ser informado`, 
            theRetestMustBeSentWithinDays: `O reteste deve ser enviado em até {0} dias`, 
            theRetestWasNotSubmitted: `O reteste não foi submetido!`, 
            theRetestHaAlreadyAccepted: `O reteste já foi aceito!`, 
            theseSettingsDirectlyImpactTheAccessOfExperts: `Essas configurações impactam diretamente no acesso dos especialistas.`, 
            theScopeAddressMustBeInformed: `O endereço do escopo deve ser informado`, 
            theThreatDescriptionMustBeInformed: `A descrição da ameaça deve ser informada!`, 
            theThreatDescriptionMustBetweenCharacters: `A descrição da ameaça deve ter entre {f} e {l} caracteres`, 
            theTitleMustBeInformed: `O título precisa ser informado`, 
            theTitleMustBeBetweenCharacters: `O título deve ter entre {f} e {l} caracteres`, 
            theWebhookIsNotValid: `O webhook não é válido!`, 
            theWebsiteMustBeFromToCharacters: `O website deve ter de {f} a {l} caracteres`, 
            thisChangeIsIrreversible: `Essa alteração é irreversível.`, 
            thisInformationCanAppear: `Essas informações podem aparecer no perfil público da empresa, ao lado dos seus comentários e em qualquer um dos seus relatórios.`, 
            thisIsAnInternalSurvey: `Esta é uma pesquisa interna, os especialistas não terão acesso aos dados deste questionário.`, 
            thisServiceCreatesAVPNResponsible: `Este serviço cria uma VPN, responsável por conectar e monitorar o tráfego de dados dos testes do especialista aos seus escopos, e com isso maior rastreabilidade e segurança.`, 
            thisWeek: `nesta semana`, 
            threats: `Ameaças`, 
            time: `Tempo`, 
            timeToFirstResponse: `a primeira resposta`, 
            timeToBounty: `pagar a recompensa`, 
            timeToResolution: `encerrar o relatório`, 
            title: `Título`, 
            to: `para`, 
            toAcceptThisInvitation: `Para aceitar este convite é necessário se verificar na Meta<b>Map</b> , após a verificação, aguarda alguns minutos e atualize a página.`, 
            tokenIsInvalid: `O token é inválido ou já foi utilizado`, 
            toAddMorePrograms: `Para acrescentar mais programas confira nossos planos clicando`, 
            toAddMoreScopesToThe: `Para acrescentar mais escopos no programa confira nossos planos clicando`, 
            toAddMoreUsersCheck: `Para acrescentar mais usuários, confira nossos planos clicando`, 
            toAddTheseIntegrations: `Para acrescentar estas integrações confira nossos planos clicando`, 
            toAddThisFeatureCheck: `Para acrescentar este recurso, confira nossos planos clicando`, 
            toChangeYourPlanContactSupport: `Para alterar seu plano, entre em contato com o suporte.`, 
            toCheck: `verificar`, 
            toConfirmWeNeedYourPassword: `Para confirmar precisamos de sua senha`, 
            toConfirmYourRegistrationOn: `Para confirmar seu cadastro em nossa plataforma é necessário clicar no botão abaixo.`, 
            today: `Hoje`, 
            toDoThisYouNeedToEnterYourAppCode: `Para fazer isso é preciso digitar o código de seu aplicativo ou colar um de seus tokens de backup!`, 
            topReportedCWE: `CWE mais relatado`, 
            totalConnectedHours: `Total de horas conectadas`, 
            totalEvents: `Total de eventos`, 
            totalMonthlyFees: `Total das mensalidades`, 
            totalReports: `Total de relatórios`, 
            totalReceived: `Total Recebido`, 
            totalRewards: `Total de recompensas`, 
            toTheProgram: `ao programa`, 
            totalSpent: `Total Pago`, 
            totalSum: `Somatório Total`, 
            trackYourOpenReports: `Acompanhe seus relatórios abertos`, 
            twoFactorAuthentication: `Autenticação de dois fatores`, 
            type: `Tipo`, 
            typeOfContract: `Tipo de contrato`, 
            typeOrPasteOneOfYourBackupTokens: `Digite ou cole um de seus tokens de backup, lembrando que cada token só pode ser usado uma vez!`, 
            typeProgramLimitExceeded: `O limite de programas do tipo {programType} foi excedido`, 
            unableToCompleteThisRequest: `Não foi possível concluir esta solicitação.`, 
            unableToSubmittedTheReport: `Não foi possível submeter este relatório. Certifique-se que todos os campos foram preenchidos corretamente.`, 
            undefinedRanking: `Ranking indefinido`, 
            uninformed: `Não informado`, 
            unshowPassword: `Esconder senha`, 
            update: `Atualizar`, 
            updates: `Atualizações ({numberOfUpdates})`, 
            updated: `Atualizado`, 
            uploadFiles: `Enviar arquivos`, 
            upTo: `Até`, 
            urlIsNotValid: `A url não é válida`, 
            useBackupCode: `Usar código de backup ?`, 
            user: `Usuário`, 
            userBlockedForOverTrying: `Usuário bloqueado por excesso de tentativas, tente novamente mais tarde.`, 
            userByCompany: `Usuário por empresa`, 
            userDisconnected: `Usuário desconectado!`, 
            userLimitReached: `Limite de usuários atingido!`, 
            userLoggedIn: `Usuário conectado!`, 
            usersByCompany: `Usuários por empresa`, 
            userDoesNotHavPermissionToPerform: `Usuário não tem permissão para executar esta ação`, 
            usernameHasInvalidCharacters: `O nome de usuário possui caracteres inválidos`, 
            usernameIsNotAvailable: `O username não está disponível!`, 
            usernameMustBeFromCharacters: `O nome de usuário deve ter de {f} a {l} caracteres.`, 
            users: `Usuários`, 
            userEmail: `Usuário ou e-mail`, 
            usersOnTheBlacklist: `Usuários na Blacklist não terão acesso a este programa!`, 
            userRemoved: `Usuário removido`, 
            useYourAuthenticationAppToEnterTheCode: `Use seu aplicativo de autenticação para inserir o código`, 
            validatePhone: `Validar telefone`, 
            validatedPhone: `Telefone validado`, 
            value: `Valor`, 
            verified: `Verificado`, 
            verifieds: `Verificados`, 
            vpnIP: `IP da VPN`, 
            waitingConfirmation: `Aguardando confirmação`, 
            wantSaveChangesProgram: `Você deseja mesmo salvar as alterações feitas neste programa?`, 
            waysExplore: `Formas de Explorar`, 
            weLeaveThisPanel: `Deixamos esse painel para você publicar suas vagas para nossos especialistas`, 
            whatIsBugBounty: `O que é Bug Bounty`, 
            whatIsYourAction: `Qual sua ação?`, 
            whatIsNdaHeader: `Fique atento!`, 
            whatPrograms: `Quais programas?`, 
            whatTypeOfVulnerability: `Qual o tipo de vulnerabilidade reportada`, 
            whoDoYouWantInvite: `Quem deseja convidar?`, 
            whiteMessage: `Escreva uma mensagem...`, 
            weakPasswordContain: `Senha fraca! ela deve cont`, 
            websiteInvitation: `Convite do site`, 
            weSendAToast: `Enviamos um brinde`, 
            weAreUnderMaintenance: `Estamos em manutenção! Retorne em breve!`, 
            weTemporarilyStoreYourReport: `Armazenamos temporariamente os dados de seu relatório para o programa`, 
            weWillContactYouShortly: `Em breve entraremos em contato para confirmar seus dados.`, 
            wikiSubTitle: `Nós ajudamos como podemos e como não podemos.`, 
            withoutWebAccessTheProgram: `Sem acesso Web o programa ficará disponível apenas para usuários da plataforma.`, 
            workModel: `Modelo de trabalho`, 
            workSchedule: `Horário de Trabalho`, 
            yesIWantToRegister: `Sim, quero me cadastrar`, 
            yes: `Sim`, 
            no: `Não`, 
            youAcceptedThisInvitation: `Você aceitou esse convite`, 
            youAreAboutToVisitLink: `Você está prestes a visitar um link externo.`, 
            youAreAllowedToViewTheReports: `Tem permissão para ver os relatórios.`, 
            youCanUseOneOfTheseBackupCodes: `Você pode usar um desses códigos de backup para fazer o login, caso perca o acesso ao seu smartphone. Lembre-se de que cada código só pode ser usado uma vez.`, 
            yourCurrentPlanIsThe: `Seu plano atual é`, 
            youDoNotHaveAnyTagRegistered: `Você não possui nenhuma Tag cadastrada, para adicionar acesse o menu <a href="/account?tags">Minha Conta/Tags</a>`, 
            youDontHave: `Você não possui`, 
            youDontHaveAnyAcceptedInvitations: `Ainda não possui convites aceitos!`, 
            youDontHaveAnyInvitationsWaiting: `Ainda não possui convites aguardando respostas!`, 
            youDontHaveAnyNDAs: `Você ainda não possui um programa com contrato de confidencialidade!`, 
            youDontHaveAnyNDAsHacker: `Você ainda não concordou com nenhum contrato de confidencialidade!`, 
            youDontHaveAnyProgramsInThisCategoryYet: `Você ainda não possui programas nessa categoria`, 
            youDontHaveSubmittedReports: `Ainda não possui relatórios aprovados!`, 
            youHave: `Você possui`, 
            youHaveBeenInvitedToSend: `Você foi convidado para enviar relatórios à esse programa`, 
            youHavePermissionToViewAndEditReports: `Tem permissão para ver e editar os relatórios.`, 
            youMustAgreeToTheTermsOfUse: `Você precisa concordar com o termo de uso.`, 
            yourAccessPassword: `Sua senha de acesso!`, 
            yourAccesEmail: `Seu e-mail de acesso ao {0}`, 
            youReachedLimit: `Você atingiu o limite diário de envio de relatórios!`, 
            yourEmail: `Seu email`, 
            yourFullName: `Seu nome completo!`, 
            yourNameMustBeBetweenAndCharacters: `Seu nome deve ter entre {f} e {l} caracteres!`, 
            yourOrganizationNameIsRequired: `O nome da sua organização é obrigatório`, 
            YourOrganizationTradeName: `Nome fantasia da sua organização!`, 
            yourPassword: `Sua senha`, 
            yourPhoneToGetInTouch: `Telefone para entrarmos em contato!`, 
            yourProfileIsNowAbleTo: `Seu perfil está apto a participar do processo de verificação!`, 
            ndaVerificationRequired1: `Você foi convidado para participar do programa `, 
            ndaVerificationRequired2: `A verificação do seu perfil é necessária para aceitar este convite!`, 
            ndaVerificationRequired3: `Confira a sua lista de notificações e prossiga com o processo de verificação.`, 
            noJobsFound: `Nenhuma vaga encontrada`, 
            registrationDone: `Cadastro efetuado!`, 
            reportPaymentVerificationRequired1: `O pagamento de uma recompensa para o relatório `, 
            reportPaymentVerificationRequired2: `foi solicitado!`, 
            reportSummaryNotValid: `O resumo do relatório não é válido!`, 
            reportContentIsNotValid: `O conteúdo do relatório não é válido!`, 
            reportVulnerabilitIsNotValid: `O impacto da vulnerabilidade não é válido!`, 
            reportCriticalityIsNotValid: `A criticidade da vulnerabilidade não é válida`, 
            reportCantAcceptEspecialCaracter: `( Não é possível inserir caracteres especiais. )`, 
            reportScopeIsNotValid: `O identificador do escopo do relatório não é válido!`, 
            reportIdentifierIsNotValid: `O identificador do programa não é válido!`, 
            reportVulnerabilityIdentifierIsNotValid: `O identificador da vulnerabilidade não é válido!`, 
            ndaVerificationRequired6: `Complete a validação do seu perfil para que possamos prosseguir com o pagamento da recompensa!`, 
            reportTitleIsNotValid: `O título do relatório não é válido!`, 
            showPassword: `Mostrar senha`, 
            companyNdaVerificationRequired: `Você precisa criar um NDA para o seu programa antes de convidar especialistas!`, 
            taxesNotIncluded: `Tributos não inclusos`, 
            youAcceptedParticipateInThisProgram: `Você aceitou participar deste programa.`, 
            youCanCalculate: `Você pode calcular a severidade através da calculadora abaixo`, 
            youShouldConsiderUsingSeparate: `Você deve considerar o uso de um navegador ou máquina virtual separada antes de continuar.`, 
            yourSecurityPlatformAndBugReward: `A sua plataforma de Bug Bounty`, 
            youWereInvitedPartOf: `Você foi convidado a fazer parte do time {0}, Basta informar os dados da sua conta.`, 
            youWillBeRedirectedIn: `Você será redirecionado em`, 
            youWillReceiveReportsFromCommunity: `Você irá receber relatórios dos especialistas em segurança da nossa comunidade, sem nenhum custo adicional, minimizando os riscos de seus dados serem expostos ou vulnerabilidades exploradas.`, 
            invitationsSummary: `Resumo dos convites`, 
            doubleReward: `Recompensa em dobro`, 
            boostedProgram: `Programa impulsionado!`, 
            doubleCampaignNotificationStarted: `Campanha de bonificação iniciada`, 
            doubleCampaignNotificationClosed: `Campanha de bonificação encerrada`, 
            doubleCampaignNotificationPaused: `Campanha de bonificação pausada`, 
            doubleCampaignNotificationResumed: `Campanha de bonificação retomada`, 
            campSubTitle: `Gerencie suas campanhas! Acompanhe todos os detalhes.`, 
            historicCampaign: `Histórico`, 
            historicDoubleBounty: `Bounty em dobro`, 
            historicDoubleScore: `Score em dobro`, 
            inText: `De`, 
            until: `Até`, 
            finished: `Finalizado`, 
            in_progress: `Em progresso`, 
            situationCancel: `Cancelado`, 
            createdTh: `Criado em`, 
            periodTh: `Período`, 
            rewardsTh: `Recompensas`, 
            situationsTh: `Situações`, 
            historicApproved: `Aprovados`, 
            historicCancel: `Cancelados`, 
            historicPaused: `Pausados`, 
            historicFinished: `Finalizados`, 
            notificationAttention: `Atenção!`, 
            notificationYourCampaignHasStarted: `Sua campanha foi iniciada!`, 
            notificationThisCampaign: `Esta campanha`, 
            notificationHasClosed: `foi encerrada`, 
            notificationHasBeenPaused: `foi pausada`, 
            keepAnEyeOutNotification: `fique de olho`, 
            notificationWillLetYouKnowWhenToStartAgain: `avisaremos quando iniciar novamente.`, 
            notificationThisCampaignIsLiveAgain: `Esta campanha está no ar novamente!`, 
            finalDate: `Fim`, 
            remain: `Restam`, 
            campaignStarted: `A campanha de recompensas dobradas foi iniciada!`, 
            campaignClosed: `A campanha de recompensas dobradas foi finalizada!`, 
            campaignPause: `A campanha de recompensas dobradas foi pausada!`, 
            campaignReactivated: `A campanha de recompensas dobradas foi reativada!`, 
            campaignFinalDays: `para o fim da campanha`, 
            campaignInitialDays: `para o inicío da campanha`, 
            dayCampaign: `dia`, 
            daysCampaign: `dias`, 
            daysGeneric: `dia(s)`, 
            btnRegister: `Cadastrar`, 
            btnCancel: `Cancelar`, 
            btnLabel: `Selecione a data`, 
            doubleBounties: `Dobrar bounties`, 
            doubleScore: `Dobrar pontuação`, 
            activeDoubleCampaign: `Impulsionar programa`, 
            selectAPeriod: `Selecione um período:`, 
            monthlyRanking: `Ranking Mensal`, 
            generalRanking: `Ranking Geral`, 
            expertRating: `Confira a classificação dos especialistas BugHunt`, 
            bountyOffer: `Você está oferencendo: Bounties em dobro`, 
            bountyScore: `Você está oferencendo: Pontuação em dobro`, 
            bountyAndScoreOffer: `você está oferecendo: Bouties e Pontuação em dobro`, 
            closeCampaign: `Encerrar Campanha de bonificação`, 
            pauseCampaign: `Pausar Campanha de bonificação`, 
            reactivateCampaign: `Reativar Campanha de bonificação`, 
            boostCampaign: `Impulsionar programa`, 
            doubleCheckCampaign: `Estou ciente das alterações do valor atual das recompensas.`, 
            successfullyCreatedCampaign: `Solicitação realizada com sucesso, por favor aguarde análise de aprovação da campanha!`, 
            vpnMessage: `Não há uma vpn habilitada neste programa.`, 
            campaignPaused: `Campanha pausada com sucesso!`, 
            doubleCampaignClosed: `Campanha encerrada com sucesso!`, 
            doubleCampaignResumed: `Campanha retomada com sucesso!`, 
            registeredProgramWarning: `Este programa já possui uma campanha aprovada ou encerrada a menos de 15 dias.`, 
            warningBoutiesOrScore: `A campanha deve oferecer bounties ou pontuação em dobro!`, 
            invalidDateMessage: `Data inválida, por favor verifique se o campo foi preenchido corretamente!`, 
            v_administrator: `administrador`, 
            v_viewer: `visualizador`, 
            v_analyst: `analista`, 
            administrator: `Administrador`, 
            viewer: `Visualizador`, 
            analyst: `Analista`, 
            v_private: `privado`, 
            v_public: `publico`, 
            v_internal: `interno`, 
            v_new: `novo`, 
            v_under_review: `em revisão`, 
            v_triaged: `triado`, 
            v_needs_information: `necessita de informações`, 
            v_approved: `aprovado`, 
            v_informative: `informativo`, 
            v_duplicated: `duplicado`, 
            v_not_applicable: `não aplicável`, 
            v_spam: `spam`, 
            v_accepted: `Aceitos`, 
            v_pending: `Pendentes`, 
            v_declined: `Recusados`, 
            v_revoked: `Revogados`, 
            v_pending_retest: `Reteste`, 
            v_retest_done: `Reteste concluído`, 
            retest_done: `Reteste concluído`, 
            pending_retest: `Reteste Pendente`, 
            notImpact: `Severidade não informada`, 
            lowImpact: `Severidade baixa`, 
            mediumImpact: `Severidade média`, 
            highImpact: `Severidade alta`, 
            criticalImpact: `Severidade crítica`, 
            approved: `Aprovado`, 
            informative: `Informativo`, 
            duplicated: `Duplicado`, 
            not_applicable: `Não aplicável`, 
            spam: `Spam`, 
            comment: `Postar um comentário`, 
            change_situation: `Alterar situação`, 
            update_severity: `Alterar gravidade`, 
            request_update: `Solicitar atualização`, 
            retest: `Solicitar reteste`, 
            pay_bounty: `Pagar uma recompensa`, 
            close_report: `Fechar o relatório`, 
            reopen_report: `Reabrir o relatório`, 
            needs_information: `Aguardando informações`, 
            under_review: `Em revisão`, 
            triaged: `Triado`, 
            plan_trial: `Plano Trial`, 
            plan_bronze: `Plano Bronze`, 
            plan_silver: `Plano Prata`, 
            plan_gold: `Plano Ouro`, 
            trial: `Trial`, 
            bronze: `Bronze`, 
            silver: `Prata`, 
            gold: `Ouro`, 
            fulltime: `Full-time`, 
            parttime: `Part-time`, 
            clt: `CLT`, 
            pj: `PJ`, 
            autonomous: `Autônomo`, 
            cltflex: `CLT-Flex`, 
            cooperative: `Cooperativo`, 
            internship: `Estágio`, 
            hybrid: `Híbrido`, 
            office: `Presencial`, 
            remote: `Remoto`, 
            web: `Aplicação Web`, 
            api: `API`, 
            mobileapplication: `Aplicação Mobile`, 
            mobileapplicationandroid: `Aplicação Mobile android`, 
            mobileapplicationios: `Aplicação Mobile ios`, 
            ip: `Endereço de IP`, 
            january: `Janeiro`, 
            february: `Fevereiro`, 
            march: `Março`, 
            april: `Abril`, 
            may: `Maio`, 
            june: `Junho`, 
            july: `Julho`, 
            august: `Agosto`, 
            september: `Setembro`, 
            october: `Outubro`, 
            november: `Novembro`, 
            december: `Dezembro`, 
            seeOriginalText: `Ver texto original.`, 
            waiting_for_information: `Aguardando informações`, 
            severity_updated: `Gravidade atualizada`, 
            retest_requested: `Solicitação de resteste`, 
            bounty_paid: `Recompensa paga`, 
            close_as_approved: `Fechar como aprovado`, 
            close_as_informative: `Fechar como informativo`, 
            close_as_spam: `Fechar como spam`, 
            close_as_duplicated: `Fechar como duplicado`, 
            close_as_not_applicable: `Fechar como não aplicável`, 
            select_option: `Selecione uma opção`, 
            deleteMessageAlert: `Tem certeza de que deseja excluir esta mensagem?`, 
            automaticMessage: `Ao selecionar a opção, a resposta automática será registrada como uma primeira interação no relatório.`, 
            defaultMessageCenterMenu: `Central de Mensagens Padrão`, 
            registerNotFound: `Nenhum registro foi encontrado.`, 
            registeredMessageTitle: `Mensagens Cadastradas`, 
            customSettingsTitle: `Configurações Personalizadas`, 
            customSettingsSubtitle: `Configuração de mensagens para respostas padronizadas`, 
            addMessageButton: `Adicionar mensagem`, 
            existingMessageAlert: `É possível cadastrar apenas uma mensagem por tipo de mensagem. Atualmente, todas as mensagens já estão registradas!`, 
            editMessage: `Editar Mensagem`, 
            registerMessage: `Cadastrar Mensagem`, 
            placeholderTitleMessage: `Titulo da mensagem`, 
            placeholderTextAreaMessage: `Adicione uma descrição...`, 
            labelAutomatic: `Automático`, 
            alertMessageSuccess: `Mensagem cadastrada com sucesso!`, 
            alertMessageUpdate: `Mensagem atualizada com sucesso!`, 
            swalTokenRemoved: `O token foi excluído com sucesso.`, 
            deleteTokenCompany: `Excluir token`, 
            placeholderTokenCompany: `Digite um token`, 
            errorToken: `O token deve conter no mínimo 20 caracteres e no máximo 500 caracteres!`, 
            emailNotification: `A notificação por e-mail foi ativada com sucesso!`, 
            enableEmailNotification: `Ativar o recebimento de atualizações do programa por meio de endereço eletrónico.`, 
            emailNotificationDisabled: `A notificação enviada por e-mail foi desativada!`, 
            china: `China`, 
            india: `Índia`, 
            estadosUnidos: `Estados Unidos`, 
            indonesia: `Indonésia`, 
            paquistao: `Paquistão`, 
            brasil: `Brasil`, 
            nigeria: `Nigéria`, 
            bangladesh: `Bangladesh`, 
            russia: `Rússia`, 
            mexico: `México`, 
            japao: `Japão`, 
            etiopia: `Etiópia`, 
            filipinas: `Filipinas`, 
            egito: `Egito`, 
            vietna: `Vietnã`, 
            repuplicaDemocraticaDoCongo: `República Democrática do Congo`, 
            turquia: `Turquia`, 
            ira: `Irã`, 
            alemanha: `Alemanha`, 
            tailandia: `Tailândia`, 
            reinoUnido: `Reino Unido`, 
            franca: `França`, 
            italia: `Itália`, 
            tanzania: `Tanzânia`, 
            africaDoSul: `África do Sul`, 
            mianmar: `Mianmar (Birmânia)`, 
            coreiaDoSul: `Coreia do Sul`, 
            colombia: `Colômbia`, 
            quenia: `Quênia`, 
            espanha: `Espanha`, 
            ucrania: `Ucrânia`, 
            uganda: `Uganda`, 
            sudao: `Sudão`, 
            angertina: `Argentina`, 
            angelia: `Argélia`, 
            iraque: `Iraque`, 
            polonia: `Polônia`, 
            canada: `Canadá`, 
            uzbequistao: `Uzbequistão`, 
            arabiaSaudita: `Arábia Saudita`, 
            br: `Português`, 
            en: `Inglês`, 
            es: `Espanhol`, 
            fr: `Francês`, 
            it: `Italiano`, 
            ru: `Russo`, 
            de: `Alemão`, 
            jp: `Japonês`, 
            cn: `Chinês`, 
            pl: `Polonês`, 
            ua: `Ucraniano`, 
            sd: `Árabe`, 
            kr: `Coreano`, 
            in: `Hindi`, 
            id: `Indonésio`, 
            pk: `Urdu`, 
            bd: `Bengali`, 
            et: `Amárico`, 
            ph: `Filipino (Tagalo)`, 
            vn: `Vietnamita`, 
            tr: `Turco`, 
            ir: `Persa`, 
            th: `Tailandês`, 
            za: `Africâner`, 
            mm: `Birmanês`, 
            ug: `Suaíli`, 
            uz: `Uzbeque`, 
            sa: `Árabe`, 
            additionalMoreLanguages: `Adicionar mais idioma`, 
            country: `País`, 
            language: `Idioma`, 
            clearText: `Utilizar a mensagem padrão`, 
            selectCountry: `Selecione um país`, 
            basic: `Básico`, 
            proficiency: `Proficiência`, 
            conversational: `Conversacional`, 
            fluent: `Fluente`, 
            native: `Nativo ou bilingue`, 
            AreYouSureYouWantToCompleteTheRequest: `Tem certeza de que deseja concluir esta solicitação?`, 
            managers: `Gestores`, 
            manageProgram: `Defina quem irá gerenciar o seu novo programa.`, 
            config: `Configurações`, 
            programSettings: `Configurações do programa`, 
            programEditAlert: `Atenção! Não é possível editar programas inativos ou aguardando aprovação.`, 
            changeSettings: `Alterar configurações`, 
            managersWithAccesToTheProgram: `Gestores com acesso ao programa`, 
            freeAccess: `Acesso liberado`, 
            pendingInviteAlert: `Atenção! Já existe um convite pendente associado a este endereço de email.`, 
            USDT: `Dólar`, 
            BRL: `Real`, 
            selectCurrencyType: `Selecione o tipo de moeda`, 
            passwordSuccess: `Senha cadastrada com sucesso!`,
            isNan: `O valor informado deve ser numérico.`,
            //translation_script_end_pt
        }),

        new MLanguage("english").create({ 
            ln: "en",
            //translation_script_start_en
            agreementText: `Do you agree with the therms of the confidentiality contract?`,
            agree: `Agree`,
            doNotAgree: `Disagree`,
            programWithNda: `NDA successfully linked to this program!`,
            ndaAccepted: `NDA accepted!`,
            programWithoutNda: `This program doesn't have a linked NDA!`,
            menuProgram: `Programs`,
            menuReport: `Report`,
            menuAccount: `My account`,
            navInvitations: `Invitations`,
            navPayments: `Payments`,
            navCreateNda: `Create an NDA Model`,
            navEditNda: `Edit NDA`,
            navPrograms: `Programs`,
            navPublished: `Published`,
            navClosed: `Inactive`,
            navNda: `NDAs`,
            navAll: `All`,
            navPending: `Pending`,
            navRetest: `Retest`,
            dashTitle: `Welcome {0}!`,
            dashSubTitle: `An overview and quick access to your account just for you`,
            dashReportResolv: `Resolved Reports`,
            navAverage: `Average Rewards`,
            dashMsgYouHave: `you have`,
            dashMsgYouDHave: `you don't have`,
            msgProgramPu: `public programs!`,
            msgProgramPr: `private programs!`,
            dashMsgGP: `Manage your programs.`,
            dashMsgCP: `Register a program now?`,
            dashInvTitle: `Invite Experts!`,
            dashInvSubTitle: `Invite experts to participate in your programs.`,
            dashPayTitle: `Payments!`,
            dashPaySubTitle: `Financial summary and payment requests.`,
            dashNdaTitle: `Confidentiality Contracts!`,
            dashNdaSubTitle: `Manage your program's confidentiality contracts.`,
            dashCreatNdaTitle: `NDA model!`,
            dashCreatNdaSubTitle: `Create your template to manage confidentiality contracts.`,
            dashCreatNdaAbriefsummary: `A brief summary for the expert to understand what it is all about ...`,
            dashCreatNdaDesc: `NDA is an acronym in English for Non-Disclosure-Agreements, or simply information confidentiality agreement. It is intended to protect industrial, trade secrets, or any information that cannot be disclosed and must remain confidential among those who have access to it.`,
            dashCreatNdaWriteTerms: `Write the terms of your confidentiality agreement and its peculiarities.`,
            dashCreatNdawritePaste: `Let's get started, write or paste your terms!`,
            dashCreatNdaWantAttach: `Do you want to attach a document to be signed?`,
            progTitle: `Overview!`,
            progSubTitle: `Track and manage your programs at BugHunt.`,
            progPubTitle: `Published Programs!`,
            progPubSubTitle: `Manage your published programs! Follow all the details.`,
            progCampTitle: `Campaigns`,
            progClosTitle: `Inactive programs!`,
            progClosSubTitle: `Missing something? Check the data of closed programs`,
            progCreateTitle: `Create a Program`,
            progCreateSubTitle: `Exciting moment, time to start creating your program!`,
            progRankTitle: `Contribution Ranking!`,
            progRankSubTitle: `See who else contributes to your programs.`,
            progRankSendThank: `Send a Thank You!`,
            progRankBtnSendThank: `Send Thanks`,
            progTimelineTitle: `Timeline programs!`,
            progTimelineSubTitle: `Follow the timeline of your programs`,
            repTitle: `Reports!`,
            repSubTitle: `Manage the reports sent by experts to your programs.`,
            repSubTitleHacker: `Manage reports sent to programs.`,
            repDetMsgAlter: `Changes made to the report cannot be undone!`,
            ccpTitle: `Shall we create a program?`,
            ccpProgPubli: `Public Program`,
            ccpProgPubliDesc: `Create a program where all registered specialists can view and send reports!`,
            ccpProgVDPDesc: `Create a program where all experts can view and send reports!`,
            ccpProgPriv: `Private Program`,
            ccpProgPrivDesc: `Create a program where only selected experts can view and send reports!`,
            managedProgram: `Managed Program`,
            protectedByNDA: `Protected by an NDA`,
            helpTitle: `Needing help?`,
            helpProgram: `How does a program work?`,
            helpDifference: `Whats the difference between private and public programs?`,
            helpaverage: `What is the average applied to a bounty?`,
            rankTitle: `Contribution Ranking`,
            retest_confirmed: `Adjusted`,
            retest_denied: `Fault persists`,
            accountSubTitle: `An overview and quick access to your account just for you.`,
            accountAcSubTitle: `Who, when and how accessed your account`,
            accountTerSubTitle: `Access our terms and privacy policy`,
            accountUserSubTitle: `Manage who has access to the organization.`,
            accountSettSubTitle: `How you want to receive your emails, privacy policy and more.`,
            aboutUs: `About Us`,
            aboutYou: `About you`,
            aboutYourAccount: `About your account`,
            aboutTheProgramPolicy: `About the program policy!`,
            add: `Add`,
            addUser: `Add User`,
            addAcomment: `Add a comment`,
            addExpertToBlacklist: `Add Expert to Blacklist`,
            addTheScopesHere: `Add the scopes here!`,
            addOutOfScopesHere: `Add here the applications which should be avoid during the security tests!`,
            addYourPayPalAccount: `Add your PayPal account`,
            adjustedTheImpactTo: `adjusted the impact to`,
            adjustedTheImpactFrom: `adjusted the impact from`,
            adjustMetrics: `Adjust Metrics`,
            allowedFiles: `Allowed files: videos, images and text files .jpg .jpeg .png .txt .rar .zip .7z`,
            alreadyHaveAccount: `Already have an account?`,
            accepted: `Accepted`,
            acceptThisInvitation: `Accept this Invitation!`,
            access: `Access`,
            accessControl: `Access Control`,
            accessMyAccount: `Access my account!`,
            accessProfile: `Access Profile`,
            accessInformation: `Access Information`,
            accountCreatedSuccessfully: `Account created successfully!`,
            accountDeleted: `Account deleted`,
            accountRecovery: `Account recovery`,
            accurate: `Accurate`,
            activate: `Activate`,
            activated: `Activated`,
            additionalServices: `Additional Services`,
            addOtherRewardsHere: `Add other rewards here!`,
            addToBlacklist: `Add to Blacklist`,
            agreementSpecialists: `Agreement specialists`,
            ago: `{0} ago`,
            aGoodPolicAvoids: `A good policy avoids problems, if you have any problems, contact us.`,
            all: `All`,
            gatTagOptDescription: `Only reports with the GAT tag`,
            gatTagDescription: `Which reports are going to be sent to GAT?`,                    
            allowMobileAccess: `Allow mobile access`,
            allowedToPayReward: `Allowed to pay rewards.`,
            allThePrograms: `All the programs`,
            allStatus: `All Status`,
            aLowercaseLetter: `A lowercase letter. `,
            anEmailContainingPasswordReset: `An email containing password reset instructions has been sent.`,
            aNewValidationEmailHasBeenSenToYou: `A new validation email has been sent to you, check your mailbox`,
            aNewSuperStrongPassword: `A new super strong password!`,
            annotation: `Annotation`,
            aNumber: `A number. `,
            anUppercaseLetter: `An uppercase letter. `,
            anyQuestionsAboutIntegration: `Any questions about the integration ?`,
            application: `Application`,
            applicableReport: `Applicable report`,
            approvedReports: `Approved reports`,
            approveWithoutRetest: `Do you really want to close the report as approved before requesting a retest?`,
            approveRetest: `Approve retest`,
            approvedRetest: `approved retest`,
            areYouSureYouWantToDeleteThisUser: `Are you sure you want to delete this user ?`,
            as: `as`,
            aSuperStrongPasswordNow: `A super strong password now!`,
            atBugHuntYouWillFindPrograms: `At BugHunt you will find programs to test different types of technologies, put your knowledge into practice, testing real applications in an ethical and legal way.`,
            attention: `Attention!`,
            atLeastCharacters: `At least 6 characters. `,
            authentication: `Authentication`,
            averageTicket: `Average ticket`,
            average_time_to_bounty: `Average time to pay reward`,
            average_time_to_first_response: `Average time to first response`,
            average_time_to_resolution: `Average time to close the report`,
            averageTimeToBounty: `Average time to bounty`,
            avgTimeToBounty: `The average elapsed time from the company's first interaction with a report to the request for payment of a reward.`,
            avgTimeToFirstResponse: `The average elapsed time from the report submission to the company's first interaction with a report.`,
            avgTimeToResolution: `The average time elapsed from opening a report to closing it.`,
            awaitingAcceptance: `awaiting acceptance`,
            awaitingPayment: `awaiting payment`,
            paymentReceived: `received the payment`,
            awaitingResponse: `Awaiting Response`,
            award: `Award`,
            backupCodesLeft: `backup codes left`,
            balance: `Balance`,
            basedLast90Day: `Based on the last 90 days`,
            beforeActivatingTwoFactorAuthentication: `Before activating Two-factor authentication you need to validate your phone.`,
            beforeContinuingYouNeed: `Before continuing, you need to validate your email!`,
            billingCreditCard: `Billing Credit Card`,
            billingForms: `Billing Forms`,
            billingInformation: `Billing Information`,
            byActivatingTheProgramSpecialistsWill: `By activating the program specialists will be able to send new reports!`,
            byPausingTheProgramExpertsWill: `By pausing the program, experts will no longer be able to send new reports!`,
            bounty: `Bounty`,
            bountyAwarded: `Bounty awarded`,
            bugBountyAndTheSecurityParadox: `Bug Bounty and the Security Paradox`,
            bugHuntIsTheFirstBrazilianBugBounty: `BugHunt is the first Brazilian Bug Bounty platform, and is now in partnership with AME Digital with the purpose of democratizing access to information security and thus making the Internet a safer place.`,
            ongoingProfileVerification: `Your profile is being verified!`,
            cancel: `Cancel`,
            cannotEnterEqualScopes: `Cannot enter equal scopes`,
            cannotEnterSpecialCharacters: `Cannot enter special characters`,
            cautionNDA1: `When writing your company's NDA, make sure it consider the following items:`,
            cautionNDA2: `contain at least one clause with the penalty, in case of non-compliance;`,
            cautionNDA3: `inform the parties that assume that commitment;`,
            cautionNDA4: `contain expiration date;`,
            cautionNDA5: `detail specifically about what that NDA, as generic and ambiguous information de-characterize the legal document;`,
            cautionNDA6: `use the tag `,
            cautionNDA7: `to refer to the specialist's name;`,
            cautionNDA8: `The NDA model below is illustrative. Make sure correctly inform your company data when writing the confidentiality agreement`,
            changeAccessPassword: `Change access password`,
            changePassword: `Change Password`,
            changePermission: `Change permission`,
            changedReportSeverity: `Changed report severity`,
            changedReportStatus: `Changed report status`,
            changedTheStatusFrom: `changed the status from {f} to {l}`,
            changedTheSituationTo: `changed the situation to {0}`,
            changedTheTitleOf: `changed the title of the report from {f} to {l}`,
            changedTheTitleTo: `changed the report title to {0}`,
            changedTheVisibilityOf: `changed their visibility from {f} to {l}`,
            changedTheVisibilityTo: `changed the visibility to {0}`,
            checkOutAllFieldsHighlightedInRed: `Check out all fields highlighted in red!`,
            chooseANicknameYoursAlone: `Choose a nickname to be yours alone!`,
            city: `City`,
            clickHereToLearn: `Click here to learn more about it!`,
            clearData: `Clear Data`,
            clearlyDefine: `Clearly define your program policy.`,
            close: `Close`,
            closed: `Closed`,
            closedAgo: `Closed {0} ago`,
            closedIn: `Closed in`,
            closedReport: `Closed report`,
            closedReports: `Closed reports`,
            closedTheReportAs: `closed the report as`,
            reopenedTheReport: `reopened the report`,
            code: `Code`,
            conclude: `Wrap up`,
            connectionDenied: `Connection denied`,
            connectionTime: `Approximate connection time`,
            connectionRefusedUserDisabled: `Connection refused, user disabled!`,
            connectionsPerUser: `connections per user`,
            contacts: `Contacts`,
            company: `Company`,
            completed: `Completed`,
            confirm: `Confirm!`,
            confirmAccountRemoval: `Confirm Account Removal`,
            confirmYourPassword: `Confirm your password!`,
            confirmProgramChanges: `Describe the changes that were made to the program`,
            congratulationsYourUsernameIsNowVerified: `Congratulations, your profile is now verified.`,
            invalidEmail: `Invalid email, please check and try again.`,
            continueReport: `Continue Report`,
            copiedId: `Copied id`,
            copyLink: `Copy link`,
            continue: `Continue`,
            creatAccountInvit: `Created account by invitation`,
            createA: `Create a`,
            created: `Created`,
            createMyAccount: `Create my account!`,
            critical: `Critical`,
            request_response: `Response`,
            request_closure: `Closure`,
            responseRequestReport: `requested a response to this report.`,
            reportClosureRequest: `requested closure of this report.`,
            day: `day`,
            days: `days`,
            dateTime: `Date/Time`,
            declined: `Declined`,
            dataChanged: `Data changed!`,
            dataWillBeRemovedWithPhoneValidation: `2fa data will be removed with phone validation!`,
            date: `Date`,
            declineThisInvitation: `Decline this Invitation!`,
            delimitDomains: `Delimit domains, subdomains, apps, and more`,
            delimitItems: `Delimite itens`,
            deleteUser: `Delete user`,
            depositedAmount:  `Deposited amount`,
            delimitationOfDomainsSubdomains: `Delimitation of domains, subdomains, applications and others`,
            describeALittleMoreAboutTheImpact: `Describe a little more about the impact!`,
            describeChangesMadeInProgram: `This summary will be available to all experts participating in this program!`,
            describeClearlyHowTheVulnerabilityWorks: `Describe clearly how the vulnerability works.`,
            describeInDetailTheImpactOfThisRepor: `Describe in detail the impact of this report.`,
            describeThePerformedTests: `Describe the performed tests`,
            describeTheTitleOfTheReport: `Describe the title of the report`,
            describeTheScope: `What is the url of the vulnerable application?`,
            description: `Description`,
            descriptionSubmitReport: `##### 1. Summary\\n(add vulnerability summary)\\n\\n##### 2. Description\\n(add more details about this vulnerability)\\n1. [add step]\\n\\n##### 3. Steps to reproduce\\n(Add details of how we can reproduce the problem)\\n1. [add step]\\n2. [add step]\\n3. [add step]\\n\\n##### 4. Support material/references\\n(e.g. screenshots, records, etc.) \\n1. Please list any additional materials\\n `, 
            descriptionCannotContainSpecialCharacters: `Description cannot contain special characters`,
            descriptionMustBeFromToCharacters: `Description must be from {f} to {l} characters.`,
            describeEditsMade: `Describe the edits made.`,
            details: `Details`,
            directoryName: `Directory name`,
            disable: `Disable`,
            domain: `Domain`,
            done: `Done`,
            doNotUseSpecialCharactersAndMalicious: `Do not use special characters and malicious payloads in the title, impact and summary, these items should be appended as .zip, .rar or .7z at the end of the report.`,
            doNotUseSpecialCharacters: `Do not send payloads with possible malicious code, these items must be appended as .zip, .rar or .7z!`,
            dontForgetToSaveYourChanges: `Don't forget to save your changes!`,
            downloadTheReportPDF: `Download the Report in PDF`,
            doYouHaveOrganizationAndDidYou: `Would you like to protect your company?`,
            doYouWantToRemoveThePhone: `Do you want to remove the phone ?`,
            doyoureallyWanttoDeleteVacancy: `Do you really want to delete this vacancy ?`,
            doYouReallyWantToRemoveTwoFactor: `Do you really want to remove Two-factor authentication ?`,
            doYouReallyWantToRemoveThisAccount: `Do you really want to remove this account ?`,
            doYouReallyWantToRemoveThis: `Do you really want to remove this {0} ?`,
            doYouWantToActivateTheProgram: `Do you want to activate the program ?`,
            doYouWantToContinue: `Do you want to continue with the fields already filled in ?`,
            doYouWantDisableProgram: `Do you want to disable the program ?`,
            doYouWantToPauseTheProgram: `Do you want to pause the program ?`,
            doYouWantToAddVPNToYourNewProgram: `Do you want to add VPN to your new program?`,
            editProgram: `Edit Program`,
            editNda: `Edit NDA`,
            eligible: `Eligible`,
            efficiencyMetrics: `Efficiency metrics`,
            emailAlreadyRegistered: `E-mail already registered`,
            emailAlreadyValidatedNonExistent: `Email already validated or expired!`,
            emailConfirmation: `Email confirmation`,
            emailDoesNotAppearToBeValid: `Email does not appear to be valid`,
            emailSuccessfullyValidated: `Email successfully validated!`,
            enableTwoFactorAuthentication: `Enable two-factor authentication`,
            end: `End`,
            enterNewTags: ` Enter new tags separating them with a comma`,
            enterPasswordConfirmation: `Enter password confirmation`,
            enterTheCode: `Enter the code`,
            enterTheCodeReceivedBySms: `Enter the code received by sms`,
            enterTheCompletePhone: `Enter the complete Phone`,
            enterTheDescriptionOfTheOrganization: `Enter the description of the organization`,
            enterTheEmail: `Enter the email`,
            enterTheNameOfTheOrganization: `Enter the name of the organization`,
            enterThePassword: `Enter the password`,
            enterTheUsername: `Enter the username`,
            enterTheScope: `Enter the scope of the program!`,
            enterUserName: `Enter user name`,
            enterYourEmail: `Enter your email`,
            enterYourFullName: `Enter your full name`,
            enterYourPayPalAccountEmail: `Enter your PayPal account email`,
            enterYourPrimaryEmailAddress: `Enter your primary email address!`,
            enterYourUserPassword: `Enter your user password`,
            enterYourRewardDetails: `Enter your reward details!`,
            evaluate_retest: `Evaluate retest`,
            evaluatedRetest: `Evaluated retest`,
            executiveSummary: `Executive summary of the organization`,
            exit: `Exit`,
            expertSuccessfullCreated: `{0} expert successfully created`,
            export: `Export`,
            exportLogs: `Export logs`,
            exportInCsv: `Export in .csv`,
            exportReports: `Export reports`,
            externalLinkNotice: `External link notice`,
            extract: `Extract`,
            extractedBy: `Extracted by`,
            fillInTheDetailsBelowTo: `Fill in the details below to change your password.`,
            fillInAllFieldHighlightedInRed: `Fill in all fields highlighted in red!`,
            filterByTags: `Filter by tags`,
            findSecurityJobsOnOurDashboard: `BugHunt connecting the community with the best companies.`, 
            forgotYourPassword: `Forgot your password ?`,
            forSecurityWeRequestYourPassword: `Due to security reasons, we require that you inform your password`,
            forYourSecurityToPDF: `For your security, you need to add a password to the PDF.`,
            fullName: `Full name`,
            generateNewCodes: `Generate new codes`,
            getAccessToExclusiveRewards: `Get access to exclusive rewards for this program!`,
            gift: `Gift`,
            giftsAndAcknowledgments: `Gifts and Acknowledgments`,
            guests: `Guests`,
            hackerControl: `Hacker Control`,
            haveYouRevised: `Have you revised your model? So ready!`,
            haveYouReviewedYourReportNow: `Have you reviewed your report? Now, let's send it for analysis!`,
            here: `here`,
            hereYouCanSetUpYourAccount: `Here you can set up your account to receive your rewards.`,
            high: `High`,
            historic: `Historic`,
            features: `Features`,
            iAlreadyHaveAnSccount: `I already have an account!`,
            iAlreadyRemembered: `I already remembered!`,
            iAgreeWithThe: `I agree with the `,
            ifYouDontReceiveIt: `If you don't receive it, you can try again at`,
            ifYouNeedToSubmitMoreComment: `If you need to submit more, just write another comment.`,
            impact: `Impact`,
            impactDescriptionCannotContainSpecialCharacters: `Impact description cannot contain special characters!`,
            inactivated: `inactivated`,
            inactiveUsers: `Inactive Users`,
            initProgramMessage: `Program started on `,
            informBugHuntPassword: `Enter the BugHunt platform password to confirm this operation.`,
            informThePhoneWithAreaCode: `Inform the phone with area code`,
            informTheRecommendations: `Inform the recommendations that the specialist will obtain if successful!`,
            informTheScope: `Inform the scope`,
            informTheScopeWhereTheThreatsAre: `Inform the scope where the threats are`,
            selectTheScopeType: `Select the scope type`,
            informTheImpact: `Inform the impact`,
            informTheUser: `Inform the user`,
            informTheWebsite: `Inform the website`,
            interationIdealTime: `The optimal average time to {interationType} is `,
            interviewWithExpertIgorRincon: `Interview with expert Igor Rincon`,
            invalidBackupCodeOrToken: `Invalid backup code or token`,
            invalidCode: `Invalid code`,
            invalidCodeOrToken: `Invalid code or token`,
            invalidDate: `Invalid date`,
            invalidData: `Invalid data`,
            invalidRegistrationData: `Invalid {0} registration data!`,
            invalidEmailOrPassword: `Invalid email or password!`,
            invalidPassword: `Invalid password`,
            invite: `Invite`,
            invitationAccepted: `Invitation accepted`,
            invitationDeclined: `invitation declined`,
            invitationLimitManagersReached: `The invitation limit for managers has been reached.`,
            invitationProgramLimitReached: `The invitation limit for the {program} program has been reached.`,
            invitationNotFoundOrExpired: `Invitation not found or expired!`,
            invitationsAccepted: `Invitations Accepted`,
            invitationsReceived: `Invitations Received!`,
            invitationRevoked: `Invitation revoked`,
            invitationSent: `Invitation sent`,
            invoiceValue: `Invoice value`,
            NdaCreated: `NDA Created `,
            inProgress: `In progress`,
            inRelationToTheReport: `In relation to the report`,
            inSomeCasesTheEmailMayFallAsSpam: `In some cases, the email may fall as spam.`,
            integration: `Integration`,
            integrations: `Integrations`,
            integrationsNotAvailable: `Integrations not available!`,
            inTheProgram: `in the program`,
            internal: `Internal`,
            invoices: `Invoices`,
            iPAdress: `IP adress`,
            issued: `Issued`,
            itHappensInTheBestFamilies: `It happens in the best families! Don't worry, just enter your email and we'll send you a new password.`,
            itHappensInTheBestFamiliesDonotworry: `It happens in the best families! Do not worry.`,
            itIsNotPossibleToEnterEqualRewards: `It is not possible to enter equal rewards!`,
            itIsNotPossibleToEnterMore: `It is not possible to enter more than 30 tags!`, 
            itIsNotPossibleToSubmitAnotherRetest: `Unable to submit retest assessment! <br /> Wait for the specialist's retest.`,
            iWantToCreateAnAccount: `I want to create an account!`,
            jobBoard: `Job Board`,
            jobDescription: `##### About the Company\\nDescribe here the details about your**company**\\n\\n##### About the Vacancy\\nWe are looking for a Professional whose main responsibilities will be:\\n- Responsibility 1. \\n- Responsibility 2. \\n- Responsibility 3. \\n\\n##### Requirements\\n- **Requirement 1: App.vue assets components helpers HTTP.js main.js ml.js ml_old.js parsed_ml parsed_ml_en parsed_ml_es parsed_ml_old router services state translate.sh translated_ml.js utils.js view Above x years of experience. \\n- **Requirement 2: App.vue assets components helpers HTTP.js main.js ml.js ml_old.js parsed_ml parsed_ml_en parsed_ml_es parsed_ml_old router services state translate.sh translated_ml.js utils.js view Above x years of experience. \\n- **Requirement 3: App.vue assets components helpers HTTP.js main.js ml.js ml_old.js parsed_ml parsed_ml_en parsed_ml_es parsed_ml_old router services state translate.sh translated_ml.js utils.js view Above x years of experience.`, 
            jobTitle: `Job Title`,
            joinedThePlatform: `Joined the platform`,
            lastReviewSubmittedAgo: `Last review submitted {0} ago`,
            lastInvitations: `Last Invitations Send`,
            last7daysOfAccess: `Last 7 days of access`,
            latestReports: `Latest reports`,
            letStartYourRegistrationAnd: `Let's start your registration and soon we'll get in touch with you to clarify any doubts and finalize your registration!`,
            letsCompleteYourRegistration: `Let's complete your registration!`,
            letsCreateYourAccount: `Let's create your account!`,
            letsCreateYourPreRegistration: `Let's create your pre-registration!`,
            lessThanMonthAgo: `less than a month ago`,
            like: `as`,
            limitScope: `Limit the scope and only the accesses that will be reconsidered!`,
            limitOutOfScope: `Which applications should not be tested?`,
            limitOfScopesPerProgramReached: `Limit of {0} scopes per program reached!`,
            linkToJob: `Job application link`,
            location: `Location`,
            longPeriodsImpactSpecialists: `Long waiting periods can impact specialists' engagement in this program.`,
            low: `Low`,
            makePayment: `Make a Payment`,
            makeAPayment: `Make a Payment`,
            makeSureYouHaveACompatibleAppLike: `Make sure you have a compatible app like `,
            makeYourAccessEvenMoreSecure: `Make your access even more secure`,
            manageAccess: `Manage who has access to the program.`,
            managementInvitations: `Management of received invitations.`,
            manageVPNforUsers: `Manage VPN for users of each program`,
            manageYourPlanInformation: `Manage your plan information.`,
            manageYourProgressPlatform: `Manage your progress on the BugHunt platform`,
            maximumLengthIsCharacters: `Maximum length is {0} characters`,
            maximumFilesPerComment: `Maximum 10 files per comment`,
            medianTimeToResolution: `Median time to resolution`,
            medianTimeToFirstResponse: `Median time to first response`,
            medium: `Medium`,
            metricDoesNotHaveEnoughDataYet: `There is not enough data to calculate this metric`,
            metricsDoesNotHaveEnoughDataYet: `There is still not enough data to calculate the metrics`,
            message: `Message`,
            messagePostedAgo: `message posted {time} ago`,
            messagePublishedDay: `message published on {day}`, 
            missedResponseTargetsReportsSent: `Missed response targets`,
            missedResponseTargetsResolved: `Missed response targets`,
            missedResponseTargetsBounty: `Missed response targets`,
            monthlyFee: `Monthly fee`,
            monthlyPayment: `Monthly payment`,
            moreOptions: `More options`,
            money: `Money`,
            myPlan: `My plan`,
            myBusiness: `My business`,
            nameChanged: `Name changed!`,
            nameOfAccountHolder: `Name of account holder!`,
            nameIsNotValid: `Name is not valid`,
            navigation: `Navigation`,
            needChangeDescription: `Use the template to make a detailed description`,
            ndaVerificationRequired: `Your profile is eligible to participate in the verification process!`,
            ndaChange: `NDA Change`,
            next: `Next`,
            new: `New`,
            newComment: `New comment`,
            newUsers: `New Users`,
            newPassword: `New password`,
            newPasswordAndConfirmation: `New password and confirmation are not the same!`,
            newReport: `New report`,
            none: `a`,
            noActivePrograms: `No active programs`,
            noInvitationAvailable: `No Invitation available`,
            noNotificationsAvailable: `No notifications available`,
            noPaymentsFound: `No payments found`,
            noProgramAvailable: `No program available`,
            noReportsFound: `No reports found`,
            noScopeAvailable: `No scope available!`,
            noSuggestionsAvailable: `No suggestions available`,
            noteValue: `Note Value`,
            notAvailableForThisPlan: `Not available for this Plan!`,
            notAuthorized: `Not authorized!`,
            shutdownRequested: `The closing of this report has already been requested!`, 
            replyNotificationTitle: `Response request`,
            closingRequestTitle: `Closure request`,
            replyRequestMessage: `A response has already been requested for this report!`,
            notificationResponseReport: `Attention! A response was requested for this report.`,
            shutdownNotificationMessage: `Attention! Closing of this report has been requested.`,
            notificationSeeRequest: `See request`, 
            requestSent: `Request sent successfully!`,
            reportResponseNotification: `Attention! A response to this report was requested.`,
            notEligible: `Not eligible`,
            noExpertsFound: `No experts found`,
            notificationUpdatedNDA: `The program confidentiality agreement {programName} has been updated! To continue participating in this program, you must review and accept the NDA.`,
            noUserAvailable: `No user available`,
            noVpnAccessLogFound: `No vpn access log found!`,
            nowTellUsLittle: `Now tell us a little about the program's policy!`,
            nowTellUsALittleBitAboutTheThreat: `Now tell us a little bit about the threat!`,
            ofReward: `of reward`,
            oneDayAgo: `one day ago`,
            oldPassword: `Old password`,
            outstandingPayments: `Outstanding payments`,
            open: `Open`,
            opssMatiDidntApproveYourData: `Opss, Mati didn't approve your data.`,
            other: `Other`,
            others: `Others`,
            otherTypes: `Other types`,
            outOfScope: `out of scope`,
            outOfScopeTitle: `Out of scope`,
            participating: `Participating`,
            password: `Password`,
            passwordChanged: `Password changed!`,
            passwordConfirmation: `Password Confirmation`,
            passwordsMustMatch: `Passwords must match`,
            pasteTheLinkIntoTheBodyOfTheDescription: `Paste the link into the body of the description.`,
            pause: `Pause`,
            paused: `Paused`,
            pauseProgram: `Pause program ?`,
            paymentFor: `Payment for`,
            paymentHistory: `Payment History`,
            paymentSummary: `Payment Summary`,
            paymentRequested: `Payment requested`,
            pending: `Pending`,
            pendingSubscription: `Pending Subscription`,
            permission: `Permission`,
            permissions: `Permissions`,
            pleaseMakeSureThatThisEmail: `Please make sure that this email is correct and that it belongs to you.`,
            phoneNumber: `Phone number`,
            phoneSuccessfullyRemoved: `Phone successfully removed!`,
            phoneValidation: `Phone validation`,
            platform: `Platform`,
            points: `Points`,
            pointsIn: `points in`,
            possibleDup: `Report possibly duplicate - Scope {scope} has already received reports referring to {CWE}`,
            possibleSpam: `Possible SPAM - We verified that expert {expert} sent multiple reports referring to {CWE} in scope {scope}.`,
            postedComment: `posted a comment `,
            postedImage: `posted an image`,
            previous: `Previous`,
            primaryEmail: `primary email`,
            primaryEmailReceiving: `Primary email for receiving information`,
            privacy: `Privacy`,
            privacyPolicy: `Privacy Policy`,
            private: `Private`,
            privateProgram: `private program`,
            profileInformation: `Profile Information`,
            profileVerifiedReleased: `Profile verification required`,
            program: `Program`,
            programs: `Programs`,
            programDetails: `Program details`,
            program_management: `Program Management`,
            programLifeCycle: `Program life cycle`,
            programsLimitReached: `{0} programs limit reached!`,
            programsIhaveAlreadyContributed: `Programs I have already contributed`,
            programPolicy: `Program Policy`,
            programPolicyMustBeInformed: `Program policy must be informed`,
            programPolicyMustBeBetweenAndCharacters: `Program policy must be between {f} and {l} characters.`,
            programRanking: `Program ranking`,
            programNdaMustBeBetweenAndCharacters: `The NDA content must be between {f} and {l} characters.`,
            programsPublishedOnTheWeb: `Programs published on the web can be accessed by experts not registered on the platform.`,
            programSuccessfullyChanged: `Program successfully changed`,
            programType: `Program Type`,
            programWith: `Program with {0}`,
            proofOfConceptLinks: `Proof-of-concept links are generally benign, but can often be accompanied by unintended consequences.`,
            setProgramNda: `Do you want to add an NDA contract to your new program?`,
            public: `Public`,
            publicInformation: `Public Information`,
            publicOrPrivateProgram: `Public or private program`,
            publicProgram: `public program`,
            publish: `Publish`,
            published: `Published`,
            publishedDaysAgo: `Published {0} ago`,
            publishProgramOnTheWeb: `Publish program on the Web ?`,
            publishToTheWeb: `Publish to the Web`,
            questionsAboutUrl: `Questions about {0}`,
            rankingDoesNotHaveEnoughDataYet: `Ranking does not have enough data yet`,
            rankingPosition: `Ranking {0}`,
            received: `Received`,
            receiveAdvertising: `Receive advertising emails`,
            receiveEmails: `Receiving E-Mails`,
            receiveAdvertisingEmails: `Receive emails from other profiles`,
            receiveNotificationsAboutNewReports: `Receive notifications about new reports directly on your management platforms`,
            referenceDate: `reference date`,
            refuseRetest: `Refuse retest`,
            refusedRetest: `refused retest`,
            registerBelowTheTags: `Register below the tags that will be used to classify the reports.`,
            registeredUsers: `Registered Users`,
            registeredVacancies: `Jobs`,
            registration: `Registration`,
            removeAccount: `Remove Account`,
            remove: `Remove`,
            removeFromWhitelist: `Remove from Whitelist`,
            removeFromBlacklist: `Remove from Blacklist`,
            removed: `Removed`,
            reportAllPossibleThreatData: `Report all possible threat data`,
            report: `Report`,
            reportID: `Report ID`,
            reportCreatedSuccessfully: `Report created successfully`,
            reportEvaluation: `Report evaluation`,
            reportPayments: `Report payments`,
            reports: `Reports`,
            reportSent: `Report sent`,
            reportsSent: `Reports sent`,
            reportTitle: `Report title`,
            reportedThatTheVulnerabilityIsFixed: `reported that the vulnerability is fixed`,
            reportedThatTheVulnerabilityIsNotPatched: `reported that the vulnerability is not patched`,
            reportedVulnerabilities: `Reported vulnerabilities`,
            vulnerabilities: `Vulnerabilities`,
            overviewSubTitle: `A managerial view of your account just for you`,
            summaryCard: `Summary of reports`,
            requestedPayment: `requested a payment`,
            requestedPaymentOf: `requested payment of`,
            requestedANewTestOfTheReport: `requested a new test of the report`,
            reset: `Reset`,
            rewardValue: `Reward value`,
            whatIsAnNda: `What is an NDA and how can it help your organization?`,
            whatIsAnNda2: `NDA is an acronym for Non-Disclosure-Agreements, or simply a confidentiality agreement.`,
            whatIsAnNda3: `He intends to protect industrial secrets, commercials, or any information that cannot be disclosed and must remain confidential among those who have access to it`,
            whatIsaVPNAndHow: `What is a VPN and how can it help your programs?`,
            reportTags: `Report tags`,
            requestNewPassword: `Request new password!`,
            requestRetest: `Request Retest`,
            requestSubscription: `Request Subscription`,
            requiredField: `Required field`,
            retestRequested: `Retest Requested`,
            requestedRetestPayment: `requested retest payment`,
            retestId: `Retest id`,
            retestSent: `Retest sent`,
            return: `Return`,
            resolved: `Resolved`,
            revoke: `Revoke`,
            revokeWebAccessToTheProgram: `Revoke Web access to the program ?`,
            revoked: `Revoked`,
            revokeAccess: `Revoke Access`,
            rewardAmount: `Reward Amount`,
            reward: `Reward`,
            rewardDetails: `Reward details`,
            rewards: `Rewards`,
            rewardsReceived: `Rewards Received`,
            rewardsWithFinancialValues: `Rewards with financial values`,
            save: `Save`,
            saveEditions: `Save editions`,
            saveNda: `Save NDA`,
            saveInformation: `Saving`, 
            scopePerProgram: `Scope per program`,
            scopesPerProgram: `Scopes per program`,
            search: `Search`,
            seconds: `seconds`,
            select: `Select`,
            selectAddAccount:  `Select "Add account" or "+" and scan the QR code below`,
            selectAScoreForTheReport: `Select a score for the report`,
            selectFile: `Select the file`,
            selectProgram: `Select a program`,
            selectLanguage: `Select a language`, 
            selectScopeType: `Select scope type`,
            selectTheThreat: `Select the threat!`,
            selectTheProgramScope: `Select the program's scope`,
            selectTheProgramImpact: `Select the program's impact`,
            selectTheReport: `Select the report`,
            selectTheScope: `Select the scope`,
            selectTheCWE: `Select the CWE`,
            selectTheVulnerability: `Select the vulnerability`,
            securityAnalyst: `Ex. Security Analyst`,
            send: `Send`,
            sentTheRetest: `Sent the retest`,
            sendMessage: `Send Message`,
            sent: `Sent`,
            sentTo: `Sent`,
            sentTheReport: `sent the report`,
            settings: `Settings`,
            severityReports: `Severity Reports`,
            severity: `Severity`,
            currentValue: `Current value`,
            finalValue: `Final Value`,
            showingResultsOfTotal: `Showing {results} out of {totalResults} results.`,
            since: `Since {0}`,
            sinceLastMonth: `since last month`,
            situation: `Situation`,
            scope: `Scope`,
            scopeLimitExceeded: `The program scopes limit has been exceeded.`,
            scopeListOfTheProgram: `Scope list of the program!`,
            score: `Score`,
            scoreHistory: `Score History`,
            scopeType: `Scope Type`,
            share: `Share`,
            smsCode: `SMS code`,
            smsCodeSent: `SMS code sent`,
            specialist: `Specialist`,
            specialistNotFound: `Specialist not found!`,
            standard: `Standard`,
            standoutCreate: `Stand out! Create a motivating title.`,
            start: `Start`,
            pauseMessage: `It was not possible to perform the action, as the campaign has not yet started.`,
            startAnAccountForOrganization: `Create an account for organization`,
            startWithRewards: `Start with rewards that have financial value`,
            statistics: `Statistics`,
            stateCity: `State`,
            status: `Status`,
            statusChanged: `Status changed!`,
            storeYourBackupCodes: `Store your backup codes`,
            subdomain: `Subdomain`,
            submittedDays: `Submitted {0} days ago`,
            submitComment: `Submit Comment`,
            submitForReview: `Submit for Review`,
            rewardNotice: `Reminder: This program offers double reward`,
            submitReport: `Submit Report`,
            submit_retest: `Submit retest`,
            successfullyGeneratedKeys: `Successfully generated keys!`,
            suggestions: `Suggestions`,
            suggestedReward: `Suggested Reward`,
            summary: `Summary`,
            superSimpleItDoesntEvenTake: `It's simple, it doesn't even take 1 minute. Just enter the data below and you're done! Your account is created.`,
            superSimpleItDoesntEvenTakeCompany: `It's simple, it doesn't even take 1 minute. Just enter the organization's common data and you're done! Your account will be submitted for review.`,
            support: `Support`,
            sureAddExpertBlacklist: `Are you sure you want to add this expert to the blacklist ?`,
            sureAddExpertWhiteList: `Are you sure you want to add this expert to the Whitelist?`, 
            sureRemoveExpertBlacklist: `Are you sure you want to remove this expert from the Blacklist ?`,
            sureRemoveExpertWhitelist: `Are you sure you want to remove this expert from the Whitelist ?`,
            successfullyCreatedProgram: `Successfully created program`,
            successfullyCreated: `successfully created`,
            acceptedNda: `The NDA has been accepted!`,
            openReports: `Open reports`,
            openYourApp: `Open your app.`,
            or: `or`,
            organizationName: `Organization name`,
            overallRanking: `Overall Ranking`,
            paidRetest: `If the &nbsp;<b>retest passes</b>, you will receive more&nbsp;<b>{0}</b>&nbsp;the bounty amount.`,
            tagsAreUsedToHelpIdentifyReports: `Tags are used to help identify reports.`,
            tagsForReports: `Tags for reports`,
            takeAction: `Take Action`,
            takeTheOpportunityToAcquireMoreComplete: `Take the opportunity to acquire more complete plans for your company`,
            talkDirectlyToOurOperators: `Talk directly to our operators.`,
            target: `{0} target`,
            telephone: `Telephone`,
            testDescriptionsMustBetweenCharacters: `Test descriptions must be between {f} and {l} characters`,
            tests: `Tests`,
            terms: `Terms`,
            termsAPolicy: `Terms and Policy`,
            termsOfUse: `Terms of use`,
            thanksForRegistering: `Thanks for registering!`,
            thankByEmail: `Thank by email`,
            theActionsTakenOnTheReportCannotBe: `The actions taken on the report cannot be removed`,
            theCommentNeedsToBeInformed: `The comment needs to be informed!`,
            theDescriptionTestsMustBeInformed: `The description of the tests must be informed`,
            theDescriptionOfTheProgramMustBeInformed: `The description of the program must be informed`,
            theImpactDescriptionMustBeInformed: `The impact's description must be informed`,
            theImpactDescriptionMustBetweenCharacters: `The impact description must be between {f} and {l} characters`,
            theIsNotValid: `The {0} is not valid`, 
            theFileIsNotValid: `The file is not valid!`,
            theNameMustBeFromToCharacters: `The name must be from {f} to {l} characters.`,
            theNameOfThePersonResponsibleIsMandatory: `The name of the person responsible is mandatory.`,
            theNameOfTheProgramMustBInformed: `The name of the program must be informed`,
            theNameWillBeAssignedToYourProgramsURL: `The name will be assigned to your program's URL.`,
            thenUseYourEmail: `Then use your email, your password and access our platform. If you have forgotten your password or your username, use the recovery option below!`,
            thePhoneIsNotValid: `The phone is not valid.`,
            theProgramDescriptionMustBeBetweenAndCharacters: `The program description must be between {f} and {l} characters!`,
            theProgramNameMustBeBetweenAndCharacters: `The program name must be between {f} and {l} characters`,
            thereIsAlreadyAprogram: `There is already a program registered with that name!`,
            thereIsAlreadyProgramSlug: `There is already a program registered with this slug!`,
            theReportNeedsToBeInformed: `The report needs to be informed`,
            theRetestMustBeSentWithinDays: `The retest must be sent within {0} days`,
            theRetestWasNotSubmitted: `The retest was not submitted!`,
            theRetestHaAlreadyAccepted: `The retest has already been accepted!`,
            theseSettingsDirectlyImpactTheAccessOfExperts: `These settings directly impact the access of experts.`,
            theScopeAddressMustBeInformed: `The scope address must be informed`,
            theThreatDescriptionMustBeInformed: `The threat description must be informed`,
            theThreatDescriptionMustBetweenCharacters: `The threat description must be between {f} and {l} characters`,
            theTitleMustBeInformed: `The title must be informed`,
            theTitleMustBeBetweenCharacters: `The title must be between {f} and {l} characters`,
            theWebhookIsNotValid: `The webhook is not valid!`,
            theWebsiteMustBeFromToCharacters: `The website must be from {f} to {l} characters`,
            thisChangeIsIrreversible: `This change is irreversible.`,
            thisInformationCanAppear: `This information can appear on your company's public profile, alongside your comments and in any of your reports.`,
            thisIsAnInternalSurvey: `This is an internal survey, experts will not have access to the data in this questionnaire.`,
            thisServiceCreatesAVPNResponsible: `This service creates a VPN, responsible for connecting and monitoring the data traffic of the specialist's tests to their scopes, and with that greater traceability and security.`,
            thisWeek: `this week`,
            threats: `Threats`,
            time: `Time`,
            timeToFirstResponse: `first response`,
            timeToBounty: `bounty`,
            timeToResolution: `close report`,
            title: `Title`,
            to: `to`,
            toAcceptThisInvitation: `To accept this invitation it is necessary to check in the Meta<b>Map</b>, after verification, wait a few minutes and refresh the page.`,
            tokenIsInvalid: `The token is invalid or has already been used`,
            toAddMorePrograms: `To add more programs check out our plans by clicking`,
            toAddMoreScopesToThe: `To add more scopes to the program check out our plans by clicking`,
            toAddMoreUsersCheck: `To add more users, check out our plans by clicking`,
            toAddTheseIntegrations: `To add these integrations check our plans by clicking`,
            toAddThisFeatureCheck: `To add this feature, check out our plans by clicking`,
            toChangeYourPlanContactSupport: `To change your plan, contact support.`,
            toCheck: `To check`,
            toConfirmWeNeedYourPassword: `To confirm we need your password`,
            toConfirmYourRegistrationOn: `To confirm your registration on our platform, click on the button below.`,
            today: `Today`,
            toDoThisYouNeedToEnterYourAppCode: `To do this you need to enter your app code or paste one of your backup tokens!`,
            topReportedCWE: `Top reported CWE`,
            totalConnectedHours: `Total connected hours`,
            totalEvents: `Total events`,
            totalMonthlyFees: `Total monthly fees`,
            totalReports: `Total reports`,
            totalReceived: `Total Received`,
            totalRewards: `Total rewards`,
            toTheProgram: `to the program`,
            totalSpent: `Total Spent`,
            totalSum: `Total Sum`,
            trackYourOpenReports: `Track your open reports`,
            twoFactorAuthentication: `Two factor authentication`,
            type: `Type`,
            typeOfContract: `Type of contract`,
            typeOrPasteOneOfYourBackupTokens: `Type or paste one of your backup tokens, remembering that each token can only be used once!`,
            typeProgramLimitExceeded: `The limit of {programType} programs has been exceeded`,
            unableToCompleteThisRequest: `Unable to complete this request.`,
            unableToSubmittedTheReport: `This report could not be submitted. Make sure all fields are filled in correctly.`,
            undefinedRanking: `Undefined Ranking`,
            uninformed: `Uninformed`,
            unshowPassword: `Hide password`,
            update: `Update`,
            updates: `Updates ({numberOfUpdates})`,
            updated: `Updated`,
            uploadFiles: `Upload files`,
            upTo: `Up to`,
            urlIsNotValid: `Url is not valid`,
            useBackupCode: `Use backup code ?`,
            user: `User`,
            userBlockedForOverTrying: `User blocked for over-trying, please try again later.`,
            userByCompany: `User by company`,
            userDisconnected: `User disconnected!`,
            userLimitReached: `User limit reached!`,
            userLoggedIn: `User logged in!`,
            usersByCompany: `Users by company`,
            userDoesNotHavPermissionToPerform: `User does not have permission to perform this action`,
            usernameHasInvalidCharacters: `Username has invalid characters`,
            usernameIsNotAvailable: `Username is not available!`,
            usernameMustBeFromCharacters: `Username must be from {f} to {l} characters long.`,
            users: `Users`,
            userEmail: `Username or email`,
            usersOnTheBlacklist: `Users on the Blacklist will not have access to this program!`,
            userRemoved: `User removed`,
            useYourAuthenticationAppToEnterTheCode: `Use your authentication app to enter the code`,
            validatePhone: `Validate phone`,
            validatedPhone: `Validated phone`,
            value: `Value`,
            verified: `Verified`,
            verifieds: `Verified`,
            vpnIP: `VPN IP`,
            waitingConfirmation: `Waiting confirmation`,
            wantSaveChangesProgram: `Do you really want to save the changes made to this program?`,
            waysExplore: `Ways to Explore`,
            weLeaveThisPanel: `We leave this panel for you to post your job advertisements to our specialists`, 
            whatIsBugBounty: `What is Bug Bounty`,
            whatIsYourAction: `What is your action?`,
            whatIsNdaHeader: `Stay tuned!`,
            whatPrograms: `What programs?`,
            whatTypeOfVulnerability: `What type of vulnerability is reported`,
            whoDoYouWantInvite: `Who do you want to invite?`,
            whiteMessage: `Write a message ...`,
            weakPasswordContain: `Weak password! it must contain: `,
            websiteInvitation: `Website invitation`,
            weSendAToast: `We send a gift`,
            weAreUnderMaintenance: `We are under maintenance! Get back soon!`,
            weTemporarilyStoreYourReport: `We temporarily store your report data for the program`,
            weWillContactYouShortly: `We will contact you shortly to confirm your details.`,
            wikiSubTitle: `We help as we can and as we cannot.`,
            withoutWebAccessTheProgram: `Without Web access, the program will only be available to platform users.`,
            workModel: `Work Model`,
            workSchedule: `Work Schedule`,
            yesIWantToRegister: `Yes, I want to register`,
            yes: `Yes`,
            no: `No`,
            youAcceptedThisInvitation: `You accepted this invitation`,
            youAreAboutToVisitLink: `You are about to visit an external link.`,
            youAreAllowedToViewTheReports: `You are allowed to view the reports.`,
            youCanUseOneOfTheseBackupCodes: `You can use one of these backup codes to log in if you lose access to your smartphone. Remember that each code can only be used once.`,
            yourCurrentPlanIsThe: `Your current plan is the`,
            youDoNotHaveAnyTagRegistered: `You don't have any Tag registered, to add access the <a href="/account?tags">My Account/Tags</a> menu`,
            youDontHave: `You don't have`,
            youDontHaveAnyAcceptedInvitations: `You don't have any accepted invitations yet!`,
            youDontHaveAnyInvitationsWaiting: `You don't have any invitations waiting for answers yet!`,
            youDontHaveAnyNDAs: `You don't have any programs with a confidentiality agreement yet!`,
            youDontHaveAnyNDAsHacker: `You haven't signed any confidentiality agreement yet!`,
            youDontHaveAnyProgramsInThisCategoryYet: `You don't have any programs in this category yet`,
            youDontHaveSubmittedReports: `You don't have any approved reports!`,
            youHave: `You have`,
            youHaveBeenInvitedToSend: `You have been invited to send reports to this program`,
            youHavePermissionToViewAndEditReports: `You have permission to view and edit reports.`,
            youMustAgreeToTheTermsOfUse: `You must agree to the terms of use.`,
            yourAccessPassword: `Your access password!`,
            yourAccesEmail: `Your {0} access email`,
            youReachedLimit: `You've reached your daily report submission limit!`,
            yourEmail: `Your email`,
            yourFullName: `Your full name!`,
            yourNameMustBeBetweenAndCharacters: `Your name must be between {f} and {l} characters!`,
            yourOrganizationNameIsRequired: `Your organization name is required`,
            YourOrganizationTradeName: `Your organization's trade name!`,
            yourPassword: `Your password`,
            yourPhoneToGetInTouch: `Your phone to get in touch!`,
            yourProfileIsNowAbleTo: `Your profile is now able to participate in the verification process!`,
            ndaVerificationRequired1: `You have been invited to join the program `,
            ndaVerificationRequired2: `A profile verification is required to accept that invitation!`,
            ndaVerificationRequired3: `Check your notification list and proceed with the verification process.`,
            noJobsFound: `No jobs found`,
            registrationDone: `Registration done!`,
            reportPaymentVerificationRequired1: `A bounty payment for the report `,
            reportPaymentVerificationRequired2: ` has been approved!`,
            reportSummaryNotValid: `The report summary is not valid!`,
            reportContentIsNotValid: `The report content is not valid!`,
            reportVulnerabilitIsNotValid: `Vulnerability impact is not valid!`,
            reportCriticalityIsNotValid: `Vulnerability criticality is not valid`,
            reportCantAcceptEspecialCaracter: ` ( Cannot enter special characters. )`,
            reportScopeIsNotValid: `The report scope identifier is not valid!`,
            reportIdentifierIsNotValid: `The program identifier is not valid!`,
            reportVulnerabilityIdentifierIsNotValid: `The vulnerability identifier is not valid!`,
            ndaVerificationRequired6: `A profile verification is required to proceed with the payment!`,
            reportTitleIsNotValid: `The report title is not valid!`,
            showPassword: `Show password`,
            companyNdaVerificationRequired: `First you need to create an NDA!`,
            taxesNotIncluded: `Taxes not included`,
            youAcceptedParticipateInThisProgram: `You have accepted to participate in this program.`,
            youCanCalculate: `You can calculate the severity using the calculator below`,
            youShouldConsiderUsingSeparate: `You should consider using a separate browser or a virtual machine before proceeding.`,
            yourSecurityPlatformAndBugReward: `Your Bug Bounty Platform`,
            youWereInvitedPartOf: `You were invited to be part of the {0} team, Just enter your account details.`,
            youWillBeRedirectedIn: `You will be redirected in`,
            youWillReceiveReportsFromCommunity: `You will receive reports from our community's security experts at no additional cost, minimizing the risk of your data being exposed or vulnerabilities exploited.`,
            invitationsSummary: `Invitations summary`,
            doubleReward: `Double reward`, 
            boostedProgram: `Boosted program!`, 
            doubleCampaignNotificationStarted: `Double campaign started`,
            doubleCampaignNotificationClosed: `Double campaign closed`,
            doubleCampaignNotificationPaused: `Double campaign paused`,
            doubleCampaignNotificationResumed: `Double campaign resumed`,
            campSubTitle: `Manage your campaigns! Follow all the details.`,
            historicCampaign: `Historic`,
            historicDoubleBounty: `Double bounty`,
            historicDoubleScore: `Double score`,
            inText: `From`, 
            until: `Until`,
            finished:  `Finished`,
            in_progress: `In progress`,
            situationCancel: `Canceled`,
            createdTh: `Created in`, 
            periodTh: `Period`,
            rewardsTh: `Rewards`,
            situationsTh: `Situations`,
            historicApproved: `Approved`,
            historicCancel: `Canceled`,
            historicPaused: `Paused`,
            historicFinished: `Finished`,
            notificationAttention: `Attention!`,
            notificationYourCampaignHasStarted: `Your campaign has started!`,
            notificationThisCampaign: `This campaign`,
            notificationHasClosed: `was closed`,
            notificationHasBeenPaused: `was paused`,
            keepAnEyeOutNotification: `keep an eye`,
            notificationWillLetYouKnowWhenToStartAgain: `we'll let you know when you start again.`,
            notificationThisCampaignIsLiveAgain: `This campaign is live again!`,
            finalDate: `End`,
            remain: `Remain`,
            campaignStarted: `The Double Rewards Campaign has started!`,
            campaignClosed: `The Double Rewards Campaign has ended!`,
            campaignPause: `The double rewards campaign has been paused!`,
            campaignReactivated: `The double rewards campaign has been reactivated!`,
            campaignFinalDays: `to the end of the campaign`,
            campaignInitialDays: `for the start of the campaign`,
            dayCampaign: `day`,
            daysCampaign: `days`,
            btnRegister: `Register`,
            btnCancel: `Cancel`,
            btnLabel: `select a date`,
            doubleBounties: `Double bounties`,
            doubleScore: `Double score`,
            activeDoubleCampaign: `Boost program:`,
            selectAPeriod: `Select a period`,
            monthlyRanking: `Monthly Ranking`,
            generalRanking: `General Ranking`,
            expertRating: `Check the ranking of BugHunt experts`,
            bountyOffer: `You are offering: Double Bounties`,
            bountyScore: `You are offering: Double Score`,
            bountyAndScoreOffer: `you are offering: Bounties and Double Score`,
            closeCampaign: `End double campaign`,
            pauseCampaign: `Double pause campaign`,
            reactivateCampaign: `Reactivate double campaign`,
            boostCampaign: `Boost program`,
            doubleCheckCampaign: `I am aware of changes to the current value of rewards.`,
            successfullyCreatedCampaign: `Request made successfully, please wait for campaign approval analysis!`,
            vpnMessage: `There is no vpn enabled in this program.`,
            campaignPaused: `Campaign paused successfully!`,
            doubleCampaignClosed: `Campaign ended successfully!`,
            doubleCampaignResumed: `Campaign successfully resumed!`, 
            registeredProgramWarning: `This program already has a campaign approved or locked less than 15 days ago.`,
            warningBoutiesOrScore: `The campaign must offer double bounties or scores!`,
            invalidDateMessage: `Invalid date, please check if the value has been filled in correctly!`,
            v_administrator: `administrator`,
            v_viewer: `viewer`,
            v_analyst: `analyst`,
            administrator: `Administrator`,
            viewer: `Viewer`,
            analyst: `Analyst`,
            v_private: `private`,
            v_public: `public`,
            v_internal: `internal`,
            v_new: `new`,
            v_under_review: `under review`,
            v_triaged: `triaged`,
            v_needs_information: `needs information`,
            v_approved: `approved`,
            v_informative: `informative`,
            v_duplicated: `duplicated`,
            v_not_applicable: `not applicable`,
            v_spam: `spam`,
            v_accepted: `Accepted`,
            v_pending: `Pending`,
            v_declined: `Declined`,
            v_revoked: `Revoked`,
            v_pending_retest: `Retest`,
            v_retest_done: `Retest done`,
            retest_done: `Retest done`,
            pending_retest: `Pending Retest`,
            notImpact: `Severity not reported`,
            lowImpact: `Low severity`,
            mediumImpact: `Medium severity`,
            highImpact: `High severity`,
            criticalImpact: `Critical severity`,
            approved: `Approved`,
            informative: `Informative`,
            duplicated: `Duplicated`,
            not_applicable: `Not Applicable`,
            spam: `Spam`,
            comment: `Post a comment`,
            change_situation: `Change situation`,
            update_severity: `Update severity`,
            request_update: `Request update`,
            retest: `Request retest`,
            pay_bounty: `Pay bounty`,
            close_report: `Close report`,
            reopen_report: `Reopen report`,
            needs_information: `Needs information`,
            under_review: `Under review`,
            triaged: `Triaged`,
            plan_trial: `Trial Plan`,
            plan_bronze: `Bronze Plan`,
            plan_silver: `Silver Plan`,
            plan_gold: `Gold Plan`,
            trial: `Trial`,
            bronze: `Bronze`,
            silver: `Silver`,
            gold: `Gold`,
            fulltime: `Full-time`,
            parttime: `Part-time`,
            clt: `CLT`,
            pj: `PJ`,
            autonomous: `Autonomous`,
            cltflex: `CLT-Flex`,
            cooperative: `Cooperative`,
            internship: `Internship`,
            hybrid: `Hybrid`,
            office: `Office`,
            remote: `Remote`, 
            web:  `Web application`,
            api:  `API`,
            mobileapplication:  `Mobile application`,
            mobileapplicationandroid:  `Mobile application android`,
            mobileapplicationios:  `Mobile application ios`, 
            ip:  `Endereço de IP`,
            january: `January`, 
            february: `February`, 
            march: `March`, 
            april: `April`, 
            may: `May`, 
            june: `June`, 
            july: `July`, 
            august: `August`, 
            september: `September`, 
            october: `October`, 
            november: `November`, 
            december: `December`, 
            seeOriginalText: `See original text.`, 
            waiting_for_information: `Awaiting information`, 
            severity_updated: `Gravity updated`, 
            retest_requested: `Restest request`, 
            bounty_paid: `Paid reward`, 
            close_as_approved: `Close as approved`, 
            close_as_informative: `Close as newsletter`, 
            close_as_spam: `Close as spam`, 
            close_as_duplicated: `Close as duplicate`, 
            close_as_not_applicable: `Close as not applicable`, 
            select_option: `Select an option`, 
            deleteMessageAlert: `Are you sure you want to delete this message?`, 
            automaticMessage: `When selecting the option, the automatic response will be recorded as a first interaction in the report.`, 
            defaultMessageCenterMenu: `Standard Messaging Center`, 
            registerNotFound: `No records were found.`, 
            registeredMessageTitle: `Registered messages`, 
            customSettingsTitle: `Custom settings`, 
            customSettingsSubtitle: `Configuring messages for standard replies`, 
            addMessageButton: `Add message`, 
            existingMessageAlert: `It is possible to register only one message per message type. Currently, all messages are already registered!`, 
            editMessage: `Edit Message`, 
            registerMessage: `Register Message`, 
            placeholderTitleMessage: `Title of the message`, 
            placeholderTextAreaMessage: `Add a description...`, 
            labelAutomatic: `Automatic`, 
            alertMessageSuccess: `Message successfully registered!`, 
            alertMessageUpdate: `Message updated successfully!`, 
            swalTokenRemoved: `The token was successfully deleted.`, 
            deleteTokenCompany: `Delete token`, 
            placeholderTokenCompany: `Enter a token`, 
            errorToken: `The token must contain a minimum of 20 characters and a maximum of 500 characters!`, 
            emailNotification: `The email notification was successfully activated!`, 
            enableEmailNotification: `Enable the receipt of program updates via email address.`, 
            emailNotificationDisabled: `The notification sent by e-mail has been deactivated!`, 
            china: `China`, 
            india: `India`, 
            estadosUnidos: `United States`, 
            indonesia: `Indonesia`, 
            paquistao: `Pakistan`, 
            brasil: `Brazil`, 
            nigeria: `Nigeria`, 
            bangladesh: `Bangladesh`, 
            russia: `Russia`, 
            mexico: `Mexico`, 
            japao: `Japan`, 
            etiopia: `Ethiopia`, 
            filipinas: `Filipinas`, 
            egito: `Egypt`, 
            vietna: `Vietnam`, 
            repuplicaDemocraticaDoCongo: `Democratic Republic of the Congo`, 
            turquia: `Turkey`, 
            ira: `Iran`, 
            alemanha: `Germany`, 
            tailandia: `Thailand`, 
            reinoUnido: `United Kingdom`, 
            franca: `France`, 
            italia: `Italy`, 
            tanzania: `Tanzania`, 
            africaDoSul: `South Africa`, 
            mianmar: `Myanmar (Burma)`, 
            coreiaDoSul: `South Korea`, 
            colombia: `Colombia`, 
            quenia: `Kenya`, 
            espanha: `Spain`, 
            ucrania: `Ukraine`, 
            uganda: `Uganda`, 
            sudao: `Sudan`, 
            angertina: `Argentinean`, 
            angelia: `Algeria`, 
            iraque: `Iraq`, 
            polonia: `Poland`, 
            canada: `Canada`, 
            uzbequistao: `Uzbekistan`, 
            arabiaSaudita: `Saudi Arabia`, 
            br: `Portuguese`, 
            en: `English`, 
            es: `Espanol`, 
            fr: `French`, 
            it: `Italiano`, 
            ru: `Russian`, 
            de: `Deutsch`, 
            jp: `Japanese`, 
            cn: `Chinese`, 
            pl: `Polish`, 
            ua: `Ukrainian`, 
            sd: `Arabe`, 
            kr: `Korean`, 
            in: `Hindi`, 
            id: `Indonesian`, 
            pk: `Urdu`, 
            bd: `Bengali`, 
            et: `Amharic`, 
            ph: `Filipino (Tagalog)`, 
            vn: `Vietnamese`, 
            tr: `Turkish`, 
            ir: `Persian`, 
            th: `Thai`, 
            za: `Afrikaans`, 
            mm: `Burmese`, 
            ug: `Swahili`, 
            uz: `Uzbek`, 
            sa: `Arabe`, 
            additionalMoreLanguages: `Add more language`, 
            country: `Country`, 
            language: `Language`, 
            clearText: `Use the standard message`, 
            selectCountry: `Select a country`, 
            basic: `Basic`, 
            proficiency: `Proficiency`, 
            conversational: `Conversational`, 
            fluent: `Fluent`, 
            native: `Native or bilingual`, 
            AreYouSureYouWantToCompleteTheRequest: `Are you sure you want to complete this request?`, 
            managers: `Managers`, 
            manageProgram: `Define who will manage your new program.`, 
            config: `Setups`, 
            programSettings: `Program settings`, 
            programEditAlert: `Attention! It is not possible to edit inactive programs or programs awaiting approval.`, 
            changeSettings: `Change settings`, 
            managersWithAccesToTheProgram: `Managers with access to the program`, 
            freeAccess: `Access released`, 
            pendingInviteAlert: `Attention! There is already a pending invitation associated with this email address.`, 
            USDT: `Dollar`, 
            BRL: `Real`, 
            selectCurrencyType: `Select currency type`, 
            passwordSuccess: `Password successfully registered!`, 
            isNan: `The value entered must be numeric.`, 
            //translation_script_end_en
        }),

        new MLanguage("spanish").create({ 
            ln: "es",
            //translation_script_start_es
            agreementText: `¿Está de acuerdo con los términos del acuerdo de confidencialidad?`, 
            agree: `Estoy de acuerdo`, 
            doNotAgree: `No estoy de acuerdo`, 
            programWithNda: `¡Este programa tiene un NDA vinculado!`, 
            ndaAccepted: `¡No se acepta nada!`, 
            programWithoutNda: `¡Este programa todavía no tiene un NDA vinculado!`, 
            menuProgram: `Horarios`, 
            menuReport: `Informes`, 
            menuAccount: `Mi cuenta`, 
            navInvitations: `Invitaciones`, 
            navPayments: `Pagos`, 
            navCreateNda: `Crear un modelo de NDA`, 
            navEditNda: `Editar NDA`, 
            navPrograms: `Horarios`, 
            navPublished: `Publicado`, 
            navClosed: `Inactivo`, 
            navNda: `NDA`, 
            navAll: `Todos`, 
            navPending: `Pendiente`, 
            navRetest: `Vuelva a probar`, 
            dashTitle: `Bienvenida {0}!`, 
            dashSubTitle: `Un resumen y un acceso rápido a tu cuenta solo para ti`, 
            dashReportResolv: `Informes aprobados`, 
            navAverage: `Recompensas promedio`, 
            dashMsgYouHave: `¿Tienes`, 
            dashMsgYouDHave: `No tienes`, 
            msgProgramPu: `programas públicos!`, 
            msgProgramPr: `programas privados!`, 
            dashMsgGP: `Administre sus programas.`, 
            dashMsgCP: `¿registrar un programa ahora?`, 
            dashInvTitle: `¡invita a especialistas!`, 
            dashInvSubTitle: `Invite a especialistas a participar en sus programas.`, 
            dashPayTitle: `Pagos!`, 
            dashPaySubTitle: `Resumen financiero y solicitudes de pago.`, 
            dashNdaTitle: `¡Acuerdos de confidencialidad!`, 
            dashNdaSubTitle: `Administre los acuerdos de confidencialidad de sus programas.`, 
            dashCreatNdaTitle: `¡Plantilla estándar de NDA!`, 
            dashCreatNdaSubTitle: `Cree una plantilla estándar para gestionar los acuerdos de confidencialidad de sus programas.`, 
            dashCreatNdaAbriefsummary: `Un breve resumen para que el experto entienda de qué se trata...`, 
            dashCreatNdaDesc: `NdA es un acrónimo en inglés de Non-Disclosure-Agreements, o simplemente acuerdo de confidencialidad de la información. Su objetivo es proteger los secretos industriales, los secretos comerciales o cualquier información que no pueda divulgarse y debe mantenerse confidencial entre quienes tienen acceso a ella.`, 
            dashCreatNdaWriteTerms: `Escriba los términos de su acuerdo de confidencialidad y sus peculiaridades.`, 
            dashCreatNdawritePaste: `¡Comencemos, escribe o pega tus términos!`, 
            dashCreatNdaWantAttach: `¿Quieres adjuntar un documento para firmarlo?`, 
            progTitle: `¡Visión general!`, 
            progSubTitle: `Rastrea y administra tus programas en bugHunt.`, 
            progPubTitle: `¡Programas publicados!`, 
            progPubSubTitle: `¡administre sus programas publicados! Mantente al día de todos los detalles.`, 
            progCampTitle: `Campañas`, 
            progClosTitle: `¡Programas inactivos!`, 
            progClosSubTitle: `¿Te lo perdiste? Consulte los datos de los programas inactivos.`, 
            progCreateTitle: `Crear un programa`, 
            progCreateSubTitle: `¡Un momento emocionante, es hora de empezar a crear tu programa!`, 
            progRankTitle: `Ranking de contribuciones!`, 
            progRankSubTitle: `Vea quién contribuye más a sus programas.`, 
            progRankSendThank: `¡Envía un agradecimiento!`, 
            progRankBtnSendThank: `Enviar agradecimiento`, 
            progTimelineTitle: `¡Programas cronológicos!`, 
            progTimelineSubTitle: `Siga la cronología de sus programas`, 
            repTitle: `Informes!`, 
            repSubTitle: `Administre los informes enviados por los especialistas a sus programas.`, 
            repSubTitleHacker: `Administrar los informes enviados a los programas.`, 
            repDetMsgAlter: `¡Los cambios realizados en el informe no se pueden deshacer!`, 
            ccpTitle: `¿vamos a crear un programa?`, 
            ccpProgPubli: `Programa público`, 
            ccpProgPubliDesc: `¡cree un programa donde todos los especialistas registrados puedan ver y enviar informes!`, 
            ccpProgVDPDesc: `¡cree un programa donde todos los especialistas puedan ver y enviar informes!`, 
            ccpProgPriv: `Programa privado`, 
            ccpProgPrivDesc: `¡cree un programa donde solo los especialistas seleccionados puedan ver y enviar informes!`, 
            managedProgram: `Programa gestionado`, 
            protectedByNDA: `Protegido por un NDA`, 
            helpTitle: `¿necesitas ayuda?`, 
            helpProgram: `¿Cómo funciona un programa?`, 
            helpDifference: `¿Cuál es la diferencia entre privado y público?`, 
            helpaverage: `¿Cuál es el promedio aplicado a una recompensa?`, 
            rankTitle: `Clasificación de contribuciones`, 
            retest_confirmed: `Revestido`, 
            retest_denied: `La falla persiste`, 
            accountSubTitle: `Un resumen y un acceso rápido a tu cuenta solo para ti.`, 
            accountAcSubTitle: `Quién, cuándo y cómo accedió a tu cuenta`, 
            accountTerSubTitle: `Accede a nuestros términos y política de privacidad`, 
            accountUserSubTitle: `Administrar quién tiene acceso a la organización.`, 
            accountSettSubTitle: `Cómo desea recibir sus correos electrónicos, política de privacidad y otros.`, 
            aboutUs: `Acerca de nosotros`, 
            aboutYou: `Acerca de ti`, 
            aboutYourAccount: `Acerca de tu cuenta`, 
            aboutTheProgramPolicy: `¡sobre la política del programa!`, 
            add: `Agregar`, 
            addUser: `Agregar usuario`, 
            addAcomment: `Añadir un comentario`, 
            addExpertToBlacklist: `Agregar un experto a la lista negra`, 
            addTheScopesHere: `¡agrega los osciloscopios aquí!`, 
            addOutOfScopesHere: `¡agregue aquí las aplicaciones que deben evitarse durante las pruebas de seguridad!`, 
            addYourPayPalAccount: `Agrega tu cuenta PayPal`, 
            adjustedTheImpactTo: `Ajusta el impacto a`, 
            adjustedTheImpactFrom: `ajustó el impacto de`, 
            adjustMetrics: `Ajustar métricas`, 
            allowedFiles: `Archivos permitid`, 
            alreadyHaveAccount: `¿Ya tienes una cuenta?`, 
            accepted: `Aceptada`, 
            acceptThisInvitation: `¡Acepta esta invitación!`, 
            access: `Accesiones`, 
            accessControl: `Control de acceso`, 
            accessMyAccount: `¡accede a mi cuenta!`, 
            accessProfile: `Perfil de acceso`, 
            accessInformation: `Acceder a la información`, 
            accountCreatedSuccessfully: `¡Cuenta creada correctamente!`, 
            accountDeleted: `Cuenta eliminada`, 
            accountRecovery: `Recuperación de cuenta`, 
            accurate: `Comprobado`, 
            activate: `Activar`, 
            activated: `Habilitado`, 
            additionalServices: `Servicios adicionales`, 
            addOtherRewardsHere: `¡agrega otras recompensas aquí!`, 
            addToBlacklist: `Agregar a la lista negra`, 
            agreementSpecialists: `Especialistas en acuerdos`, 
            ago: `Hay {0}`, 
            aGoodPolicAvoids: `Una buena política evita problemas, si tienes algún problema contacta con nosotros.`, 
            all: `Todos`, 
            gatTagOptDescription: `Solo los informes que contienen la etiqueta GAT`, 
            gatTagDescription: `¿qué informes se enviarán a la plataforma GAT?`, 
            allowMobileAccess: `Permitir el acceso al teléfono móvil`, 
            allowedToPayReward: `Se le permite pagar recompensas.`, 
            allThePrograms: `Todos los programas`, 
            allStatus: `Todos los estados`, 
            aLowercaseLetter: `Una letra minúscula. `, 
            anEmailContainingPasswordReset: `Se ha enviado un correo electrónico con instrucciones para restablecer la contraseña.`, 
            aNewValidationEmailHasBeenSenToYou: `Se le ha enviado un nuevo correo electrónico de validación, compruebe su buzón`, 
            aNewSuperStrongPassword: `¡una nueva contraseña súper segura!`, 
            annotation: `Nota`, 
            aNumber: `Un número. `, 
            anUppercaseLetter: `Una letra mayúscula. `, 
            anyQuestionsAboutIntegration: `¿Tiene preguntas sobre esta integración?`, 
            application: `Aplicación`, 
            applicableReport: `Informe aplicable`, 
            approvedReports: `Informes aprobados`, 
            approveWithoutRetest: `¿Realmente desea cerrar el informe como aprobado antes de solicitar una nueva prueba?`, 
            approveRetest: `Aprobar la repetición de la prueba`, 
            approvedRetest: `Pasó la nueva prueba`, 
            areYouSureYouWantToDeleteThisUser: `¿Estás seguro de que deseas eliminar este usuario?`, 
            as: `como`, 
            aSuperStrongPasswordNow: `¡una contraseña súper segura ahora!`, 
            atBugHuntYouWillFindPrograms: `En bugHunt encontrarás programas para probar diferentes tipos de tecnologías, poner en práctica tus conocimientos y probar aplicaciones reales de forma ética y legal.`, 
            attention: `¡Atención!`, 
            atLeastCharacters: `Al menos 6 caracteres. `, 
            authentication: `Autenticación`, 
            averageTicket: `Billete mediano`, 
            average_time_to_bounty: `Tiempo promedio para pagar una recompensa`, 
            average_time_to_first_response: `Tiempo promedio de la primera respuesta`, 
            average_time_to_resolution: `Tiempo promedio para cerrar el informe`, 
            averageTimeToBounty: `Tiempo medio de pago`, 
            avgTimeToBounty: `El tiempo medio transcurrido desde la primera interacción de la empresa con un informe hasta la solicitud de pago de una recompensa.`, 
            avgTimeToFirstResponse: `El tiempo medio transcurrido desde la presentación del informe hasta la primera interacción de la empresa con el informe.`, 
            avgTimeToResolution: `El tiempo medio transcurrido desde la apertura de un informe hasta su cierre.`, 
            awaitingAcceptance: `esperando la aceptación`, 
            awaitingPayment: `Esperando el pago`, 
            paymentReceived: `Pago recibido`, 
            awaitingResponse: `Esperando respuesta`, 
            award: `Concesión`, 
            backupCodesLeft: `códigos de respaldo restantes`, 
            balance: `Equilibrio`, 
            basedLast90Day: `Basado en los últimos 90 días`, 
            beforeActivatingTwoFactorAuthentication: `Antes de activar la autenticación de dos factores, debes validar tu teléfono.`, 
            beforeContinuingYouNeed: `¡antes de continuar es necesario validar tu correo electrónico!`, 
            billingCreditCard: `Tarjeta de crédito de facturación`, 
            billingForms: `Formularios de facturación`, 
            billingInformation: `Información de facturación`, 
            byActivatingTheProgramSpecialistsWill: `¡Al activar el programa, los especialistas podrán enviar nuevos informes!`, 
            byPausingTheProgramExpertsWill: `Cuando el programa esté en pausa, ¡los especialistas ya no podrán enviar nuevos informes!`, 
            bounty: `Financiero`, 
            bountyAwarded: `Recompensa otorgada`, 
            bugBountyAndTheSecurityParadox: `Bug Bounty y la paradoja de la seguridad`, 
            bugHuntIsTheFirstBrazilianBugBounty: `<b>BugHunt</b> es la primera plataforma brasileña de Bug Bounty, y ahora está en asociación con <b>AME Digital</b> con el propósito de democratizar el acceso a la seguridad de la información y, por lo tanto, hacer de Internet un lugar más seguro.`, 
            ongoingProfileVerification: `¡tu perfil está siendo verificado!`, 
            cancel: `Cancelar`, 
            cannotEnterEqualScopes: `No es posible introducir ámbitos iguales`, 
            cannotEnterSpecialCharacters: `No es posible introducir caracteres especiales`, 
            cautionNDA1: `Al redactar el NDA de su empresa, asegúrese de que incluya los siguientes element`, 
            cautionNDA2: `contener al menos una cláusula de penalización en caso de incumplimiento;`, 
            cautionNDA3: `informar a las partes que asumen ese compromiso;`, 
            cautionNDA4: `contener una fecha de caducidad;`, 
            cautionNDA5: `detalle específicamente a qué se refiere esa NDA, ya que la información genérica y ambigua caracteriza erróneamente el documento legal;`, 
            cautionNDA6: `Usa la etiqueta `, 
            cautionNDA7: `para hacer referencia al nombre del especialista;`, 
            cautionNDA8: `La plantilla de NDA que aparece a continuación es ilustrativa. Asegúrese de proporcionar correctamente los datos de su empresa al redactar el acuerdo de confidencialidad `, 
            changeAccessPassword: `Cambiar la contraseña de acceso`, 
            changePassword: `Cambiar contraseña`, 
            changePermission: `Cambiar permiso`, 
            changedReportSeverity: `Cambio en la severidad del informe`, 
            changedReportStatus: `Estado del informe modificado`, 
            changedTheStatusFrom: `cambió la situación de {f} a {l}`, 
            changedTheSituationTo: `cambió la situación a {0}`, 
            changedTheTitleOf: `cambió el título del informe de {f} a {l}`, 
            changedTheTitleTo: `cambió el título del informe a {0}`, 
            changedTheVisibilityOf: `cambió la visibilidad de {f} a {l}`, 
            changedTheVisibilityTo: `cambió la visibilidad a {0}`, 
            checkOutAllFieldsHighlightedInRed: `¡echa un vistazo a todos los campos resaltados en rojo!`, 
            chooseANicknameYoursAlone: `¡elige un apodo para que sea solo tuyo!`, 
            city: `Pueblo`, 
            clickHereToLearn: `Obtener más información.`, 
            clearData: `Borrar datos`, 
            clearlyDefine: `Defina claramente la política de su programa.`, 
            close: `Adjunto`, 
            closed: `Terminado`, 
            closedAgo: `Cerrado {0} días`, 
            closedIn: `Cerrado en`, 
            closedReport: `Informe cerrado`, 
            closedReports: `Informes cerrados`, 
            closedTheReportAs: `Cerró el informe como`, 
            reopenedTheReport: `Reabrió el informe`, 
            code: `Código`, 
            conclude: `Concluir`, 
            connectionDenied: `Conexión denegada`, 
            connectionTime: `Tiempo aproximado de conexión`, 
            connectionRefusedUserDisabled: `Conexión rechazada, usuario desactivado!`, 
            connectionsPerUser: `Conexiones por usuario`, 
            contacts: `Enlaces`, 
            company: `Compromiso`, 
            completed: `Completado`, 
            confirm: `¡confirma!`, 
            confirmAccountRemoval: `Confirme la eliminación de la cuenta`, 
            confirmYourPassword: `¡confirma tu contraseña!`, 
            confirmProgramChanges: `Describa los cambios realizados en el programa`, 
            congratulationsYourUsernameIsNowVerified: `Felicidades, tu usuario ya está verificado.`, 
            invalidEmail: `Correo electrónico no válido, compruébalo e inténtalo de nuevo.`, 
            continueReport: `Continuar con el informe`, 
            copiedId: `ID copiado`, 
            copyLink: `Copiar enlace`, 
            continue: `Continuar`, 
            creatAccountInvit: `Creó la cuenta por invitación`, 
            createA: `Crear un`, 
            created: `Creado!`, 
            createMyAccount: `¡crea mi cuenta!`, 
            critical: `Sentencioso`, 
            request_response: `Respuesta`, 
            request_closure: `Juicio hipotecario`, 
            responseRequestReport: `solicitó una respuesta a este informe.`, 
            reportClosureRequest: `solicitó el cierre de este informe.`, 
            day: `día`, 
            days: `días`, 
            dateTime: `Fecha/hora`, 
            declined: `Rechazado`, 
            dataChanged: `¡datos cambiados!`, 
            dataWillBeRemovedWithPhoneValidation: `¡Los datos de 2fa se eliminarán con la validación del teléfono!`, 
            date: `Cita`, 
            declineThisInvitation: `¡rechace esta invitación!`, 
            delimitDomains: `Delimitar dominios, subdominios, aplicaciones y más`, 
            delimitItems: `Delimitar artículos`, 
            deleteUser: `Eliminar usuario`, 
            depositedAmount: `Contribuciones totales`, 
            delimitationOfDomainsSubdomains: `Delimitar dominios, subdominios, aplicaciones y otros`, 
            describeALittleMoreAboutTheImpact: `¡Describa un poco más sobre el impacto!`, 
            describeChangesMadeInProgram: `¡Este resumen estará disponible para todos los especialistas que participan en este programa!`, 
            describeClearlyHowTheVulnerabilityWorks: `Describa claramente cómo funciona la vulnerabilidad.`, 
            describeInDetailTheImpactOfThisRepor: `Describa en detalle el impacto de este informe.`, 
            describeThePerformedTests: `Describa las pruebas realizadas`, 
            describeTheTitleOfTheReport: `Describa el título del informe`, 
            describeTheScope: `¿Cuál es la URL de la aplicación vulnerable?`, 
            description: `Descripción`, 
            descriptionSubmitReport: `##### 1. Resumen\\n(añadir resumen de vulnerabilidad)\\n\\n##### 2. Descripción\\n(añada más detalles sobre esta vulnerabilidad)\\n1. [agregar paso]\\n##### 3. Pasos para reproducir\\n(añada detalles sobre cómo podemos reproducir el problema)\\n1. [añadir paso]\\n2. [añadir paso]\\n3. [añadir paso]\\n\\n##### 4. Material o referencias de apoyo\\n(p. ej., capturas de pantalla, registros, etc.) \\n1. Enumere cualquier material adicional\\n `, 
            descriptionCannotContainSpecialCharacters: `La descripción no puede contener caracteres especiales`, 
            descriptionMustBeFromToCharacters: `La descripción debe tener entre {f} y {l} caracteres.`, 
            describeEditsMade: `Describa las ediciones realizadas.`, 
            details: `Detalles`, 
            directoryName: `Nombre del directorio`, 
            disable: `Deshabilitar`, 
            domain: `Maestría`, 
            done: `Pagado`, 
            doNotUseSpecialCharactersAndMalicious: `No utilices caracteres especiales ni cargas maliciosas en el título, el impacto y el resumen; estos elementos deben adjuntarse como.zip, .rar o.7z al final del informe.`, 
            doNotUseSpecialCharacters: `No envíes cargas con posibles códigos maliciosos, estos elementos deben adjuntarse como.zip, .rar o.7z!`, 
            dontForgetToSaveYourChanges: `¡no olvides guardar los cambios!`, 
            downloadTheReportPDF: `Descargue el informe en PDF`, 
            doYouHaveOrganizationAndDidYou: `¿le gustaría proteger su empresa?`, 
            doYouWantToRemoveThePhone: `¿Quieres quitar el teléfono?`, 
            doyoureallyWanttoDeleteVacancy: `¿Realmente deseas eliminar esta vacante?`, 
            doYouReallyWantToRemoveTwoFactor: `¿De verdad quieres eliminar la autenticación de dos factores?`, 
            doYouReallyWantToRemoveThisAccount: `¿De verdad quieres eliminar esta cuenta?`, 
            doYouReallyWantToRemoveThis: `¿De verdad quieres eliminar este {0}?`, 
            doYouWantToActivateTheProgram: `¿quieres activar el programa?`, 
            doYouWantToContinue: `¿Quieres continuar con los campos ya rellenados?`, 
            doYouWantDisableProgram: `¿quieres desactivar el programa?`, 
            doYouWantToPauseTheProgram: `¿quieres pausar el programa?`, 
            doYouWantToAddVPNToYourNewProgram: `¿Quieres añadir una VPN a tu nuevo programa?`, 
            editProgram: `Editar programa`, 
            editNda: `Editar NDA`, 
            eligible: `Elegible`, 
            efficiencyMetrics: `Métricas de eficiencia`, 
            emailAlreadyRegistered: `El correo electrónico ya está registrado`, 
            emailAlreadyValidatedNonExistent: `¡el correo electrónico ya ha sido validado o ha caducado!`, 
            emailConfirmation: `Confirmación por correo electrónico`, 
            emailDoesNotAppearToBeValid: `El correo electrónico no parece ser válido`, 
            emailSuccessfullyValidated: `Correo electrónico validado correctamente!`, 
            enableTwoFactorAuthentication: `Habilitar la autenticación de dos factores`, 
            end: `Definitivo`, 
            enterNewTags: `Introduce nuevas etiquetas separándolas por comas`, 
            enterPasswordConfirmation: `Introducir la confirmación de la contraseña`, 
            enterTheCode: `Introduce el código`, 
            enterTheCodeReceivedBySms: `Introduce el código recibido por SMS`, 
            enterTheCompletePhone: `Dime el número de teléfono completo`, 
            enterTheDescriptionOfTheOrganization: `Introduzca la descripción de la organización`, 
            enterTheEmail: `Dime el correo`, 
            enterTheNameOfTheOrganization: `Introduzca el nombre de la organización`, 
            enterThePassword: `Introduce la contraseña`, 
            enterTheUsername: `Introducir nombre de usuario`, 
            enterTheScope: `¡Dime el alcance del programa!`, 
            enterUserName: `Introduzca el nombre del usuario`, 
            enterYourEmail: `Introduce tu correo electrónico`, 
            enterYourFullName: `Escribe tu nombre completo`, 
            enterYourPayPalAccountEmail: `Introduce el correo electrónico de la cuenta PayPal`, 
            enterYourPrimaryEmailAddress: `¡introduce tu correo electrónico principal!`, 
            enterYourUserPassword: `Introduce tu contraseña de usuario`, 
            enterYourRewardDetails: `¡introduce los detalles de la recompensa!`, 
            evaluate_retest: `Evaluar la repetición de la prueba`, 
            evaluatedRetest: `Repetición evaluada`, 
            executiveSummary: `Resumen ejecutivo de la organización`, 
            exit: `Dejando`, 
            expertSuccessfullCreated: `Specialist {0} creado correctamente`, 
            export: `Exportar`, 
            exportLogs: `Registros de exportación`, 
            exportInCsv: `Exportar a.csv`, 
            exportReports: `Informes de exportación`, 
            externalLinkNotice: `Aviso de enlace externo`, 
            extract: `Declaración`, 
            extractedBy: `Extraído por`, 
            fillInTheDetailsBelowTo: `Rellena los datos que aparecen a continuación para cambiar tu contraseña.`, 
            fillInAllFieldHighlightedInRed: `¡rellena todos los campos resaltados en rojo!`, 
            filterByTags: `Filtrar por etiquetas`, 
            findSecurityJobsOnOurDashboard: `BugHunt conecta a la comunidad con las mejores empresas.`, 
            forgotYourPassword: `¿Has olvidado tu contraseña?`, 
            forSecurityWeRequestYourPassword: `Por motivos de seguridad, le solicitamos su contraseña para esta operación.`, 
            forYourSecurityToPDF: `Para su seguridad, es necesario añadir una contraseña al PDF.`, 
            fullName: `Nombre completo`, 
            generateNewCodes: `Generar códigos nuevos`, 
            getAccessToExclusiveRewards: `¡obtén acceso a recompensas exclusivas de este programa!`, 
            gift: `Brindis`, 
            giftsAndAcknowledgments: `Regalos y agradecimientos`, 
            guests: `Huéspedes`, 
            hackerControl: `Control de piratas informáticos`, 
            haveYouRevised: `¿has revisado tu modelo? ¡Entonces eso es todo!`, 
            haveYouReviewedYourReportNow: `¿Ha revisado su informe? Así que eso es todo, ¡enviémoslo para su revisión!`, 
            here: `al presente`, 
            hereYouCanSetUpYourAccount: `Aquí puedes configurar tu cuenta para recibir tus recompensas.`, 
            high: `Ruidosamente`, 
            historic: `Historia`, 
            features: `Funcionalidades`, 
            iAlreadyHaveAnSccount: `¡Ya tengo una cuenta!`, 
            iAlreadyRemembered: `¡Ya me acordé!`, 
            iAgreeWithThe: `Estoy de acuerdo con la `, 
            ifYouDontReceiveIt: `Si no lo recibes, puedes volver a intentarlo en`, 
            ifYouNeedToSubmitMoreComment: `Si necesitas enviar más, simplemente escribe otro comentario`, 
            impact: `Impacto`, 
            impactDescriptionCannotContainSpecialCharacters: `¡la descripción del impacto no puede contener caracteres especiales!`, 
            inactivated: `inactivado`, 
            inactiveUsers: `Usuarios inactivos`, 
            initProgramMessage: `El programa comenzó hoy `, 
            informBugHuntPassword: `Introduzca la contraseña de la plataforma BugHunt para confirmar esta operación.`, 
            informThePhoneWithAreaCode: `Introduce el número de teléfono con el código de área`, 
            informTheRecommendations: `¡Dime las recomendaciones que recibirá el experto si tiene éxito!`, 
            informTheScope: `Introduzca el alcance`, 
            informTheScopeWhereTheThreatsAre: `Dime el alcance de las amenazas`, 
            selectTheScopeType: `Seleccione el tipo de endoscopio inspeccionado`, 
            informTheImpact: `Reporta el impacto`, 
            informTheUser: `Informar al usuario`, 
            informTheWebsite: `Háblame del sitio web`, 
            interationIdealTime: `El tiempo promedio ideal para {interationType} es `, 
            interviewWithExpertIgorRincon: `Entrevista con el especialista Igor Rincon`, 
            invalidBackupCodeOrToken: `Código o token de respaldo no válido`, 
            invalidCode: `Código inválido`, 
            invalidCodeOrToken: `Código o token no válido`, 
            invalidDate: `Fecha no válida`, 
            invalidData: `Datos inválidos`, 
            invalidRegistrationData: `Datos de registro no válidos {0}!`, 
            invalidEmailOrPassword: `¡correo electrónico o contraseña inválidos!`, 
            invalidPassword: `Contraseña inválida`, 
            invite: `Invitación`, 
            invitationAccepted: `Invitación aceptada`, 
            invitationDeclined: `Invitación rechazada`, 
            invitationLimitManagersReached: `Se ha alcanzado el límite de invitaciones para los gerentes.`, 
            invitationProgramLimitReached: `Se ha alcanzado el límite de invitaciones para el programa {program}.`, 
            invitationNotFoundOrExpired: `¡La invitación no se ha encontrado o ha caducado!`, 
            invitationsAccepted: `Invitación aceptada`, 
            invitationsReceived: `¡Invitaciones recibidas!`, 
            invitationRevoked: `Invitación revocada`, 
            invitationSent: `Invitación enviada`, 
            invoiceValue: `Factura total`, 
            NdaCreated: `NdA creado`, 
            inProgress: `En marcha`, 
            inRelationToTheReport: `En relación con el informe`, 
            inSomeCasesTheEmailMayFallAsSpam: `En algunos casos, el correo electrónico puede considerarse spam.`, 
            integration: `Integración`, 
            integrations: `Integraciones`, 
            integrationsNotAvailable: `¡integraciones no disponibles!`, 
            inTheProgram: `En el programa`, 
            internal: `Interno`, 
            invoices: `Facturación`, 
            iPAdress: `Dirección IP`, 
            issued: `Emitido`, 
            itHappensInTheBestFamilies: `¡Sucede en las mejores familias! No te preocupes, introduce tu correo electrónico y te enviaremos una nueva contraseña.`, 
            itHappensInTheBestFamiliesDonotworry: `¡Sucede en las mejores familias! No te preocupes.`, 
            itIsNotPossibleToEnterEqualRewards: `¡no es posible obtener recompensas iguales!`, 
            itIsNotPossibleToEnterMore: `¡no es posible introducir más de 30 etiquetas!`, 
            itIsNotPossibleToSubmitAnotherRetest: `¡No fue posible enviar la evaluación de nueva prueba! <br />Espere a que el especialista vuelva a realizar la prueba.`, 
            iWantToCreateAnAccount: `¡Quiero crear una cuenta!`, 
            jobBoard: `Panel de vacantes`, 
            jobDescription: `##### Acerca de la empresa\\nDescriba aquí los detalles sobre su**empresa**\\n\\n#### Acerca de la vacante\\nEstamos buscando un profesional cuyas principales responsabilidades serán:\\n- Responsabilidad 1. \\n- Responsabilidad 2. \\n- Responsabilidad 3. \\n\\n##### Requisitos\\n- **Requisito 1: App.vue assets components helpers HTTP.js main.js ml.js ml_old.js parsed_ml parsed_ml_en parsed_ml_es parsed_ml_old router services state translate.sh translated_ml.js utils.js view Más de x años de experiencia. \\n- **Requisito 2: App.vue assets components helpers HTTP.js main.js ml.js ml_old.js parsed_ml parsed_ml_en parsed_ml_es parsed_ml_old router services state translate.sh translated_ml.js utils.js view Más de x años de experiencia. \\n- **Requisito 3: App.vue assets components helpers HTTP.js main.js ml.js ml_old.js parsed_ml parsed_ml_en parsed_ml_es parsed_ml_old router services state translate.sh translated_ml.js utils.js view Más de x años de experiencia.`, 
            jobTitle: `Título de la vacante`, 
            joinedThePlatform: `Inició sesión en la plataforma`, 
            lastReviewSubmittedAgo: `Última opinión enviada hace {0}`, 
            lastInvitations: `Últimas invitaciones enviadas`, 
            last7daysOfAccess: `Últimos 7 días de acceso`, 
            latestReports: `Informes más recientes`, 
            letStartYourRegistrationAnd: `¡Comenzaremos su registro y pronto nos pondremos en contacto con usted para responder cualquier pregunta y finalizar su registro!`, 
            letsCompleteYourRegistration: `¡completemos tu registro!`, 
            letsCreateYourAccount: `¡vamos a crear tu cuenta!`, 
            letsCreateYourPreRegistration: `¡vamos a crear tu preinscripción!`, 
            lessThanMonthAgo: `Hace menos de un mes`, 
            like: `Del tipo`, 
            limitScope: `¡delimite el alcance y solo los accesos que serán recompensados!`, 
            limitOutOfScope: `¿qué aplicaciones no deberían probarse?`, 
            limitOfScopesPerProgramReached: `¡Se ha alcanzado el límite de {0} ámbitos por programa!`, 
            linkToJob: `Enlace a la vacante`, 
            location: `Local`, 
            longPeriodsImpactSpecialists: `Los largos períodos de espera pueden afectar la participación de los especialistas en este programa.`, 
            low: `Baja`, 
            makePayment: `Realizar un pago`, 
            makeAPayment: `Realizar un pago`, 
            makeSureYouHaveACompatibleAppLike: `Asegúrate de tener una aplicación compatible como `, 
            makeYourAccessEvenMoreSecure: `Haga que su acceso sea aún más seguro`, 
            manageAccess: `Administrar quién tiene acceso al programa.`, 
            managementInvitations: `Gestión de las invitaciones recibidas.`, 
            manageVPNforUsers: `Gestionar la VPN de los usuarios de cada programa`, 
            manageYourPlanInformation: `Administre la información de su plan.`, 
            manageYourProgressPlatform: `Gestiona tu progreso en la plataforma BugHunt`, 
            maximumLengthIsCharacters: `La longitud máxima es de {0} caracteres`, 
            maximumFilesPerComment: `El máximo es de 10 archivos por comentario`, 
            medianTimeToResolution: `Tiempo medio de resolución`, 
            medianTimeToFirstResponse: `Tiempo medio hasta la primera respuesta`, 
            medium: `Mediano`, 
            metricDoesNotHaveEnoughDataYet: `No hay datos suficientes para calcular esta métrica`, 
            metricsDoesNotHaveEnoughDataYet: `Aún no hay datos suficientes para calcular las métricas`, 
            message: `Mensaje`, 
            messagePostedAgo: `mensaje publicado hace {time}`, 
            messagePublishedDay: `Mensaje publicado el {day}`, 
            missedResponseTargetsReportsSent: `Respuestas enviadas en el tiempo previsto`, 
            missedResponseTargetsResolved: `Resolución de informes en el tiempo previsto`, 
            missedResponseTargetsBounty: `Pagos realizados durante el tiempo previsto`, 
            monthlyFee: `Cuota mensual`, 
            monthlyPayment: `Cuota mensual`, 
            moreOptions: `Más opciones`, 
            money: `Fondos`, 
            myPlan: `Mi plan`, 
            myBusiness: `Mi empresa`, 
            nameChanged: `¡nombre cambiado!`, 
            nameOfAccountHolder: `¡nombre de la persona responsable de la cuenta!`, 
            nameIsNotValid: `El nombre no es válido`, 
            navigation: `Navegación`, 
            needChangeDescription: `Usa la plantilla para hacer una descripción detallada.`, 
            ndaVerificationRequired: `¡Tu perfil es elegible para participar en el proceso de verificación!`, 
            ndaChange: `Cambio de NDA`, 
            next: `Cerca`, 
            new: `Recién descubierto`, 
            newComment: `Comentario nuevo`, 
            newUsers: `Nuevos usuarios`, 
            newPassword: `Contraseña nueva`, 
            newPasswordAndConfirmation: `¡la nueva contraseña y la confirmación no son lo mismo!`, 
            newReport: `Nuevo informe`, 
            none: `Ninguna`, 
            noActivePrograms: `No hay programa activo`, 
            noInvitationAvailable: `No hay invitación disponible`, 
            noNotificationsAvailable: `No hay ninguna notificación disponible`, 
            noPaymentsFound: `No se encontró ningún pago`, 
            noProgramAvailable: `No hay ningún programa disponible`, 
            noReportsFound: `No se encontró ningún informe`, 
            noScopeAvailable: `¡no hay osciloscopio disponible!`, 
            noSuggestionsAvailable: `No hay ninguna sugerencia disponible`, 
            noteValue: `Valor de la nota`, 
            notAvailableForThisPlan: `¡no disponible para este Plan!`, 
            notAuthorized: `¡no autorizado!`, 
            shutdownRequested: `¡Ya se ha solicitado el cierre de este informe!`, 
            replyNotificationTitle: `Solicitud de respuesta`, 
            closingRequestTitle: `Solicitud de cierre`, 
            replyRequestMessage: `¡Ya se ha solicitado una respuesta para este informe!`, 
            notificationResponseReport: `¡Atención! Se solicitó una respuesta para este informe.`, 
            shutdownNotificationMessage: `¡Atención! Se ha solicitado el cierre de este informe.`, 
            notificationSeeRequest: `Ver solicitud`, 
            requestSent: `Solicitud enviada correctamente!`, 
            reportResponseNotification: `¡Atención! Se solicitó una respuesta a este informe.`, 
            notEligible: `No elegible`, 
            noExpertsFound: `No se encontró ningún especialista`, 
            notificationUpdatedNDA: `¡Se ha actualizado el acuerdo de confidencialidad del programa {programName}! Para seguir participando en este programa, debes revisar y aceptar el NDA.`, 
            noUserAvailable: `No hay usuario disponible`, 
            noVpnAccessLogFound: `¡no se encontraron registros de acceso a la VPN!`, 
            nowTellUsLittle: `¡Ahora cuéntanos un poco sobre la política del programa!`, 
            nowTellUsALittleBitAboutTheThreat: `¡Ahora cuéntanos un poco sobre la amenaza!`, 
            ofReward: `De recompensa`, 
            oneDayAgo: `Hace un día`, 
            oldPassword: `Contraseña antigua`, 
            outstandingPayments: `Pagos pendientes`, 
            open: `Abierto`, 
            opssMatiDidntApproveYourData: `Vaya, Mati no aprobó tus datos.`, 
            other: `Otros`, 
            others: `Otros`, 
            otherTypes: `Otros tipos`, 
            outOfScope: `fuera del alcance`, 
            outOfScopeTitle: `Fuera de alcance`, 
            participating: `Participante`, 
            password: `Contraseña`, 
            passwordChanged: `¡Contraseña cambiada!`, 
            passwordConfirmation: `Confirmación de nueva contraseña`, 
            passwordsMustMatch: `Las contraseñas deben ser las mismas`, 
            pasteTheLinkIntoTheBodyOfTheDescription: `Pegue el enlace en el cuerpo de la descripción.`, 
            pause: `Pausa`, 
            paused: `Pausado`, 
            pauseProgram: `¿pausar el programa?`, 
            paymentFor: `Pago de`, 
            paymentHistory: `Historial de pagos`, 
            paymentSummary: `Resumen de pagos`, 
            paymentRequested: `Pago solicitado`, 
            pending: `Pendiente`, 
            pendingSubscription: `Suscripción pendiente`, 
            permission: `Permiso`, 
            permissions: `Permisos`, 
            pleaseMakeSureThatThisEmail: `Asegúrese de que este correo electrónico sea correcto y de que le pertenezca.`, 
            phoneNumber: `Número de teléfono`, 
            phoneSuccessfullyRemoved: `¡el teléfono se ha eliminado correctamente!`, 
            phoneValidation: `Validación telefónica`, 
            platform: `Plataforma`, 
            points: `Puntadas`, 
            pointsIn: `Puntos en`, 
            possibleDup: `Informe posiblemente duplica`, 
            possibleSpam: `Posible sp`, 
            postedComment: `publicó un comentario `, 
            postedImage: `Publicó una imagen`, 
            previous: `Previo`, 
            primaryEmail: `correo electrónico principal`, 
            primaryEmailReceiving: `Correo electrónico principal para recibir información`, 
            privacy: `Intimidad`, 
            privacyPolicy: `Política de privacidad`, 
            private: `Soldados`, 
            privateProgram: `programa privado`, 
            profileInformation: `Información de perfil`, 
            profileVerifiedReleased: `Verificación de perfil solicitada`, 
            program: `Programa`, 
            programs: `Horarios`, 
            programDetails: `Detalles del programa`, 
            program_management: `Gestión de programas`, 
            programLifeCycle: `Ciclo de vida del programa`, 
            programsLimitReached: `¡Se ha alcanzado el límite del programa {0}!`, 
            programsIhaveAlreadyContributed: `Programas a los que ya he contribuido`, 
            programPolicy: `Política del programa`, 
            programPolicyMustBeInformed: `La política del programa debe estar informada`, 
            programPolicyMustBeBetweenAndCharacters: `La política del programa debe tener entre {f} y {l} caracteres`, 
            programRanking: `Clasificación de programas`, 
            programNdaMustBeBetweenAndCharacters: `El contenido del NDA debe tener entre {f} y {l} caracteres`, 
            programsPublishedOnTheWeb: `Los especialistas no registrados en la plataforma pueden acceder a los programas publicados en la web.`, 
            programSuccessfullyChanged: `El programa se ha modificado correctamente`, 
            programType: `Tipo de programa`, 
            programWith: `Programa con {0}`, 
            proofOfConceptLinks: `Los vínculos a la prueba de concepto son generalmente benignos, pero a menudo pueden ir acompañados de consecuencias no deseadas.`, 
            setProgramNda: `¿Desea añadir el acuerdo de confidencialidad a su nuevo programa?`, 
            public: `Público`, 
            publicInformation: `Datos públicos`, 
            publicOrPrivateProgram: `Programa público o privado`, 
            publicProgram: `Programa público`, 
            publish: `Publicar`, 
            published: `Publicado`, 
            publishedDaysAgo: `Publicado hace {0}`, 
            publishProgramOnTheWeb: `¿publicar programa en la web?`, 
            publishToTheWeb: `Publicar en la web `, 
            questionsAboutUrl: `Preguntas sobre {0}`, 
            rankingDoesNotHaveEnoughDataYet: `El Ranking aún no tiene datos suficientes`, 
            rankingPosition: `{0}° en el Ranking`, 
            received: `Bienvenido`, 
            receiveAdvertising: `Reciba correos electrónicos publicitarios`, 
            receiveEmails: `Recibir correos electrónicos`, 
            receiveAdvertisingEmails: `Recibir correos electrónicos publicitarios`, 
            receiveNotificationsAboutNewReports: `Reciba notificaciones sobre nuevos informes directamente en sus plataformas de gestión`, 
            referenceDate: `Fecha de referencia`, 
            refuseRetest: `Rechazar una nueva prueba`, 
            refusedRetest: `Rechazó la nueva prueba`, 
            registerBelowTheTags: `Registre a continuación las etiquetas que se utilizarán para clasificar los informes.`, 
            registeredUsers: `Usuarios registrados`, 
            registeredVacancies: `Vacantes`, 
            registration: `Catastro`, 
            removeAccount: `Eliminar cuenta`, 
            remove: `Retirar`, 
            removeFromWhitelist: `Eliminar de la lista blanca`, 
            removeFromBlacklist: `Eliminar de la lista negra`, 
            removed: `Eliminado`, 
            reportAllPossibleThreatData: `Reportar todos los datos de posibles amenazas`, 
            report: `Reportaje`, 
            reportID: `ID del informe`, 
            reportCreatedSuccessfully: `El informe se creó correctamente`, 
            reportEvaluation: `Evaluación del informe`, 
            reportPayments: `Reportar pagos`, 
            reports: `Informes`, 
            reportSent: `Informe enviado`, 
            reportsSent: `Informes enviados`, 
            reportTitle: `Título del informe`, 
            reportedThatTheVulnerabilityIsFixed: `Informó que la vulnerabilidad está solucionada`, 
            reportedThatTheVulnerabilityIsNotPatched: `Informó que la vulnerabilidad no está solucionada`, 
            reportedVulnerabilities: `Vulnerabilidades reportadas`, 
            vulnerabilities: `Vulnerabilidades`, 
            overviewSubTitle: `Una vista gerencial de tu cuenta solo para ti`, 
            summaryCard: `Resumen de los informes`, 
            requestedPayment: `solicitó un pago`, 
            requestedPaymentOf: `solicitó el pago de`, 
            requestedANewTestOfTheReport: `solicitó una nueva prueba del informe`, 
            reset: `Limpiar`, 
            rewardValue: `Importe de la recompensa`, 
            whatIsAnNda: `¿Qué es un NDA?`, 
            whatIsAnNda2: `NdA es un acrónimo en inglés de Non-Disclosure-Agreements, o simplemente acuerdo de confidencialidad de la información.`, 
            whatIsAnNda3: `Tiene la intención de proteger los secretos industriales, los secretos comerciales o cualquier información que no pueda divulgarse y que deba mantenerse confidencial entre quienes tienen acceso a ella.`, 
            whatIsaVPNAndHow: `¿Qué es una VPN y cómo puede ayudarte con tus programas?`, 
            reportTags: `Etiquetas para el informe`, 
            requestNewPassword: `¡solicite una nueva contraseña!`, 
            requestRetest: `Solicitar una nueva prueba`, 
            requestSubscription: `Solicitar suscripción`, 
            requiredField: `Campo obligatorio`, 
            retestRequested: `Repetición de prueba solicitada`, 
            requestedRetestPayment: `Pago solicitado para la repetición de la prueba`, 
            retestId: `ID de nueva prueba`, 
            retestSent: `Se ha enviado una nueva prueba`, 
            return: `Regresar`, 
            resolved: `Resuelto`, 
            revoke: `Revocar`, 
            revokeWebAccessToTheProgram: `¿revocar el acceso web al programa?`, 
            revoked: `Revocado`, 
            revokeAccess: `Revocar el acceso`, 
            rewardAmount: `Importe de la recompensa`, 
            reward: `Recompensa`, 
            rewardDetails: `Detalles de la recompensa`, 
            rewards: `Recompensas`, 
            rewardsReceived: `Recompensas recibidas`, 
            rewardsWithFinancialValues: `Recompensas con valores financieros`, 
            save: `Ahorrando`, 
            saveEditions: `Guardar cambios`, 
            saveNda: `Guardar acuerdo de confidencialidad`, 
            saveInformation: `Ahorrando`, 
            scopePerProgram: `Alcance por programa`, 
            scopesPerProgram: `Ámbitos por programa`, 
            search: `Buscar`, 
            seconds: `segundos`, 
            select: `Seleccionar`, 
            selectAddAccount: `Selecciona «Añadir cuenta» o «+» y escanea el código QR de abajo`, 
            selectAScoreForTheReport: `Seleccione una puntuación para el informe`, 
            selectFile: `Selecciona el archivo!`, 
            selectProgram: `Seleccione un programa`, 
            selectLanguage: `Seleccione un idioma`, 
            selectScopeType: `Seleccione el tipo de alcance`, 
            selectTheThreat: `¡selecciona la amenaza!`, 
            selectTheProgramScope: `¡seleccione el alcance del programa!`, 
            selectTheProgramImpact: `¡seleccione el impacto del programa!`, 
            selectTheReport: `Seleccione el informe`, 
            selectTheScope: `Seleccione el alcance`, 
            selectTheCWE: `Seleccione el CWE`, 
            selectTheVulnerability: `Seleccione la vulnerabilidad`, 
            securityAnalyst: `Ex. Analista de seguridad`, 
            send: `Enviar`, 
            sentTheRetest: `¿Enviaste la nueva prueba?`, 
            sendMessage: `Enviar mensaje`, 
            sent: `Enviado por correo`, 
            sentTo: `Subido`, 
            sentTheReport: `Envié el informe`, 
            settings: `Ajustes`, 
            severityReports: `Informes de gravedad`, 
            severity: `Gravedad`, 
            currentValue: `Valor actual`, 
            finalValue: `Valor final`, 
            showingResultsOfTotal: `Mostrando {resultados} de {totalResults} resultados.`, 
            since: `Desde {0}`, 
            sinceLastMonth: `Desde el mes pasado`, 
            situation: `Situación`, 
            scope: `Alcance`, 
            scopeLimitExceeded: `Se ha superado el límite de alcance del programa.`, 
            scopeListOfTheProgram: `¡lista de alcances del programa!`, 
            score: `Anotando`, 
            scoreHistory: `Historial de goleadores`, 
            scopeType: `Tipo de alcance`, 
            share: `Compartir`, 
            smsCode: `Código SMS`, 
            smsCodeSent: `Código SMS enviado`, 
            specialist: `Versado`, 
            specialistNotFound: `¡No se encontró el especialista!`, 
            standard: `Estándar`, 
            standoutCreate: `¡destaque! Crea un título motivador.`, 
            start: `Comienzo`, 
            pauseMessage: `No fue posible ejecutar la acción porque la campaña aún no ha comenzado.`, 
            startAnAccountForOrganization: `Crear una cuenta para la organización`, 
            startWithRewards: `Comience con recompensas que tengan valor financiero`, 
            statistics: `Estadísticas`, 
            stateCity: `Estado`, 
            status: `Estado`, 
            statusChanged: `¡estado cambiado!`, 
            storeYourBackupCodes: `Almacena tus códigos de respaldo`, 
            subdomain: `Subdominio`, 
            submittedDays: `Enviado hace {0} días`, 
            submitComment: `Enviar comentario`, 
            submitForReview: `Enviar a Análisis`, 
            rewardNotice: `Recordator`, 
            submitReport: `Enviar informe`, 
            submit_retest: `Enviar una nueva prueba`, 
            successfullyGeneratedKeys: `¡claves generadas correctamente!`, 
            suggestions: `Sugerencias`, 
            suggestedReward: `Recompensa sugerida`, 
            summary: `Resumen`, 
            superSimpleItDoesntEvenTake: `Es sencillo, no lleva ni un minuto. Solo tienes que introducir los detalles a continuación y ¡listo! Se ha creado tu cuenta.`, 
            superSimpleItDoesntEvenTakeCompany: `Es sencillo, no lleva ni un minuto. Solo tienes que introducir los datos comunes de la organización y ¡listo! Tu cuenta se enviará para su revisión.`, 
            support: `Puntal`, 
            sureAddExpertBlacklist: `¿Está seguro de que desea añadir a este experto a la lista negra?`, 
            sureAddExpertWhiteList: `¿Está seguro de que desea añadir a este experto a la lista blanca?`, 
            sureRemoveExpertBlacklist: `¿Está seguro de que desea eliminar a este especialista de la lista negra?`, 
            sureRemoveExpertWhitelist: `¿Está seguro de que desea eliminar a este especialista de la lista blanca?`, 
            successfullyCreatedProgram: `El programa se creó correctamente`, 
            successfullyCreated: `creado satisfactoriamente`, 
            acceptedNda: `¡NdA ha sido aceptada satisfactoriamente!`, 
            openReports: `Informes abiertos`, 
            openYourApp: `Abre tu aplicación.`, 
            or: `o`, 
            organizationName: `Nombre de la organización`, 
            overallRanking: `Clasificación general`, 
            paidRetest: `Si <b>se aprueba la repetición de la prueba</b>, recibirás un <b>{0} adicional del importe</b> de la recompensa.`, 
            tagsAreUsedToHelpIdentifyReports: `Las etiquetas se utilizan para ayudar a identificar los informes.`, 
            tagsForReports: `Etiquetas para informes`, 
            takeAction: `Realizar acción`, 
            takeTheOpportunityToAcquireMoreComplete: `Aproveche la oportunidad de adquirir planes más completos para su empresa`, 
            talkDirectlyToOurOperators: `Hable directamente con nuestros operadores.`, 
            target: `Tiempo espera`, 
            telephone: `Teléfono`, 
            testDescriptionsMustBetweenCharacters: `La descripción de las pruebas debe tener entre {f} y {l} caracteres`, 
            tests: `Exámenes`, 
            terms: `Términos`, 
            termsAPolicy: `Términos y política`, 
            termsOfUse: `Términos de uso`, 
            thanksForRegistering: `¡gracias por registrarte!`, 
            thankByEmail: `Gracias por correo electrónico`, 
            theActionsTakenOnTheReportCannotBe: `Las acciones realizadas en el informe no se pueden eliminar`, 
            theCommentNeedsToBeInformed: `¡el comentario debe ser denunciado!`, 
            theDescriptionTestsMustBeInformed: `Debe proporcionarse la descripción de las pruebas`, 
            theDescriptionOfTheProgramMustBeInformed: `Se debe informar la descripción del programa`, 
            theImpactDescriptionMustBeInformed: `Se debe informar de la descripción del impacto`, 
            theImpactDescriptionMustBetweenCharacters: `La descripción del impacto debe tener entre {f} y {l} caracteres`, 
            theIsNotValid: `{0} no es válido`, 
            theFileIsNotValid: `¡el archivo no es válido!`, 
            theNameMustBeFromToCharacters: `El nombre debe tener entre {f} y {l} caracteres`, 
            theNameOfThePersonResponsibleIsMandatory: `El nombre de la persona responsable es obligatorio.`, 
            theNameOfTheProgramMustBInformed: `Debe ingresarse el nombre del programa`, 
            theNameWillBeAssignedToYourProgramsURL: `El nombre se asignará a la URL de su programa.`, 
            thenUseYourEmail: `Luego usa tu correo electrónico, tu contraseña y accede a nuestra plataforma. Si ha olvidado su contraseña o su nombre de usuario, ¡utilice la opción de recuperación que aparece a continuación!`, 
            thePhoneIsNotValid: `El teléfono no es válido.`, 
            theProgramDescriptionMustBeBetweenAndCharacters: `¡la descripción del programa debe tener entre {f} y {l} caracteres!`, 
            theProgramNameMustBeBetweenAndCharacters: `El nombre del programa debe tener entre {f} y {l} caracteres`, 
            thereIsAlreadyAprogram: `¡Ya hay un programa registrado con ese nombre!`, 
            thereIsAlreadyProgramSlug: `¡Ya hay un programa registrado con este slug!`, 
            theReportNeedsToBeInformed: `El informe debe denunciarse`, 
            theRetestMustBeSentWithinDays: `La nueva prueba debe enviarse en un plazo de {0} días`, 
            theRetestWasNotSubmitted: `¡No se presentó la nueva prueba!`, 
            theRetestHaAlreadyAccepted: `¡La nueva prueba ya ha sido aceptada!`, 
            theseSettingsDirectlyImpactTheAccessOfExperts: `Estas configuraciones afectan directamente al acceso de los expertos.`, 
            theScopeAddressMustBeInformed: `Debe introducirse la dirección del alcance`, 
            theThreatDescriptionMustBeInformed: `¡Se debe informar la descripción de la amenaza!`, 
            theThreatDescriptionMustBetweenCharacters: `La descripción de la amenaza debe tener entre {f} y {l} caracteres`, 
            theTitleMustBeInformed: `Se debe introducir el título`, 
            theTitleMustBeBetweenCharacters: `El título debe tener entre {f} y {l} caracteres`, 
            theWebhookIsNotValid: `¡el webhook no es válido!`, 
            theWebsiteMustBeFromToCharacters: `El sitio web debe tener entre {f} y {l} caracteres`, 
            thisChangeIsIrreversible: `Esta alteración es irreversible.`, 
            thisInformationCanAppear: `Esta información puede aparecer en el perfil público de la empresa, junto a sus comentarios y en cualquiera de sus informes.`, 
            thisIsAnInternalSurvey: `Esta es una encuesta interna, los especialistas no tendrán acceso a los datos de este cuestionario.`, 
            thisServiceCreatesAVPNResponsible: `Este servicio crea una VPN, responsable de conectar y monitorear el tráfico de datos de las pruebas del especialista para sus fines y, por lo tanto, de una mayor trazabilidad y seguridad.`, 
            thisWeek: `Esta semana`, 
            threats: `Amenazas`, 
            time: `Clima`, 
            timeToFirstResponse: `La primera respuesta`, 
            timeToBounty: `Paga la recompensa`, 
            timeToResolution: `Cerrar el informe`, 
            title: `Título`, 
            to: `hacia`, 
            toAcceptThisInvitation: `Para aceptar esta invitación es necesario comprobar el meta <b>mapa</b>, después de la verificación, esperar unos minutos y actualizar la página.`, 
            tokenIsInvalid: `El token no es válido o ya se ha utilizado`, 
            toAddMorePrograms: `Para añadir más programas, consulta nuestros planes haciendo clic`, 
            toAddMoreScopesToThe: `Para añadir más alcance al programa, consulta nuestros planes haciendo clic en`, 
            toAddMoreUsersCheck: `Para añadir más usuarios, consulta nuestros planes haciendo clic`, 
            toAddTheseIntegrations: `Para añadir estas integraciones, consulta nuestros planes haciendo clic en`, 
            toAddThisFeatureCheck: `Para añadir esta función, consulta nuestros planes haciendo clic en`, 
            toChangeYourPlanContactSupport: `Para cambiar tu plan, ponte en contacto con el servicio de asistencia.`, 
            toCheck: `verificar`, 
            toConfirmWeNeedYourPassword: `Para confirmarlo necesitamos tu contraseña`, 
            toConfirmYourRegistrationOn: `Para confirmar su registro en nuestra plataforma, debe hacer clic en el botón de abajo.`, 
            today: `Hoy`, 
            toDoThisYouNeedToEnterYourAppCode: `¡Para ello debes introducir el código de tu aplicación o pegar uno de tus tokens de respaldo!`, 
            topReportedCWE: `CWe más reportado`, 
            totalConnectedHours: `Horas totales de conexión`, 
            totalEvents: `Total de eventos`, 
            totalMonthlyFees: `Cuotas mensuales totales`, 
            totalReports: `Informes totales`, 
            totalReceived: `Total recibido`, 
            totalRewards: `Recompensas totales`, 
            toTheProgram: `Al programa`, 
            totalSpent: `Pago total`, 
            totalSum: `Suma total`, 
            trackYourOpenReports: `Siga sus informes abiertos`, 
            twoFactorAuthentication: `Autenticación de dos factores`, 
            type: `Tipo`, 
            typeOfContract: `Tipo de contrato`, 
            typeOrPasteOneOfYourBackupTokens: `Escribe o pega uno de tus tokens de respaldo, ¡recordando que cada token solo se puede usar una vez!`, 
            typeProgramLimitExceeded: `Se ha superado el límite para programas de tipo {ProgramType}`, 
            unableToCompleteThisRequest: `No hemos podido completar esta solicitud.`, 
            unableToSubmittedTheReport: `No fue posible presentar este informe. Asegúrese de que todos los campos se hayan rellenado correctamente.`, 
            undefinedRanking: `Clasificación indefinida`, 
            uninformed: `Desinformado`, 
            unshowPassword: `Ocultar contraseña`, 
            update: `Mejorar`, 
            updates: `Actualizaciones ({numberOfUpdates})`, 
            updated: `Actualizado`, 
            uploadFiles: `Enviar archivos`, 
            upTo: `Hasta`, 
            urlIsNotValid: `La URL no es válida`, 
            useBackupCode: `¿usar código de respaldo?`, 
            user: `Usuario`, 
            userBlockedForOverTrying: `Usuario bloqueado debido a intentos excesivos, inténtelo de nuevo más tarde.`, 
            userByCompany: `Usuario por empresa`, 
            userDisconnected: `Usuario desconectado!`, 
            userLimitReached: `¡Se ha alcanzado el límite de usuarios!`, 
            userLoggedIn: `Usuario conectado!`, 
            usersByCompany: `Usuarios por empresa`, 
            userDoesNotHavPermissionToPerform: `El usuario no puede realizar esta acción`, 
            usernameHasInvalidCharacters: `El nombre de usuario tiene caracteres no válidos`, 
            usernameIsNotAvailable: `¡el nombre de usuario no está disponible!`, 
            usernameMustBeFromCharacters: `El nombre de usuario debe tener entre {f} y {l} caracteres.`, 
            users: `Portadores`, 
            userEmail: `Usuario o correo electrónico`, 
            usersOnTheBlacklist: `¡Los usuarios de la lista negra no tendrán acceso a este programa!`, 
            userRemoved: `Usuario eliminado`, 
            useYourAuthenticationAppToEnterTheCode: `Usa tu aplicación de autenticación para introducir el código`, 
            validatePhone: `Validar teléfono`, 
            validatedPhone: `Teléfono validado`, 
            value: `Dignidad`, 
            verified: `Verificado`, 
            verifieds: `Verificado`, 
            vpnIP: `IPs de VPN`, 
            waitingConfirmation: `Esperando confirmación`, 
            wantSaveChangesProgram: `¿Realmente desea guardar los cambios realizados en este programa?`, 
            waysExplore: `Maneras de explorar`, 
            weLeaveThisPanel: `Dejamos este panel para que publiques tus vacantes a nuestros especialistas`, 
            whatIsBugBounty: `Qué es Bug Bounty`, 
            whatIsYourAction: `¿Cuál es tu acción?`, 
            whatIsNdaHeader: `¡estad atentos!`, 
            whatPrograms: `¿qué programas?`, 
            whatTypeOfVulnerability: `Qué tipo de vulnerabilidad se informó`, 
            whoDoYouWantInvite: `¿a quién quieres invitar?`, 
            whiteMessage: `Escribir un mensaje...`, 
            weakPasswordContain: `Contraseña débil! ¡Ella debe contar`, 
            websiteInvitation: `Invitación desde el sitio`, 
            weSendAToast: `Enviamos un brindis`, 
            weAreUnderMaintenance: `¡estamos en mantenimiento! ¡Vuelve pronto!`, 
            weTemporarilyStoreYourReport: `Almacenamos temporalmente los datos de su informe para el programa`, 
            weWillContactYouShortly: `Nos pondremos en contacto contigo en breve para confirmar tus datos.`, 
            wikiSubTitle: `Ayudamos en la forma en que podemos y en la que no.`, 
            withoutWebAccessTheProgram: `Sin acceso a la web, el programa estará disponible solo para los usuarios de la plataforma.`, 
            workModel: `Modelo de trabajo`, 
            workSchedule: `Horario de trabajo`, 
            yesIWantToRegister: `Sí, quiero registrarme`, 
            yes: `Sí`, 
            no: `No`, 
            youAcceptedThisInvitation: `¿Aceptaste esta invitación?`, 
            youAreAboutToVisitLink: `Estás a punto de visitar un enlace externo.`, 
            youAreAllowedToViewTheReports: `Se le permite ver los informes.`, 
            youCanUseOneOfTheseBackupCodes: `Puedes usar uno de estos códigos de respaldo para iniciar sesión si pierdes el acceso a tu smartphone. Recuerda que cada código solo se puede usar una vez.`, 
            yourCurrentPlanIsThe: `Tu plan actual es`, 
            youDoNotHaveAnyTagRegistered: `<a href=\"/account?tags\">no tienes ninguna etiqueta registrada, para añadirla ve al menú Mi cuenta/Etiquetas</a>`, 
            youDontHave: `No tienes`, 
            youDontHaveAnyAcceptedInvitations: `¡Aún no se aceptan invitaciones!`, 
            youDontHaveAnyInvitationsWaiting: `¡Aún no hay invitaciones esperando respuestas!`, 
            youDontHaveAnyNDAs: `¡todavía no tienes un programa con un acuerdo de confidencialidad!`, 
            youDontHaveAnyNDAsHacker: `¡aún no has aceptado ningún acuerdo de confidencialidad!`, 
            youDontHaveAnyProgramsInThisCategoryYet: `Aún no tienes programas en esta categoría`, 
            youDontHaveSubmittedReports: `¡todavía no hay informes aprobados!`, 
            youHave: `¿Tienes`, 
            youHaveBeenInvitedToSend: `Se le invitó a enviar informes a este programa`, 
            youHavePermissionToViewAndEditReports: `Tiene permiso para ver y editar los informes.`, 
            youMustAgreeToTheTermsOfUse: `Debe aceptar los términos de uso.`, 
            yourAccessPassword: `¡tu contraseña de acceso!`, 
            yourAccesEmail: `Tu correo electrónico de acceso a {0}`, 
            youReachedLimit: `¡Has alcanzado el límite diario para enviar informes!`, 
            yourEmail: `Tu correo electrónico`, 
            yourFullName: `¡tu nombre completo!`, 
            yourNameMustBeBetweenAndCharacters: `¡tu nombre debe tener entre {f} y {l} caracteres!`, 
            yourOrganizationNameIsRequired: `El nombre de tu organización es obligatorio`, 
            YourOrganizationTradeName: `¡nombre elegante de tu organización!`, 
            yourPassword: `Tu contraseña`, 
            yourPhoneToGetInTouch: `¡Llámanos para ponerte en contacto!`, 
            yourProfileIsNowAbleTo: `¡Tu perfil es elegible para participar en el proceso de verificación!`, 
            ndaVerificationRequired1: `Te invitaron a participar en el programa `, 
            ndaVerificationRequired2: `¡Es necesaria la verificación de tu perfil para aceptar esta invitación!`, 
            ndaVerificationRequired3: `Consulta tu lista de notificaciones y continúa con el proceso de verificación.`, 
            noJobsFound: `No se encontró ninguna vacante`, 
            registrationDone: `Registro hecho!`, 
            reportPaymentVerificationRequired1: `El pago de una recompensa por el informe `, 
            reportPaymentVerificationRequired2: `¡fue solicitado!`, 
            reportSummaryNotValid: `¡el resumen del informe no es válido!`, 
            reportContentIsNotValid: `¡el contenido del informe no es válido!`, 
            reportVulnerabilitIsNotValid: `¡el impacto de la vulnerabilidad no es válido!`, 
            reportCriticalityIsNotValid: `La gravedad de la vulnerabilidad no es válida`, 
            reportCantAcceptEspecialCaracter: `(No puede introducir caracteres especiales).`, 
            reportScopeIsNotValid: `¡el identificador del alcance del informe no es válido!`, 
            reportIdentifierIsNotValid: `¡el identificador del programa no es válido!`, 
            reportVulnerabilityIdentifierIsNotValid: `¡el identificador de vulnerabilidad no es válido!`, 
            ndaVerificationRequired6: `¡completa la validación de tu perfil para que podamos proceder al pago de la recompensa!`, 
            reportTitleIsNotValid: `¡el título del informe no es válido!`, 
            showPassword: `Mostrar contraseña`, 
            companyNdaVerificationRequired: `¡necesita crear un NDA para su programa antes de invitar a especialistas!`, 
            taxesNotIncluded: `Impuestos no incluidos`, 
            youAcceptedParticipateInThisProgram: `Ha aceptado participar en este programa.`, 
            youCanCalculate: `Puede calcular la gravedad con la siguiente calculadora.`, 
            youShouldConsiderUsingSeparate: `Debería considerar la posibilidad de utilizar un navegador o una máquina virtual distintos antes de continuar.`, 
            yourSecurityPlatformAndBugReward: `Tu plataforma Bug Bounty`, 
            youWereInvitedPartOf: `Te han invitado a unirte al equipo de {0}, solo tienes que introducir los detalles de tu cuenta.`, 
            youWillBeRedirectedIn: `Serás redirigido a`, 
            youWillReceiveReportsFromCommunity: `Recibirá informes de los expertos en seguridad de nuestra comunidad sin costo adicional, lo que minimizará los riesgos de que sus datos queden expuestos o exploten las vulnerabilidades.`, 
            invitationsSummary: `Resumen de las invitaciones`, 
            doubleReward: `Doble recompensa`, 
            boostedProgram: `Programa impulsado!`, 
            doubleCampaignNotificationStarted: `Se inició una doble campaña`, 
            doubleCampaignNotificationClosed: `Doble campaña cerrada`, 
            doubleCampaignNotificationPaused: `Campaña doblemente pausada`, 
            doubleCampaignNotificationResumed: `Se reanudó la doble campaña`, 
            campSubTitle: `¡gestiona tus campañas! Mantente al día de todos los detalles.`, 
            historicCampaign: `Historia`, 
            historicDoubleBounty: `Recompensa doble`, 
            historicDoubleScore: `Doble puntuación`, 
            inText: `De`, 
            until: `Hasta`, 
            finished: `Completado`, 
            in_progress: `Continuo`, 
            situationCancel: `Cancelado`, 
            createdTh: `Creado en`, 
            periodTh: `Plazos`, 
            rewardsTh: `Recompensas`, 
            situationsTh: `Situaciones`, 
            historicApproved: `Aprobado`, 
            historicCancel: `Cancelado`, 
            historicPaused: `En pausa`, 
            historicFinished: `Completado`, 
            notificationAttention: `¡Atención!`, 
            notificationYourCampaignHasStarted: `¡tu campaña ha empezado!`, 
            notificationThisCampaign: `Esta campaña`, 
            notificationHasClosed: `Estaba cerrado`, 
            notificationHasBeenPaused: `Estaba en pausa`, 
            keepAnEyeOutNotification: `Esté atento`, 
            notificationWillLetYouKnowWhenToStartAgain: `te avisaremos cuando vuelva a empezar.`, 
            notificationThisCampaignIsLiveAgain: `¡esta campaña vuelve a emitirse!`, 
            finalDate: `Fin`, 
            remain: `Restante`, 
            campaignStarted: `¡La campaña de recompensas dobles ha comenzado!`, 
            campaignClosed: `¡La campaña de recompensas dobles ha terminado!`, 
            campaignPause: `¡La campaña de recompensas dobles se ha pausado!`, 
            campaignReactivated: `¡Se ha reactivado la campaña de recompensas dobles!`, 
            campaignFinalDays: `Hacia el final de la campaña`, 
            campaignInitialDays: `Para el inicio de la campaña`, 
            dayCampaign: `día`, 
            daysCampaign: `días`, 
            btnRegister: `Registrar`, 
            btnCancel: `Cancelar`, 
            btnLabel: `Selecciona la fecha`, 
            doubleBounties: `Recompensas dobles`, 
            doubleScore: `Doble puntuación`, 
            activeDoubleCampaign: `Programa Boost`, 
            selectAPeriod: `Seleccione un perío`, 
            monthlyRanking: `Ranking mensual`, 
            generalRanking: `Clasificación general`, 
            expertRating: `Consulta el ranking de expertos de BugHunt`, 
            bountyOffer: `Usted está ofrecien`, 
            bountyScore: `Usted está ofrecien`, 
            bountyAndScoreOffer: `Estás ofrecien`, 
            closeCampaign: `Termina la campaña por partida doble`, 
            pauseCampaign: `Pausar la doble campaña`, 
            reactivateCampaign: `Reactivar la doble campaña`, 
            boostCampaign: `Programa Boost`, 
            doubleCheckCampaign: `Soy consciente de los cambios en el valor actual de las recompensas.`, 
            successfullyCreatedCampaign: `La solicitud se ha completado correctamente, ¡espere a que se revise la aprobación de la campaña!`, 
            vpnMessage: `No hay ninguna VPN habilitada en este programa.`, 
            campaignPaused: `¡La campaña se ha pausado correctamente!`, 
            doubleCampaignClosed: `¡campaña cerrada con éxito!`, 
            doubleCampaignResumed: `¡La campaña se reanudó con éxito!`, 
            registeredProgramWarning: `Este programa ya tiene una campaña aprobada o cerrada hace menos de 15 días.`, 
            warningBoutiesOrScore: `¡la campaña debe ofrecer recompensas o puntajes dobles!`, 
            invalidDateMessage: `Fecha no válida, ¡compruebe si el campo se ha rellenado correctamente!`, 
            v_administrator: `fideicomisario`, 
            v_viewer: `espectador`, 
            v_analyst: `Analista`, 
            administrator: `Fideicomisario`, 
            viewer: `Espectador`, 
            analyst: `Analista`, 
            v_private: `soldados`, 
            v_public: `Público`, 
            v_internal: `interno`, 
            v_new: `recién descubierto`, 
            v_under_review: `En revisión`, 
            v_triaged: `Triado`, 
            v_needs_information: `¿Necesitas información?`, 
            v_approved: `aprobado`, 
            v_informative: `informativo`, 
            v_duplicated: `duplicado`, 
            v_not_applicable: `no aplicable`, 
            v_spam: `correo no deseado`, 
            v_accepted: `Aceptado`, 
            v_pending: `Pendientes`, 
            v_declined: `Rechazado`, 
            v_revoked: `Revocado`, 
            v_pending_retest: `Vuelva a probar`, 
            v_retest_done: `Repetición de prueba completada`, 
            retest_done: `Repetición de prueba completada`, 
            pending_retest: `Reprobado pendiente`, 
            notImpact: `Gravedad no declarada`, 
            lowImpact: `Baja severidad`, 
            mediumImpact: `Severidad media`, 
            highImpact: `Gravedad alta`, 
            criticalImpact: `Gravedad crítica`, 
            approved: `Aprobado`, 
            informative: `Informativo`, 
            duplicated: `Duplicado`, 
            not_applicable: `No aplicable`, 
            spam: `Correo no deseado`, 
            comment: `Publicar un comentario`, 
            change_situation: `Cambiar situación`, 
            update_severity: `Cambiar la gravedad`, 
            request_update: `Solicitar actualización`, 
            retest: `Solicitar una nueva prueba`, 
            pay_bounty: `Paga una recompensa`, 
            close_report: `Cerrar el informe`, 
            reopen_report: `Vuelva a abrir el informe`, 
            needs_information: `Esperando información`, 
            under_review: `En revisión`, 
            triaged: `Triado`, 
            plan_trial: `Plan de prueba`, 
            plan_bronze: `Plano de bronce`, 
            plan_silver: `Plan Plata`, 
            plan_gold: `Plan dorado`, 
            trial: `Juicio`, 
            bronze: `Bronce`, 
            silver: `Plata`, 
            gold: `Oro`, 
            fulltime: `A tiempo completo`, 
            parttime: `A tiempo parcial`, 
            clt: `CLT`, 
            pj: `PJ`, 
            autonomous: `Individual`, 
            cltflex: `CLT-Flex`, 
            cooperative: `Cooperativa`, 
            internship: `Etapa`, 
            hybrid: `Híbrido`, 
            office: `Presencial`, 
            remote: `Remoto`, 
            web: `Aplicación web`, 
            api: `API`, 
            mobileapplication: `Aplicación móvil`, 
            mobileapplicationandroid: `Aplicación móvil Android`, 
            mobileapplicationios: `Aplicación móvil iOS`, 
            ip: `Dirección IP`, 
            january: `Enero`, 
            february: `Febrero`, 
            march: `Marzo`, 
            april: `Abril`, 
            may: `Mayo`, 
            june: `Junio`, 
            july: `Julio`, 
            august: `Agosto`, 
            september: `Septiembre`, 
            october: `Octubre`, 
            november: `Noviembre`, 
            december: `Diciembre`, 
            seeOriginalText: `Ver texto original.`, 
            waiting_for_information: `Esperando información`, 
            severity_updated: `Gravity actualizado`, 
            retest_requested: `Solicitud de restablecimiento`, 
            bounty_paid: `Recompensa pagada`, 
            close_as_approved: `Cerrar según lo aprobado`, 
            close_as_informative: `Cerrar como boletín`, 
            close_as_spam: `Cerrar como correo no deseado`, 
            close_as_duplicated: `Cerrar como duplicado`, 
            close_as_not_applicable: `Cerrar por no ser aplicable`, 
            select_option: `Seleccione una opción`, 
            deleteMessageAlert: `¿Estás seguro de que deseas eliminar este mensaje?`, 
            automaticMessage: `Al seleccionar la opción, la respuesta automática se registrará como primera interacción en el informe.`, 
            defaultMessageCenterMenu: `Centro de mensajería estándar`, 
            registerNotFound: `No se encontró ningún registro.`, 
            registeredMessageTitle: `Mensajes registrados`, 
            customSettingsTitle: `Ajustes personalizados`, 
            customSettingsSubtitle: `Configurar mensajes para respuestas estándar`, 
            addMessageButton: `Agregar mensaje`, 
            existingMessageAlert: `Es posible registrar solo un mensaje por tipo de mensaje. ¡Actualmente, todos los mensajes ya están registrados!`, 
            editMessage: `Editar mensaje`, 
            registerMessage: `Registrar mensaje`, 
            placeholderTitleMessage: `Título del mensaje`, 
            placeholderTextAreaMessage: `Añadir una descripción...`, 
            labelAutomatic: `Automática`, 
            alertMessageSuccess: `Mensaje registrado correctamente!`, 
            alertMessageUpdate: `¡el mensaje se actualizó correctamente!`, 
            swalTokenRemoved: `El token se eliminó correctamente.`, 
            deleteTokenCompany: `Eliminar token`, 
            placeholderTokenCompany: `Introducir un token`, 
            errorToken: `¡el token debe contener un mínimo de 20 caracteres y un máximo de 500 caracteres!`, 
            emailNotification: `¡la notificación por correo electrónico se activó correctamente!`, 
            enableEmailNotification: `Habilite la recepción de actualizaciones del programa a través de la dirección de correo electrónico.`, 
            emailNotificationDisabled: `¡La notificación enviada por correo electrónico ha sido desactivada!`, 
            china: `China`, 
            india: `India`, 
            estadosUnidos: `Estados Unidos`, 
            indonesia: `Indonesia`, 
            paquistao: `Pakistán`, 
            brasil: `Brasil`, 
            nigeria: `Nigeria`, 
            bangladesh: `Bangladesh`, 
            russia: `Rusia`, 
            mexico: `Mexico`, 
            japao: `Japón`, 
            etiopia: `Etiopía`, 
            filipinas: `Filipinas`, 
            egito: `Egipto`, 
            vietna: `Vietnam`, 
            repuplicaDemocraticaDoCongo: `República Democrática del Congo`, 
            turquia: `Turquía`, 
            ira: `Irán`, 
            alemanha: `Alemania`, 
            tailandia: `Tailandia`, 
            reinoUnido: `Reino Unido`, 
            franca: `Francia`, 
            italia: `Italia`, 
            tanzania: `Tanzania`, 
            africaDoSul: `Sudáfrica`, 
            mianmar: `Myanmar (Birmania)`, 
            coreiaDoSul: `Corea del Sur`, 
            colombia: `Colombia`, 
            quenia: `Kenia`, 
            espanha: `España`, 
            ucrania: `Ucrania`, 
            uganda: `Uganda`, 
            sudao: `Sudán`, 
            angertina: `Argentino`, 
            angelia: `Argelia`, 
            iraque: `Irak`, 
            polonia: `Polonia`, 
            canada: `Canadá`, 
            uzbequistao: `Uzbekistán`, 
            arabiaSaudita: `Arabia Saudí`, 
            br: `Portugués`, 
            en: `Inglés`, 
            es: `Espanol`, 
            fr: `Francés`, 
            it: `Italiano`, 
            ru: `Rusa`, 
            de: `Deutsch`, 
            jp: `Japonés`, 
            cn: `Chino`, 
            pl: `Polaco`, 
            ua: `Ucraniana`, 
            sd: `árabe`, 
            kr: `Coreano`, 
            in: `Hindi`, 
            id: `Indonesio`, 
            pk: `Urdu`, 
            bd: `Bengalí`, 
            et: `Amárico`, 
            ph: `Filipino (tagalo)`, 
            vn: `Vietnamita`, 
            tr: `Turca`, 
            ir: `Persa`, 
            th: `Tailandés`, 
            za: `Afrikáans`, 
            mm: `Birmano`, 
            ug: `Swahili`, 
            uz: `Uzbeko`, 
            sa: `árabe`, 
            additionalMoreLanguages: `Añadir más idioma`, 
            country: `Campo`, 
            language: `Lengua`, 
            clearText: `Usa el mensaje estándar`, 
            selectCountry: `Seleccione un país`, 
            basic: `Básica`, 
            proficiency: `Competencia`, 
            conversational: `Conversacional`, 
            fluent: `Fluido`, 
            native: `Nativo o bilingüe`, 
            AreYouSureYouWantToCompleteTheRequest: `¿Estás seguro de que quieres completar esta solicitud?`, 
            managers: `Gerentes`, 
            manageProgram: `Defina quién administrará su nuevo programa.`, 
            config: `Ajustes`, 
            programSettings: `Ajustes del programa`, 
            programEditAlert: `Atención! No es posible editar programas inactivos o en espera de aprobación.`, 
            changeSettings: `Cambiar la configuración`, 
            managersWithAccesToTheProgram: `Gerentes con acceso al programa`, 
            freeAccess: `Acceso publicado`, 
            pendingInviteAlert: `Atención! Ya hay una invitación pendiente asociada a esta dirección de correo electrónico.`, 
            USDT: `Dólar`, 
            BRL: `Real`, 
            selectCurrencyType: `Seleccione el tipo de moneda`, 
            passwordSuccess: `¡la contraseña se registró correctamente!`, 
            isNan: `El valor introducido debe ser numérico.`, 
            //translation_script_end_es
        }),

    ],
});
